import { jsx as e, jsxs as a, Fragment as ue } from "react/jsx-runtime";
import { useMemo as St, useState as y, useRef as K, useEffect as H, useCallback as D, Component as Xo } from "react";
import { createPortal as Zt } from "react-dom";
function Qo(t) {
  var n;
  return ((n = t.userType) == null ? void 0 : n.startsWith("client_")) ?? !1;
}
const _t = "https://app.theonestack.com", Zo = [
  // Core MSP Operations
  { id: "psa", name: "PSA", url: "https://app.theonestack.com/psa", icon: "briefcase", color: "#8b5cf6", launch_status: "ga" },
  { id: "crm", name: "CRM", url: "https://app.theonestack.com/crm", icon: "target", color: "#8b5cf6", launch_status: "ga" },
  { id: "books", name: "Books", url: "https://app.theonestack.com/books", icon: "book-open", color: "#10b981", launch_status: "ga" },
  { id: "voice", name: "Voice", url: "https://app.theonestack.com/voice", icon: "phone", color: "#06b6d4", launch_status: "ga" },
  { id: "projects", name: "Projects", url: "https://app.theonestack.com/projects", icon: "folder-kanban", color: "#8b5cf6", launch_status: "ga" },
  { id: "oncall", name: "On-Call", url: "https://app.theonestack.com/oncall", icon: "bell-ring", color: "#F43F5E", launch_status: "ga" },
  { id: "cmdb", name: "CMDB", url: "https://app.theonestack.com/cmdb", icon: "database", color: "#06B6D4", launch_status: "ga" },
  { id: "canvas", name: "Canvas", url: "https://app.theonestack.com/canvas", icon: "pen-tool", color: "#f59e0b", launch_status: "ga" },
  // Endpoint & Security
  { id: "connect", name: "Connect", url: "https://app.theonestack.com/connect", icon: "monitor-smartphone", color: "#3b82f6", launch_status: "ga" },
  { id: "rmm", name: "RMM", url: "https://app.theonestack.com/rmm", icon: "monitor", color: "#06b6d4", launch_status: "ga" },
  { id: "defend", name: "Defend", url: "https://app.theonestack.com/defend", icon: "shield-alert", color: "#E63946", launch_status: "ga" },
  { id: "security", name: "Security", url: "https://app.theonestack.com/security", icon: "shield-check", color: "#ef4444", launch_status: "ga" },
  { id: "backups", name: "Backups", url: "https://app.theonestack.com/backups", icon: "hard-drive", color: "#10b981", launch_status: "ga" },
  { id: "protect", name: "Protect", url: "https://app.theonestack.com/protect", icon: "shield", color: "#8b5cf6", launch_status: "ga" },
  { id: "compliance", name: "Compliance", url: "https://app.theonestack.com/compliance", icon: "shield", color: "#f59e0b", launch_status: "ga" },
  { id: "soc", name: "SOC", url: "https://app.theonestack.com/soc", icon: "shield-check", color: "#ef4444", launch_status: "ga" },
  // AI & Intelligence
  { id: "theo", name: "THEO", url: "https://app.theonestack.com/theo", icon: "bot", color: "#8b5cf6", launch_status: "ga" },
  { id: "ai", name: "THEO", url: "https://app.theonestack.com/theo", icon: "bot", color: "#818cf8", launch_status: "ga" },
  { id: "agents", name: "Agents", url: "https://app.theonestack.com/agents", icon: "bot", color: "#7c3aed", launch_status: "ga" },
  { id: "ai-studio", name: "AI Studio", url: "https://app.theonestack.com/studio", icon: "sparkles", color: "#6366f1", launch_status: "ga" },
  // People & Field
  { id: "people", name: "People", url: "https://app.theonestack.com/people", icon: "users", color: "#F59E0B", launch_status: "ga" },
  { id: "fleet", name: "Fleet", url: "https://app.theonestack.com/fleet", icon: "truck", color: "#10B981", launch_status: "ga" },
  { id: "visitor", name: "Visitor", url: "https://app.theonestack.com/visitor", icon: "door-open", color: "#0EA5E9", launch_status: "ga" },
  { id: "onsite", name: "Onsite", url: "https://app.theonestack.com/onsite", icon: "map-pin", color: "#f97316", launch_status: "ga" },
  { id: "legal", name: "Legal", url: "https://app.theonestack.com/legal", icon: "scale", color: "#2563eb", launch_status: "ga" },
  { id: "space", name: "Space", url: "https://app.theonestack.com/space", icon: "building-2", color: "#0d9488", launch_status: "ga" },
  // Infrastructure & Integration
  { id: "relay", name: "Relay", url: "https://app.theonestack.com/relay", icon: "mail", color: "#6366f1", launch_status: "ga" },
  { id: "bridge", name: "Bridge", url: "https://app.theonestack.com/bridge", icon: "arrow-left-right", color: "#64748b", launch_status: "ga" },
  { id: "status", name: "Status", url: "https://app.theonestack.com/status", icon: "activity", color: "#2dd4bf", launch_status: "ga" },
  { id: "code", name: "CodeProtect", url: "https://app.theonestack.com/code", icon: "shield-check", color: "#06b6d4", launch_status: "ga" },
  { id: "migrate", name: "Migrate", url: "https://app.theonestack.com/migrate", icon: "arrow-right-left", color: "#0891b2", launch_status: "ga" },
  { id: "esign", name: "eSign", url: "https://app.theonestack.com/esign", icon: "file-signature", color: "#10b981", launch_status: "ga" },
  // Content & Media
  { id: "podcast", name: "Podcast", url: "https://app.theonestack.com/podcast", icon: "mic", color: "#8b5cf6", launch_status: "ga" },
  // Community & Giveback
  // collective — REMOVED 2026-04-16: standalone at mspcollective.io; linked in Hub footer
  // mission — REMOVED 2026-04-15: standalone app at app.theonemission.app
  // Vertical SaaS
  // ams — REMOVED 2026-04-15: standalone app at app.theoneams.app
  // build — REMOVED 2026-04-16: standalone app at app.theonebuild.app; linked in Hub footer
  { id: "govwin", name: "GovWin", url: "https://app.theonestack.com/govwin", icon: "award", color: "#1d4ed8", launch_status: "ga" },
  // Streaming & Events
  { id: "livekit", name: "LiveKit", url: "https://app.theonestack.com/livekit", icon: "video", color: "#ec4899", launch_status: "ga" },
  { id: "gather", name: "Gather", url: "https://app.theonestack.com/gather", icon: "users-round", color: "#6366f1", launch_status: "ga" },
  // Hub & Platform
  { id: "hub", name: "Hub", url: "https://app.theonestack.com", icon: "layout-grid", color: "#8b5cf6", launch_status: "ga" },
  { id: "portal", name: "Portal", url: "https://app.theonestack.com/portal", icon: "globe", color: "#ec4899", launch_status: "ga" },
  { id: "ops-center", name: "Ops Center", url: "https://app.theonestack.com/ops", icon: "activity", color: "#818cf8", launch_status: "ga" },
  { id: "workflows", name: "Workflows", url: "https://app.theonestack.com/workflows", icon: "git-branch", color: "#10b981", launch_status: "ga" },
  { id: "clarity", name: "Clarity", url: "https://app.theonestack.com/clarity", icon: "bar-chart-2", color: "#6366f1", launch_status: "ga" },
  { id: "brand", name: "Brand", url: "https://app.theonestack.com/brand", icon: "palette", color: "#e11d48", launch_status: "ga" }
], On = {
  info: "#60a5fa",
  success: "#34d399",
  warning: "#fbbf24",
  error: "#f87171"
}, er = 48, tr = `
  .hb-root {
    all: initial;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #f1f5f9;
    box-sizing: border-box;
  }
  .hb-root *, .hb-root *::before, .hb-root *::after {
    box-sizing: inherit;
  }
  .hb-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 48px;
    /* Subtle vertical gradient + shadow give the bar depth against the
       page and separate it from the content without a harsh divider. */
    background: linear-gradient(180deg, #0b0b0e 0%, #09090b 100%);
    border-bottom: 1px solid rgba(255,255,255,0.05);
    box-shadow:
      0 1px 0 rgba(0,0,0,0.4),
      0 8px 24px -12px rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    padding: 0 12px;
    gap: 8px;
    z-index: 9999;
    -webkit-font-smoothing: antialiased;
  }
  .hb-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 8px;
    flex-shrink: 0;
    text-decoration: none;
    color: #f1f5f9;
  }
  .hb-logo-bird {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f97316;
  }
  .hb-logo-name {
    font-weight: 600;
    font-size: 14px;
    color: #f1f5f9;
    white-space: nowrap;
    letter-spacing: -0.01em;
  }
  /* Divider softens to a gradient so it reads as a hint rather than a
     hard pixel line; matches the shell's 'invisible until noticed' tone. */
  .hb-divider {
    width: 1px;
    height: 24px;
    background: linear-gradient(180deg, transparent, rgba(255,255,255,0.09), transparent);
    flex-shrink: 0;
  }

  /* Waffle Button */
  .hb-waffle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    flex-shrink: 0;
    padding: 0;
  }
  .hb-waffle-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-waffle-btn.open { background: rgba(255,255,255,0.06); }

  /* Waffle Grid Panel */
  .hb-waffle-panel {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 380px;
    max-height: 80vh;
    overflow-y: auto;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.6);
    z-index: 10000;
    padding: 16px;
    animation: hb-panel-slide 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  .hb-waffle-header {
    font-size: 13px;
    font-weight: 600;
    color: #8c8c8c;
    margin-bottom: 12px;
  }
  .hb-waffle-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
  }
  .hb-waffle-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 4px;
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    transition: background 0.12s;
  }
  .hb-waffle-tile:hover { background: rgba(255,255,255,0.04); }
  .hb-waffle-tile.inactive { opacity: 0.35; }
  .hb-waffle-tile-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  .hb-waffle-tile:hover .hb-waffle-tile-icon {
    transform: scale(1.08);
    box-shadow: 0 0 16px currentColor;
  }
  .hb-waffle-tile-icon.current {
    box-shadow: 0 0 0 2px currentColor;
    animation: hb-tile-pulse 2s ease-in-out infinite;
  }
  .hb-waffle-tile-name {
    font-size: 11px;
    font-weight: 500;
    color: #e8eaec;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 72px;
  }
  .hb-waffle-sep {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 12px 0;
    grid-column: 1 / -1;
  }
  .hb-waffle-section-label {
    font-size: 11px;
    font-weight: 600;
    color: #8c8c8c;
    margin-bottom: 8px;
    grid-column: 1 / -1;
  }
  .hb-waffle-explore {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #f97316;
    text-decoration: none;
    padding: 12px 0 4px;
    transition: opacity 0.15s;
  }
  .hb-waffle-explore:hover { opacity: 0.7; }

  /* Product Switcher (legacy text dropdown - now hidden, waffle replaces it) */
  .hb-switcher {
    position: relative;
    flex-shrink: 0;
  }
  .hb-switcher-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: transparent;
    border: none;
    border-radius: 6px;
    color: #f1f5f9;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;
  }
  .hb-switcher-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-chevron {
    width: 14px;
    height: 14px;
    opacity: 0.6;
    transition: transform 0.2s;
    flex-shrink: 0;
  }
  .hb-chevron.open { transform: rotate(180deg); }
  .hb-product-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* Chat button */
  .hb-chat-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }
  .hb-chat-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }

  /* Search */
  .hb-search-wrap {
    flex: 1;
    max-width: 480px;
    margin: 0 auto;
    position: relative;
  }
  .hb-search-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 7px 12px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    color: #64748b;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
  }
  .hb-search-trigger:hover {
    border-color: rgba(255,255,255,0.1);
    background: rgba(255,255,255,0.06);
  }
  .hb-search-trigger-text { flex: 1; text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .hb-kbd {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
  }
  .hb-kbd kbd {
    display: inline-block;
    padding: 1px 5px;
    background: rgba(255,255,255,0.06);
    border-radius: 4px;
    font-size: 11px;
    font-family: inherit;
    color: #94a3b8;
    border: 1px solid rgba(255,255,255,0.1);
  }

  /* Search Overlay */
  .hb-search-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    z-index: 10001;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    animation: hb-fade-in 0.1s ease;
  }
  .hb-search-modal {
    width: 600px;
    max-width: calc(100vw - 32px);
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px;
    box-shadow: 0 24px 64px rgba(0,0,0,0.7);
    overflow: hidden;
  }
  .hb-search-input-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .hb-search-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #f1f5f9;
    font-size: 16px;
    font-family: inherit;
    caret-color: #f97316;
  }
  .hb-search-input::placeholder { color: #475569; }
  .hb-search-results {
    max-height: 400px;
    overflow-y: auto;
    padding: 8px;
  }
  .hb-search-results:empty::after {
    content: 'No results';
    display: block;
    text-align: center;
    color: #475569;
    padding: 24px;
    font-size: 13px;
  }
  .hb-search-group-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #475569;
    padding: 8px 8px 4px;
  }
  .hb-search-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 7px;
    cursor: pointer;
    transition: background 0.1s;
    text-decoration: none;
    color: inherit;
  }
  .hb-search-item:hover, .hb-search-item.focused {
    background: rgba(255,255,255,0.04);
  }
  .hb-search-item-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255,255,255,0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 14px;
  }
  .hb-search-item-body { flex: 1; min-width: 0; }
  .hb-search-item-title {
    font-size: 14px;
    font-weight: 500;
    color: #f1f5f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-search-item-sub {
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-source-badge {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(255,255,255,0.04);
    color: #94a3b8;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .hb-search-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    color: #475569;
    font-size: 13px;
    gap: 8px;
  }
  .hb-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.06);
    border-top-color: #f97316;
    border-radius: 50%;
    animation: hb-spin 0.6s linear infinite;
  }
  .hb-search-empty {
    text-align: center;
    padding: 32px 16px;
    color: #475569;
    font-size: 13px;
  }
  .hb-search-empty-hint {
    font-size: 12px;
    color: #334155;
    margin-top: 4px;
  }

  /* Notifications */
  .hb-notif {
    position: relative;
    flex-shrink: 0;
  }
  .hb-notif-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    position: relative;
  }
  .hb-notif-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    min-width: 16px;
    height: 16px;
    background: #ef4444;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
    pointer-events: none;
  }
  .hb-notif-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 360px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    z-index: 10000;
    animation: hb-fade-in 0.12s ease;
    overflow: hidden;
  }
  .hb-notif-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .hb-notif-title {
    font-size: 13px;
    font-weight: 600;
    color: #f1f5f9;
  }
  .hb-notif-mark-read {
    font-size: 12px;
    color: #f97316;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: opacity 0.15s;
  }
  .hb-notif-mark-read:hover { opacity: 0.7; }
  .hb-notif-list {
    max-height: 360px;
    overflow-y: auto;
  }
  .hb-notif-item {
    display: flex;
    align-items: flex-start;
    gap: 0;
    padding: 0;
    position: relative;
    border-bottom: 1px solid rgba(255,255,255,0.03);
    transition: background 0.1s;
  }
  .hb-notif-item:hover { background: rgba(255,255,255,0.04); }
  .hb-notif-item.unread { background: rgba(249,115,22,0.04); }
  .hb-notif-item.unread:hover { background: rgba(249,115,22,0.07); }
  .hb-notif-item-link {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 11px 14px;
    padding-right: 32px;
    flex: 1;
    min-width: 0;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }
  .hb-notif-icon {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 6px;
  }
  .hb-notif-body { flex: 1; min-width: 0; }
  .hb-notif-body-title {
    font-size: 13px;
    font-weight: 500;
    color: #e2e8f0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .hb-notif-body-text {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-notif-group-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    background: rgba(249,115,22,0.15);
    color: #fb923c;
    font-size: 10px;
    font-weight: 700;
    padding: 0 4px;
    flex-shrink: 0;
  }
  .hb-notif-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
  }
  .hb-notif-time {
    font-size: 11px;
    color: #475569;
  }
  .hb-notif-dismiss {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 4px;
    color: #475569;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s, background 0.15s, color 0.15s;
  }
  .hb-notif-item:hover .hb-notif-dismiss { opacity: 1; }
  .hb-notif-dismiss:hover { background: rgba(255,255,255,0.06); color: #94a3b8; }
  .hb-notif-empty {
    text-align: center;
    padding: 32px 16px;
    color: #475569;
    font-size: 13px;
  }
  .hb-notif-footer {
    padding: 8px 14px;
    border-top: 1px solid rgba(255,255,255,0.06);
  }
  .hb-notif-footer-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .hb-notif-mute-group {
    display: flex;
    gap: 6px;
  }
  .hb-notif-mute-btn {
    font-size: 11px;
    color: #64748b;
    background: none;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 4px;
    padding: 3px 8px;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s;
    font-family: inherit;
  }
  .hb-notif-mute-btn:hover { color: #94a3b8; border-color: rgba(255,255,255,0.12); }
  .hb-notif-settings-link {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #64748b;
    text-decoration: none;
    transition: color 0.15s;
  }
  .hb-notif-settings-link:hover { color: #94a3b8; }

  /* Toast Notifications */
  .hb-toast-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    z-index: 10002;
    pointer-events: none;
  }
  .hb-toast {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.08);
    border-left: 3px solid #60a5fa;
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    min-width: 320px;
    max-width: 420px;
    animation: hb-toast-enter 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
    pointer-events: auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: #e2e8f0;
  }
  .hb-toast-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 4px;
  }
  .hb-toast-body {
    flex: 1;
    min-width: 0;
  }
  .hb-toast-title {
    font-size: 13px;
    font-weight: 600;
    color: #f1f5f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-toast-text {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-toast-link {
    display: inline-block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #f97316;
    text-decoration: none;
    transition: opacity 0.15s;
  }
  .hb-toast-link:hover { opacity: 0.7; }
  .hb-toast-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    border-radius: 4px;
    color: #475569;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
  }
  .hb-toast-close:hover { background: rgba(255,255,255,0.06); color: #94a3b8; }
  @keyframes hb-toast-enter {
    from { opacity: 0; transform: translateY(12px) scale(0.95); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @media (max-width: 480px) {
    .hb-toast-container { left: 8px; right: 8px; }
    .hb-toast { min-width: 0; max-width: 100%; }
  }

  /* Org name chip — shown in bar to left of user menu */
  .hb-org-chip {
    display: flex;
    align-items: center;
    padding: 3px 10px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(241,245,249,0.6);
    cursor: pointer;
    white-space: nowrap;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
  }
  .hb-org-chip:hover {
    background: rgba(255,255,255,0.09);
    color: rgba(241,245,249,0.9);
  }

  /* User Menu */
  .hb-user {
    position: relative;
    flex-shrink: 0;
  }
  .hb-user-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 4px 8px 4px 4px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #f1f5f9;
    cursor: pointer;
    transition: background 0.15s;
  }
  .hb-user-btn:hover { background: rgba(255,255,255,0.04); }
  .hb-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }
  .hb-user-name {
    font-size: 13px;
    font-weight: 500;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hb-user-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 220px;
    background: #09090b;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 10px;
    padding: 6px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    z-index: 10000;
    animation: hb-fade-in 0.12s ease;
  }
  .hb-user-info {
    padding: 8px 10px 10px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    margin-bottom: 4px;
  }
  .hb-user-email {
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hb-user-tenant {
    font-size: 11px;
    color: #475569;
    margin-top: 2px;
  }
  .hb-menu-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 10px;
    border-radius: 6px;
    color: #94a3b8;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.12s, color 0.12s;
    text-decoration: none;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: inherit;
  }
  .hb-menu-item:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-menu-item.danger { color: #f87171; }
  .hb-menu-item.danger:hover { background: #2d1515; color: #fca5a5; }
  .hb-menu-sep {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 4px 0;
  }
  .hb-add-product {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 8px;
    border-radius: 6px;
    color: #f97316;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s;
    text-decoration: none;
  }
  .hb-add-product:hover { background: rgba(255,255,255,0.04); }

  /* Reduce motion */
  @media (prefers-reduced-motion: reduce) {
    .hb-waffle-tile,
    .hb-waffle-panel,
    .hb-notif-dropdown,
    .hb-user-dropdown,
    .hb-sp-panel,
    .hb-jv-panel {
      animation: none !important;
      opacity: 1 !important;
    }
    .hb-waffle-tile-icon { transition: none !important; }
    .hb-waffle-tile-icon.current { animation: none !important; }
  }

  /* Responsive */
  @media (max-width: 900px) {
    .hb-kbd { display: none; }
  }
  @media (max-width: 640px) {
    .hb-search-wrap { display: none; }
    .hb-logo-name { display: none; }
    .hb-user-name { display: none; }
    .hb-org-chip { display: none; }
    .hb-waffle-panel { width: 100vw; border-radius: 0; }
  }

  /* Animations */
  /* Tile stagger animation */
  .hb-waffle-tile {
    opacity: 0;
    animation: hb-tile-enter 0.2s ease forwards;
  }
  .hb-waffle-tile:nth-child(1) { animation-delay: 0ms; }
  .hb-waffle-tile:nth-child(2) { animation-delay: 30ms; }
  .hb-waffle-tile:nth-child(3) { animation-delay: 60ms; }
  .hb-waffle-tile:nth-child(4) { animation-delay: 90ms; }
  .hb-waffle-tile:nth-child(5) { animation-delay: 120ms; }
  .hb-waffle-tile:nth-child(6) { animation-delay: 150ms; }
  .hb-waffle-tile:nth-child(7) { animation-delay: 180ms; }
  .hb-waffle-tile:nth-child(8) { animation-delay: 210ms; }
  .hb-waffle-tile:nth-child(9) { animation-delay: 240ms; }
  .hb-waffle-tile:nth-child(10) { animation-delay: 270ms; }
  .hb-waffle-tile:nth-child(11) { animation-delay: 300ms; }
  .hb-waffle-tile:nth-child(12) { animation-delay: 330ms; }
  .hb-waffle-tile:nth-child(n+13) { animation-delay: 360ms; }

  @keyframes hb-tile-enter {
    from { opacity: 0; transform: scale(0.9); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes hb-tile-pulse {
    0%, 100% { box-shadow: 0 0 0 2px currentColor; }
    50% { box-shadow: 0 0 12px currentColor, 0 0 0 2px currentColor; }
  }
  @keyframes hb-panel-slide {
    from { opacity: 0; transform: translateY(-8px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes hb-fade-in {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes hb-spin {
    to { transform: rotate(360deg); }
  }
  @keyframes hb-sp-slide-in {
    from { transform: translateX(100%); opacity: 0; }
    to   { transform: translateX(0); opacity: 1; }
  }

  /* ── Support Panel ─────────────────────────────────────────────────── */

  /* Overlay */
  .hb-sp-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 10010;
    animation: hb-fade-in 0.15s ease;
  }

  /* Panel */
  .hb-sp-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 420px;
    max-width: 100vw;
    background: #0f0f11;
    border-left: 1px solid rgba(255,255,255,0.07);
    box-shadow: -16px 0 48px rgba(0,0,0,0.6);
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #e2e8f0;
    -webkit-font-smoothing: antialiased;
    z-index: 10011;
    animation: hb-sp-slide-in 0.2s ease;
  }
  .hb-sp-panel *, .hb-sp-panel *::before, .hb-sp-panel *::after {
    box-sizing: border-box;
  }

  /* Header */
  .hb-sp-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
    height: 52px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .hb-sp-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #f1f5f9;
    flex: 1;
  }
  .hb-sp-back-btn {
    background: none;
    border: none;
    color: #f97316;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px 4px 0;
    font-family: inherit;
    flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .hb-sp-back-btn:hover { opacity: 0.7; }
  .hb-sp-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
    margin-left: auto;
  }
  .hb-sp-close-btn:hover { background: rgba(255,255,255,0.06); color: #f1f5f9; }

  /* Scrollable content area */
  .hb-sp-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .hb-sp-content::-webkit-scrollbar { width: 4px; }
  .hb-sp-content::-webkit-scrollbar-track { background: transparent; }
  .hb-sp-content::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

  /* Hub page */
  .hb-sp-hub { padding: 20px 16px; }
  .hb-sp-hub-header { margin-bottom: 20px; }
  .hb-sp-hub-title {
    font-size: 20px;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 4px;
  }
  .hb-sp-hub-sub { font-size: 13px; color: #64748b; }
  .hb-sp-hub-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
  }
  .hb-sp-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    padding: 14px 16px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s, border-color 0.15s;
    font-family: inherit;
    width: 100%;
  }
  .hb-sp-card:hover { background: rgba(249,115,22,0.06); border-color: rgba(249,115,22,0.25); }
  .hb-sp-card-label { font-size: 14px; font-weight: 600; color: #f1f5f9; }
  .hb-sp-card-desc { font-size: 12px; color: #64748b; }
  .hb-sp-hub-links { display: flex; flex-direction: column; }
  .hb-sp-link-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 4px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    color: #94a3b8;
    font-size: 13px;
    font-weight: 500;
    font-family: inherit;
    text-align: left;
    width: 100%;
    transition: color 0.15s;
  }
  .hb-sp-link-item:last-child { border-bottom: none; }
  .hb-sp-link-item:hover { color: #f1f5f9; }
  .hb-sp-chevron { font-size: 18px; color: #475569; }
  .hb-sp-section-label {
    font-size: 11px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.05em; color: #475569; padding: 4px 0 6px;
  }

  /* Forms */
  .hb-sp-form-page { padding: 16px; display: flex; flex-direction: column; gap: 14px; }
  .hb-sp-field { display: flex; flex-direction: column; gap: 6px; }
  .hb-sp-label { font-size: 12px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.04em; }
  .hb-sp-input {
    width: 100%;
    padding: 8px 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #f1f5f9;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s;
  }
  .hb-sp-input:focus { border-color: #f97316; }
  .hb-sp-input::placeholder { color: #475569; }
  .hb-sp-textarea {
    width: 100%;
    padding: 8px 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #f1f5f9;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    resize: vertical;
    min-height: 80px;
    transition: border-color 0.15s;
  }
  .hb-sp-textarea:focus { border-color: #f97316; }
  .hb-sp-textarea::placeholder { color: #475569; }
  .hb-sp-char-count { font-size: 11px; color: #475569; text-align: right; }
  .hb-sp-type-row { display: flex; gap: 6px; flex-wrap: wrap; }
  .hb-sp-type-btn {
    padding: 5px 12px;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-type-btn:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-type-btn.active { background: #f97316; border-color: #f97316; color: #fff; }
  .hb-sp-chip-row { display: flex; gap: 6px; flex-wrap: wrap; }
  .hb-sp-chip {
    padding: 4px 10px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-chip:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-chip.active { background: rgba(249,115,22,0.15); border-color: #f97316; color: #fb923c; }
  .hb-sp-error { font-size: 13px; color: #f87171; padding: 8px 12px; background: rgba(239,68,68,0.08); border-radius: 8px; border: 1px solid rgba(239,68,68,0.2); }

  /* Buttons */
  .hb-sp-btn {
    padding: 9px 18px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: opacity 0.15s, background 0.15s;
    width: 100%;
  }
  .hb-sp-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .hb-sp-btn-primary { background: #f97316; color: #fff; }
  .hb-sp-btn-primary:hover:not(:disabled) { background: #ea6c0c; }
  .hb-sp-btn-secondary { background: rgba(255,255,255,0.06); color: #f1f5f9; }
  .hb-sp-btn-secondary:hover:not(:disabled) { background: rgba(255,255,255,0.09); }
  .hb-sp-btn-ghost { background: none; color: #64748b; }
  .hb-sp-btn-ghost:hover:not(:disabled) { color: #94a3b8; }

  /* Success state */
  .hb-sp-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 40px 24px;
    text-align: center;
  }
  .hb-sp-success-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(34,197,94,0.12);
    border: 2px solid #22c55e;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #22c55e;
  }
  .hb-sp-success-title { font-size: 18px; font-weight: 700; color: #f1f5f9; }
  .hb-sp-success-num { font-size: 13px; color: #64748b; }
  .hb-sp-success-actions { display: flex; flex-direction: column; gap: 8px; width: 100%; margin-top: 8px; }

  /* List pages */
  .hb-sp-list-page { padding: 12px 0; }
  .hb-sp-filter-row { display: flex; gap: 6px; padding: 4px 16px 12px; flex-wrap: wrap; }
  .hb-sp-filter-btn {
    padding: 4px 12px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
  }
  .hb-sp-filter-btn:hover { border-color: rgba(255,255,255,0.2); color: #f1f5f9; }
  .hb-sp-filter-btn.active { background: rgba(249,115,22,0.12); border-color: #f97316; color: #fb923c; }
  .hb-sp-filter-btn-new { color: #f97316; border-color: rgba(249,115,22,0.3); margin-left: auto; }
  .hb-sp-filter-btn-new:hover { background: rgba(249,115,22,0.08); }
  .hb-sp-list { display: flex; flex-direction: column; }
  .hb-sp-list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 13px 16px;
    cursor: pointer;
    background: none;
    border: none;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    text-align: left;
    font-family: inherit;
    transition: background 0.1s;
    width: 100%;
  }
  .hb-sp-list-item:hover { background: rgba(255,255,255,0.03); }

  /* Ticket list */
  .hb-sp-ticket-top { display: flex; align-items: center; justify-content: space-between; }
  .hb-sp-ticket-num { font-size: 11px; font-weight: 700; color: #64748b; font-family: monospace; }
  .hb-sp-ticket-title { font-size: 14px; color: #e2e8f0; font-weight: 500; }
  .hb-sp-ticket-meta { font-size: 11px; color: #475569; }
  .hb-sp-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    background: rgba(255,255,255,0.06);
    color: #94a3b8;
  }

  /* Ticket detail */
  .hb-sp-detail-page { padding: 16px; display: flex; flex-direction: column; gap: 12px; }
  .hb-sp-detail-header { display: flex; align-items: center; gap: 8px; }
  .hb-sp-detail-title { font-size: 17px; font-weight: 700; color: #f1f5f9; }
  .hb-sp-detail-desc { font-size: 13px; color: #94a3b8; white-space: pre-wrap; }
  .hb-sp-activity { display: flex; flex-direction: column; gap: 0; }
  .hb-sp-activity-title { font-size: 12px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px; }
  .hb-sp-activity-item {
    padding: 10px 0;
    border-top: 1px solid rgba(255,255,255,0.05);
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .hb-sp-activity-actor { font-size: 12px; font-weight: 600; color: #94a3b8; }
  .hb-sp-activity-content { font-size: 13px; color: #e2e8f0; white-space: pre-wrap; }
  .hb-sp-activity-time { font-size: 11px; color: #475569; }
  .hb-sp-reply { display: flex; flex-direction: column; gap: 8px; padding-top: 8px; border-top: 1px solid rgba(255,255,255,0.07); }

  /* Changelog */
  .hb-sp-release { padding: 16px; border-bottom: 1px solid rgba(255,255,255,0.05); }
  .hb-sp-release-header { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
  .hb-sp-release-ver { font-size: 12px; font-weight: 700; color: #f97316; font-family: monospace; }
  .hb-sp-release-date { font-size: 11px; color: #475569; }
  .hb-sp-release-title { font-size: 15px; font-weight: 600; color: #f1f5f9; margin-bottom: 6px; }
  .hb-sp-release-notes { font-size: 13px; color: #94a3b8; white-space: pre-wrap; }

  /* Features */
  .hb-sp-feature-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
  }
  .hb-sp-feature-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
  .hb-sp-feature-title { font-size: 14px; font-weight: 600; color: #e2e8f0; }
  .hb-sp-feature-desc { font-size: 12px; color: #64748b; }
  .hb-sp-vote-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
    flex-shrink: 0;
  }
  .hb-sp-vote-btn:hover { border-color: #f97316; color: #f97316; }
  .hb-sp-vote-btn.voted { background: rgba(249,115,22,0.1); border-color: #f97316; color: #fb923c; }
  .hb-sp-vote-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  /* KB */
  .hb-sp-search-row { padding: 12px 16px 8px; }
  .hb-sp-kb-cats { display: flex; flex-direction: column; }
  .hb-sp-kb-cat {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 16px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    color: #e2e8f0;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    text-align: left;
    width: 100%;
    transition: background 0.1s;
  }
  .hb-sp-kb-cat:hover { background: rgba(255,255,255,0.03); }
  .hb-sp-kb-cat-count {
    font-size: 12px;
    color: #475569;
    background: rgba(255,255,255,0.04);
    padding: 2px 8px;
    border-radius: 12px;
  }

  /* KB article content */
  .hb-sp-article-content { font-size: 14px; color: #cbd5e1; line-height: 1.7; }
  .hb-sp-article-content h1,
  .hb-sp-article-content h2,
  .hb-sp-article-content h3 { color: #f1f5f9; margin: 16px 0 8px; font-weight: 600; }
  .hb-sp-article-content h1 { font-size: 20px; }
  .hb-sp-article-content h2 { font-size: 17px; }
  .hb-sp-article-content h3 { font-size: 15px; }
  .hb-sp-article-content p { margin: 0 0 12px; }
  .hb-sp-article-content ul,
  .hb-sp-article-content ol { padding-left: 20px; margin: 0 0 12px; }
  .hb-sp-article-content li { margin-bottom: 4px; }
  .hb-sp-article-content code {
    background: rgba(255,255,255,0.06);
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
  }
  .hb-sp-article-content pre {
    background: rgba(0,0,0,0.4);
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 0 0 12px;
    font-size: 12px;
  }
  .hb-sp-article-content a { color: #f97316; text-decoration: none; }
  .hb-sp-article-content a:hover { text-decoration: underline; }
  .hb-sp-article-content blockquote {
    border-left: 3px solid rgba(249,115,22,0.4);
    margin: 0 0 12px;
    padding: 8px 12px;
    color: #94a3b8;
  }

  /* Loading / empty / skeleton */
  .hb-sp-loading { padding: 32px 16px; text-align: center; font-size: 13px; color: #475569; }
  .hb-sp-empty { padding: 40px 16px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
  .hb-sp-empty-text { font-size: 14px; color: #475569; text-align: center; }
  .hb-sp-skeleton {
    height: 68px;
    background: linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.03) 75%);
    background-size: 200% 100%;
    animation: hb-sp-shimmer 1.4s infinite;
    border-radius: 8px;
    margin: 6px 16px;
  }
  @keyframes hb-sp-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* Responsive */
  @media (max-width: 480px) {
    .hb-sp-panel { width: 100vw; }
  }

  /* ── Jarvis AI Assistant ────────────────────────────────────────────────── */

  /* Trigger button */
  .hb-jv-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    position: relative;
  }
  .hb-jv-btn:hover { background: rgba(255,255,255,0.04); color: #f97316; }
  .hb-jv-btn.active { color: #f97316; background: rgba(249,115,22,0.08); }
  .hb-jv-btn.pulse::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 4px;
    width: 8px;
    height: 8px;
    background: #f97316;
    border-radius: 50%;
    animation: hb-jv-pulse 2s ease-in-out infinite;
  }
  @keyframes hb-jv-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.3); }
  }

  /* Overlay */
  .hb-jv-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 10010;
    animation: hb-fade-in 0.15s ease;
  }

  /* Panel */
  .hb-jv-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 400px;
    max-width: 100vw;
    background: #0f0f11;
    border-left: 1px solid rgba(255,255,255,0.07);
    box-shadow: -16px 0 48px rgba(0,0,0,0.6);
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #e2e8f0;
    -webkit-font-smoothing: antialiased;
    z-index: 10011;
    animation: hb-sp-slide-in 0.2s ease;
  }
  .hb-jv-panel *, .hb-jv-panel *::before, .hb-jv-panel *::after {
    box-sizing: border-box;
  }

  /* Header */
  .hb-jv-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    height: 52px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .hb-jv-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .hb-jv-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #f1f5f9;
  }
  .hb-jv-model-badge {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(249,115,22,0.1);
    color: #fb923c;
    letter-spacing: 0.02em;
  }
  .hb-jv-header-right {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .hb-jv-clear-btn {
    font-size: 12px;
    color: #64748b;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    font-family: inherit;
    transition: color 0.15s, background 0.15s;
  }
  .hb-jv-clear-btn:hover { color: #94a3b8; background: rgba(255,255,255,0.04); }
  .hb-jv-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }
  .hb-jv-close-btn:hover { background: rgba(255,255,255,0.06); color: #f1f5f9; }

  /* Messages area */
  .hb-jv-messages {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 14px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .hb-jv-messages::-webkit-scrollbar { width: 4px; }
  .hb-jv-messages::-webkit-scrollbar-track { background: transparent; }
  .hb-jv-messages::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

  /* Welcome state */
  .hb-jv-welcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 40px 16px 20px;
    gap: 12px;
  }
  .hb-jv-welcome-icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: rgba(249,115,22,0.08);
    border: 1px solid rgba(249,115,22,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hb-jv-welcome-title {
    font-size: 18px;
    font-weight: 700;
    color: #f1f5f9;
  }
  .hb-jv-welcome-sub {
    font-size: 13px;
    color: #64748b;
    max-width: 280px;
    line-height: 1.5;
  }
  .hb-jv-welcome-context {
    font-size: 11px;
    color: #475569;
    padding: 4px 10px;
    background: rgba(255,255,255,0.03);
    border-radius: 6px;
    margin-top: 4px;
  }
  .hb-jv-welcome-context strong { color: #94a3b8; }

  /* Message layout */
  .hb-jv-msg { display: flex; gap: 8px; }
  .hb-jv-msg-user { justify-content: flex-end; }
  .hb-jv-msg-assistant { justify-content: flex-start; align-items: flex-start; }

  .hb-jv-avatar {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(249,115,22,0.08);
    border: 1px solid rgba(249,115,22,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .hb-jv-bubble-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: calc(100% - 40px);
    min-width: 0;
  }

  /* Bubbles */
  .hb-jv-bubble {
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13px;
    line-height: 1.6;
    word-break: break-word;
  }
  .hb-jv-bubble-user {
    background: #f97316;
    color: #fff;
    border-bottom-right-radius: 4px;
    max-width: 280px;
  }
  .hb-jv-bubble-assistant {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.06);
    color: #e2e8f0;
    border-bottom-left-radius: 4px;
  }
  .hb-jv-bubble-assistant.error {
    border-color: rgba(248,113,113,0.2);
    background: rgba(248,113,113,0.06);
    color: #fca5a5;
  }

  /* Markdown content in assistant bubbles */
  .hb-jv-bubble-assistant strong { color: #f1f5f9; }
  .hb-jv-bubble-assistant em { font-style: italic; color: #cbd5e1; }
  .hb-jv-inline-code {
    background: rgba(255,255,255,0.06);
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
  }
  .hb-jv-code-block {
    background: rgba(0,0,0,0.4);
    padding: 10px 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin: 6px 0;
    font-size: 12px;
    font-family: 'Fira Code', 'Cascadia Code', monospace;
    line-height: 1.5;
  }
  .hb-jv-code-block code { background: none; padding: 0; }
  .hb-jv-link { color: #f97316; text-decoration: none; }
  .hb-jv-link:hover { text-decoration: underline; }
  .hb-jv-list {
    padding-left: 16px;
    margin: 4px 0;
    list-style-type: disc;
  }
  .hb-jv-list li { margin-bottom: 2px; }

  /* Tool calls */
  .hb-jv-tool-calls {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .hb-jv-tool-call {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 8px;
    font-size: 12px;
    color: #94a3b8;
  }
  .hb-jv-tool-call.running { border-color: rgba(249,115,22,0.15); }
  .hb-jv-tool-call.error { border-color: rgba(248,113,113,0.15); }
  .hb-jv-tool-icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 11px;
  }
  .hb-jv-tool-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid rgba(249,115,22,0.2);
    border-top-color: #f97316;
    border-radius: 50%;
    animation: hb-spin 0.6s linear infinite;
  }
  .hb-jv-tool-label { font-weight: 500; }
  .hb-jv-tool-summary { color: #64748b; margin-left: auto; }

  /* Typing indicator */
  .hb-jv-typing {
    display: inline-flex;
    gap: 4px;
    padding: 4px 0;
  }
  .hb-jv-typing span {
    width: 6px;
    height: 6px;
    background: #64748b;
    border-radius: 50%;
    animation: hb-jv-typing-bounce 1.4s ease-in-out infinite;
  }
  .hb-jv-typing span:nth-child(2) { animation-delay: 0.16s; }
  .hb-jv-typing span:nth-child(3) { animation-delay: 0.32s; }
  @keyframes hb-jv-typing-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40% { transform: scale(1); opacity: 1; }
  }

  /* Quick actions */
  .hb-jv-quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 14px 12px;
    flex-shrink: 0;
  }
  .hb-jv-quick-chip {
    padding: 6px 12px;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.08);
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
  }
  .hb-jv-quick-chip:hover {
    border-color: rgba(249,115,22,0.3);
    color: #fb923c;
    background: rgba(249,115,22,0.06);
  }
  .hb-jv-quick-chip:disabled { opacity: 0.4; cursor: not-allowed; }

  /* Input area */
  .hb-jv-input-area {
    border-top: 1px solid rgba(255,255,255,0.07);
    padding: 12px 14px;
    flex-shrink: 0;
  }
  .hb-jv-input-row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    padding: 8px 8px 8px 14px;
    transition: border-color 0.15s;
  }
  .hb-jv-input-row:focus-within {
    border-color: rgba(249,115,22,0.4);
  }
  .hb-jv-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #f1f5f9;
    font-size: 13px;
    font-family: inherit;
    resize: none;
    max-height: 120px;
    line-height: 1.5;
    caret-color: #f97316;
  }
  .hb-jv-input::placeholder { color: #475569; }
  .hb-jv-input:disabled { opacity: 0.5; }
  .hb-jv-send-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #f97316;
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, opacity 0.15s;
  }
  .hb-jv-send-btn:hover { background: #ea6c0c; }
  .hb-jv-send-btn:disabled { opacity: 0.3; cursor: not-allowed; }
  .hb-jv-stop-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(248,113,113,0.12);
    border: 1px solid rgba(248,113,113,0.3);
    border-radius: 8px;
    color: #f87171;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s;
  }
  .hb-jv-stop-btn:hover { background: rgba(248,113,113,0.2); }
  .hb-jv-stop-icon {
    display: block;
    width: 10px;
    height: 10px;
    background: #f87171;
    border-radius: 2px;
  }

  /* Input hint */
  .hb-jv-input-hint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 2px 0;
  }
  .hb-jv-kbd-hint {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    color: #334155;
  }
  .hb-jv-kbd-hint kbd {
    display: inline-block;
    padding: 0px 4px;
    background: rgba(255,255,255,0.04);
    border-radius: 3px;
    font-size: 10px;
    font-family: inherit;
    color: #475569;
    border: 1px solid rgba(255,255,255,0.06);
  }
  .hb-jv-powered {
    font-size: 11px;
    color: #334155;
  }

  /* ── Voice Chat ─────────────────────────────────────────────────────────── */

  /* Mic button — sits left of send button in input row */
  .hb-jv-mic-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: #94a3b8;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
    position: relative;
  }
  .hb-jv-mic-btn:hover:not(.disabled):not(:disabled) {
    background: rgba(255,255,255,0.04);
    color: #f1f5f9;
    border-color: rgba(255,255,255,0.15);
  }
  .hb-jv-mic-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  .hb-jv-mic-btn.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  .hb-jv-mic-btn.disabled:hover {
    background: transparent;
    color: #94a3b8;
  }

  /* Recording state — pulsing red ring */
  .hb-jv-mic-btn.recording {
    color: #f87171;
    border-color: #f87171;
    background: rgba(248,113,113,0.1);
    box-shadow: 0 0 0 0 rgba(248,113,113,0.4);
    animation: hb-mic-pulse 1.5s ease-in-out infinite;
  }

  /* Processing state — spinner overlay */
  .hb-jv-mic-btn.processing {
    color: #f97316;
    border-color: rgba(249,115,22,0.3);
    background: rgba(249,115,22,0.08);
    animation: hb-mic-spin-border 1s linear infinite;
  }

  /* Playing state — gentle glow */
  .hb-jv-mic-btn.playing {
    color: #34d399;
    border-color: rgba(52,211,153,0.3);
    background: rgba(52,211,153,0.08);
    animation: hb-mic-glow 2s ease-in-out infinite;
  }

  @keyframes hb-mic-pulse {
    0% { box-shadow: 0 0 0 0 rgba(248,113,113,0.4); }
    70% { box-shadow: 0 0 0 6px rgba(248,113,113,0); }
    100% { box-shadow: 0 0 0 0 rgba(248,113,113,0); }
  }

  @keyframes hb-mic-spin-border {
    0% { border-color: rgba(249,115,22,0.3); }
    50% { border-color: rgba(249,115,22,0.7); }
    100% { border-color: rgba(249,115,22,0.3); }
  }

  @keyframes hb-mic-glow {
    0%, 100% { box-shadow: 0 0 4px rgba(52,211,153,0.2); }
    50% { box-shadow: 0 0 8px rgba(52,211,153,0.4); }
  }

  /* Voice session indicator bar */
  .hb-jv-voice-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    margin-bottom: 8px;
    background: rgba(249,115,22,0.06);
    border: 1px solid rgba(249,115,22,0.12);
    border-radius: 8px;
    font-size: 12px;
    color: #94a3b8;
  }
  .hb-jv-voice-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f97316;
    animation: hb-mic-pulse 1.5s ease-in-out infinite;
    flex-shrink: 0;
  }
  .hb-jv-voice-end {
    margin-left: auto;
    padding: 2px 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 4px;
    color: #94a3b8;
    font-size: 11px;
    cursor: pointer;
    transition: background 0.15s;
  }
  .hb-jv-voice-end:hover {
    background: rgba(255,255,255,0.1);
    color: #f1f5f9;
  }

  /* Voice error toast */
  .hb-jv-voice-toast {
    margin: 0 14px 8px;
    padding: 8px 12px;
    background: rgba(248,113,113,0.1);
    border: 1px solid rgba(248,113,113,0.2);
    border-radius: 8px;
    font-size: 12px;
    color: #f87171;
  }

  /* Jarvis responsive */
  @media (max-width: 480px) {
    .hb-jv-panel { width: 100vw; }
  }

  /* Reduce motion for Jarvis */
  @media (prefers-reduced-motion: reduce) {
    .hb-jv-panel { animation: none !important; }
    .hb-jv-typing span { animation: none !important; opacity: 0.6; }
    .hb-jv-tool-spinner { animation: none !important; }
    .hb-jv-btn.pulse::after { animation: none !important; }
    .hb-jv-mic-btn.recording { animation: none !important; box-shadow: 0 0 0 2px rgba(248,113,113,0.4); }
    .hb-jv-mic-btn.processing { animation: none !important; }
    .hb-jv-mic-btn.playing { animation: none !important; }
    .hb-jv-voice-dot { animation: none !important; }
  }

  /* ── Hub Global Tasks Panel ───────────────────────────────────────────────── */
  .hb-tasks-btn {
    position: relative; display: flex; align-items: center; justify-content: center;
    width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer;
    background: transparent; color: #94a3b8; transition: background 0.15s, color 0.15s;
    flex-shrink: 0;
  }
  .hb-tasks-btn:hover, .hb-tasks-btn.active { background: rgba(255,255,255,0.06); color: #f1f5f9; }
  .hb-tasks-badge {
    position: absolute; top: 2px; right: 2px;
    min-width: 16px; height: 16px; padding: 0 4px; border-radius: 8px;
    background: #ef4444; color: #fff; font-size: 10px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; pointer-events: none;
  }
  .hb-tasks-panel { width: 560px; display: flex; flex-direction: column; padding: 0; }
  .hb-task-header-badge {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 18px; height: 18px; padding: 0 5px; border-radius: 9px;
    background: #ef4444; color: #fff; font-size: 11px; font-weight: 700; margin-left: 8px;
  }
  .hb-task-full-link { font-size: 12px; color: #64748b; text-decoration: none; white-space: nowrap; }
  .hb-task-full-link:hover { color: #94a3b8; }
  .hb-task-quickadd {
    padding: 8px 16px; border-bottom: 1px solid rgba(255,255,255,0.06);
    display: flex; flex-direction: column; gap: 6px;
  }
  .hb-task-quickadd-row { display: flex; align-items: center; gap: 8px; }
  .hb-task-quickadd-input {
    flex: 1; background: transparent; border: none; outline: none;
    color: #f1f5f9; font-size: 13px; font-family: inherit;
  }
  .hb-task-quickadd-input::placeholder { color: #475569; }
  .hb-task-quickadd-btn {
    padding: 2px 10px; border-radius: 4px; border: none; cursor: pointer;
    background: rgba(249,115,22,0.15); color: #f97316; font-size: 12px; font-weight: 500;
  }
  .hb-task-quickadd-btn:hover { background: rgba(249,115,22,0.25); }
  .hb-task-quickadd-area {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 4px; color: #94a3b8; font-size: 12px; padding: 3px 6px; outline: none; font-family: inherit;
  }
  .hb-tasks-body { flex: 1; display: flex; overflow: hidden; }
  .hb-tasks-sidebar {
    width: 140px; flex-shrink: 0; border-right: 1px solid rgba(255,255,255,0.06);
    padding: 8px 0; overflow-y: auto;
  }
  .hb-tasks-sidebar-section { padding: 0 8px; }
  .hb-tasks-sidebar-divider { height: 1px; background: rgba(255,255,255,0.06); margin: 8px 0; }
  .hb-tasks-sidebar-label {
    font-size: 10px; font-weight: 600; text-transform: uppercase;
    color: #475569; letter-spacing: 0.06em; padding: 4px 8px;
  }
  .hb-tasks-view-btn {
    display: flex; align-items: center; gap: 6px; width: 100%;
    padding: 5px 8px; border-radius: 5px; border: none; cursor: pointer;
    background: transparent; color: #94a3b8; font-size: 12px; text-align: left;
    font-family: inherit; transition: background 0.1s, color 0.1s;
  }
  .hb-tasks-view-btn:hover { background: rgba(255,255,255,0.04); color: #f1f5f9; }
  .hb-tasks-view-btn.active { background: rgba(249,115,22,0.1); color: #f97316; }
  .hb-task-view-count {
    margin-left: auto; min-width: 18px; height: 16px; padding: 0 4px;
    border-radius: 8px; background: #ef444433; color: #ef4444;
    font-size: 10px; font-weight: 700; display: flex; align-items: center; justify-content: center;
  }
  .hb-tasks-area-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  .hb-tasks-list { flex: 1; overflow-y: auto; padding: 4px 0; }
  .hb-task-row {
    display: flex; align-items: flex-start; gap: 8px;
    padding: 6px 16px; transition: background 0.1s;
  }
  .hb-task-row:hover { background: rgba(255,255,255,0.03); }
  .hb-task-check {
    flex-shrink: 0; padding: 2px; margin-top: 1px;
    background: transparent; border: none; cursor: pointer; color: #475569; border-radius: 3px; transition: color 0.1s;
  }
  .hb-task-check:hover { color: #22c55e; }
  .hb-task-check.done { cursor: default; }
  .hb-task-body { flex: 1; min-width: 0; }
  .hb-task-title {
    display: inline-flex; align-items: center; gap: 3px;
    color: #f1f5f9; font-size: 13px; text-decoration: none; line-height: 1.4; word-break: break-word;
  }
  .hb-task-title:hover { color: #fff; text-decoration: underline; }
  .hb-task-title.done { color: #64748b; text-decoration: line-through; }
  .hb-task-external { flex-shrink: 0; color: #475569; }
  .hb-task-meta { display: flex; align-items: center; gap: 6px; margin-top: 3px; }
  .hb-task-product-badge { font-size: 10px; font-weight: 600; padding: 1px 5px; border-radius: 3px; letter-spacing: 0.04em; }
  .hb-task-priority-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
  .hb-task-due { font-size: 11px; color: #64748b; }
  .hb-task-due.overdue { color: #ef4444; font-weight: 600; }
  .hb-task-group { margin-bottom: 4px; }
  .hb-task-group-label {
    display: flex; align-items: center; gap: 6px;
    font-size: 11px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.05em; padding: 6px 16px 2px; color: #64748b;
  }
  .hb-task-empty { padding: 32px 16px; text-align: center; color: #475569; font-size: 13px; }

  @media (max-width: 640px) {
    .hb-tasks-panel { width: 100vw; }
    .hb-tasks-sidebar { width: 110px; }
  }

  /* ── Product Switcher — launch gate states ──────────────────────────────── */
  .hb-waffle-section-label {
    font-size: 10px; font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.06em; color: #475569; padding: 4px 12px 2px;
  }
  .hb-waffle-sep { height: 1px; background: rgba(255,255,255,0.06); margin: 6px 0; }
  .hb-waffle-badge {
    font-size: 9px; font-weight: 700; text-transform: uppercase;
    letter-spacing: 0.06em; padding: 1px 5px; border-radius: 3px;
    line-height: 1.4; flex-shrink: 0;
  }
  .beta-badge { background: rgba(139,92,246,0.2); color: #a78bfa; }
  .coming-soon-badge { background: rgba(100,116,139,0.2); color: #64748b; }

  .hb-waffle-tile.inactive { opacity: 0.7; }
  .hb-waffle-tile.inactive:hover { opacity: 1; }

  .hb-waffle-tile.beta-locked {
    background: transparent; border: none; cursor: pointer;
    display: flex; flex-direction: column; align-items: center;
    gap: 4px; padding: 6px 4px; border-radius: 8px;
    transition: background 0.15s; text-align: center;
    font-family: inherit; color: inherit; width: 100%;
  }
  .hb-waffle-tile.beta-locked:hover { background: rgba(255,255,255,0.05); }

  .hb-waffle-tile.coming-soon {
    opacity: 0.45; cursor: default;
    display: flex; flex-direction: column; align-items: center;
    gap: 4px; padding: 6px 4px; border-radius: 8px; text-align: center;
  }
  .hb-waffle-lock-overlay {
    position: absolute; bottom: -2px; right: -2px;
    font-size: 9px; line-height: 1;
  }

  /* ── Waitlist Modal ─────────────────────────────────────────────────────── */
  .hb-waitlist-overlay {
    position: fixed; inset: 0; z-index: 10001;
    background: rgba(0,0,0,0.6); backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center;
    padding: 16px;
  }
  .hb-waitlist-modal {
    background: #18181b; border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px; padding: 24px; width: 100%; max-width: 380px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.6);
    position: relative; color: #f1f5f9;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px; line-height: 1.5;
  }
  .hb-waitlist-close {
    position: absolute; top: 12px; right: 12px;
    background: transparent; border: none; cursor: pointer;
    color: #64748b; font-size: 14px; line-height: 1;
    padding: 4px 6px; border-radius: 4px; transition: color 0.1s;
  }
  .hb-waitlist-close:hover { color: #f1f5f9; }
  .hb-waitlist-header {
    display: flex; align-items: center; gap: 12px; margin-bottom: 16px;
  }
  .hb-waitlist-icon {
    width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
  }
  .hb-waitlist-title { font-size: 16px; font-weight: 600; color: #f1f5f9; }
  .hb-waitlist-desc { color: #94a3b8; font-size: 13px; margin: 0 0 12px; }
  .hb-waitlist-body { color: #94a3b8; font-size: 13px; margin: 0 0 16px; }
  .hb-waitlist-success {
    background: rgba(34,197,94,0.1); color: #86efac;
    border: 1px solid rgba(34,197,94,0.2); border-radius: 6px;
    padding: 10px 12px; font-size: 13px; margin-bottom: 12px;
  }
  .hb-waitlist-error {
    background: rgba(239,68,68,0.1); color: #fca5a5;
    border: 1px solid rgba(239,68,68,0.2); border-radius: 6px;
    padding: 10px 12px; font-size: 13px; margin-bottom: 12px;
  }
  .hb-waitlist-btn {
    width: 100%; padding: 10px 16px; border-radius: 8px;
    background: #7c3aed; border: none; cursor: pointer;
    color: #fff; font-size: 13px; font-weight: 600;
    font-family: inherit; transition: background 0.15s;
  }
  .hb-waitlist-btn:hover:not(:disabled) { background: #6d28d9; }
  .hb-waitlist-btn:disabled { opacity: 0.6; cursor: default; }

  /* ── THEO Onboarding ──────────────────────────────────────────────────────── */
  .theo-onboarding {
    position: absolute;
    inset: 0;
    background: rgba(10, 10, 20, 0.95);
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px;
    border-radius: 12px;
  }
  .theo-onboarding-step {
    max-width: 380px;
    text-align: center;
  }
  .onboarding-prompts {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 16px 0;
    width: 100%;
  }
  .prompt-chip {
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.4);
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
    text-align: left;
    color: #e2e8f0;
    transition: background 0.15s;
    font-family: inherit;
  }
  .prompt-chip:hover {
    background: rgba(99, 102, 241, 0.3);
  }
  .onboarding-step-dots {
    display: flex;
    gap: 6px;
    margin-bottom: 24px;
  }
  .step-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
  }
  .step-dot.active {
    background: #6366f1;
  }

  /* ── THEO Feedback ────────────────────────────────────────────────────────── */
  @keyframes theo-slide-down {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes theo-fade-in {
    from { opacity: 0; transform: translateX(-50%) translateY(4px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
  }

  /* Phase 7B — Voice-to-THEO pulsing mic indicator */
  @keyframes theo-mic-pulse {
    0%, 100% { opacity: 1;   transform: scale(1);   }
    50%      { opacity: 0.5; transform: scale(1.4); }
  }
`;
function zo(t, n, o) {
  if (n && o)
    return (n[0] + o[0]).toUpperCase();
  if (n)
    return n.slice(0, 2).toUpperCase();
  const i = t.split("@")[0].split(/[._-]/);
  return i.length >= 2 ? (i[0][0] + i[1][0]).toUpperCase() : t.slice(0, 2).toUpperCase();
}
function nr() {
  var t;
  if (typeof document > "u") return null;
  try {
    const n = document.cookie.match(/(?:^|;\s*)hub_identity=([^;]+)/);
    if (!(n != null && n[1])) return null;
    const o = atob(n[1].replace(/-/g, "+").replace(/_/g, "/")), i = JSON.parse(o), r = i.sub ?? "";
    if (!r) return null;
    const l = (i.name ?? "").trim().split(/\s+/), d = l[0] ?? "", c = l.length > 1 ? l.slice(1).join(" ") : "", f = ((t = i.roles) == null ? void 0 : t[0]) ?? "member";
    return {
      userId: r,
      tenantId: i.org ?? "",
      firstName: d || void 0,
      lastName: c || void 0,
      role: f,
      initials: zo(r, d || void 0, c || void 0)
    };
  } catch {
    return null;
  }
}
function or(t) {
  const n = t.id || "", o = t.email || "";
  if (!n || !o) return null;
  const i = t.firstName || void 0, r = t.lastName || void 0, l = t.tenantId || "", d = t.tenantSlug || "", c = t.tenantName || d, f = t.orgRole || "member", u = t.orgRole, k = t.user_type, b = t.entitlements, S = t.is_platform_owner || !1, v = t.org_type || void 0, g = t.vertical || void 0, _ = t.managed_by_org_id || void 0;
  return {
    userId: n,
    tenantId: l,
    tenantSlug: d,
    tenantName: c,
    email: o,
    role: f,
    orgRole: u,
    userType: k,
    entitlements: b,
    isPlatformOwner: S,
    orgType: v,
    vertical: g,
    managedByOrgId: _,
    firstName: i,
    lastName: r,
    initials: zo(o, i, r)
  };
}
let ut = null, Dt = null;
async function rr(t) {
  return ut || Dt || (Dt = (async () => {
    try {
      const n = t || `${_t}`, o = await fetch(`${n}/api/portal/auth/me`, {
        credentials: "include",
        headers: { Accept: "application/json" }
      });
      if (!o.ok) return null;
      const i = await o.json();
      if (!i.data) return null;
      const r = or(i.data);
      return r && (ut = r), r;
    } catch {
      return null;
    } finally {
      Dt = null;
    }
  })(), Dt);
}
function ir(t, n) {
  const o = St(() => {
    if (t || ut) return null;
    const c = nr();
    return c ? {
      userId: c.userId,
      tenantId: c.tenantId,
      tenantSlug: "",
      tenantName: "",
      email: "",
      role: c.role,
      firstName: c.firstName,
      lastName: c.lastName,
      initials: c.initials
    } : null;
  }, []), [i, r] = y(t ?? ut ?? o), l = K(!1), d = St(() => t, [t]);
  return H(() => {
    if (d) {
      r(d);
      return;
    }
    if (ut) {
      r(ut);
      return;
    }
    if (l.current) return;
    l.current = !0, rr(n || _t).then((f) => {
      r(f);
    });
  }, [d, n]), i;
}
const Un = [
  { id: "theo", name: "THEO", description: "AI built for MSPs. Proactive, integrated, yours.", icon: "Sparkles", color: "#7c3aed", url: "https://app.theonestack.com/theo", default_launch_status: "ga" },
  { id: "coo", name: "COO THEO", description: "Your AI Chief Operating Officer — knows your business, executes on your behalf.", icon: "BriefcaseBusiness", color: "#f97316", url: "https://hub.theonestack.com/coo", default_launch_status: "ga" },
  // collective — REMOVED 2026-04-16: standalone site at mspcollective.io; linked in Hub footer
  { id: "psa", name: "The One PSA", description: "Service desk with full client context on every ticket.", icon: "Layers", color: "#6366f1", url: "https://app.theonestack.com/psa", default_launch_status: "ga" },
  { id: "clarity", name: "The One Clarity", description: "AI-native MSP analytics — true profitability, SLA trends, and client health in one view.", icon: "BarChart2", color: "#6366f1", url: "https://app.theonestack.com/clarity", default_launch_status: "ga" },
  { id: "crm", name: "The One CRM", description: "Sales pipeline, marketing automation, and AI-powered QBR builder.", icon: "Users", color: "#8b5cf6", url: "https://app.theonestack.com/crm", default_launch_status: "ga" },
  { id: "cmdb", name: "The One CMDB", description: "Documentation, password vault, and knowledge base that builds itself.", icon: "Database", color: "#0ea5e9", url: "https://app.theonestack.com/cmdb", default_launch_status: "ga" },
  { id: "books", name: "The One Books", description: "Full double-entry accounting with per-client profitability.", icon: "BookOpen", color: "#10b981", url: "https://app.theonebooks.app", default_launch_status: "ga" },
  { id: "projects", name: "The One Projects", description: "Project management with Gantt charts and budgets that flow to invoicing.", icon: "FolderKanban", color: "#f59e0b", url: "https://app.theonestack.com/projects", default_launch_status: "ga" },
  { id: "oncall", name: "The One On-Call", description: "Rotation scheduling, multi-tier escalation, and auto-billed on-call hours.", icon: "BellRing", color: "#f97316", url: "https://app.theonestack.com/oncall", default_launch_status: "ga" },
  { id: "canvas", name: "The One Canvas", description: "Intelligent diagramming with auto-generated topology.", icon: "PenTool", color: "#64748b", url: "https://app.theonestack.com/canvas", default_launch_status: "ga" },
  { id: "legal", name: "The One Legal", description: "Matter management, encrypted document vault, and on-demand attorney services.", icon: "Scale", color: "#6366f1", url: "https://app.theonestack.com/legal", default_launch_status: "ga" },
  { id: "legal-attorney", name: "Legal Attorney", description: "Partner attorney portal — matters, templates, messages, and earnings across every MSP served.", icon: "Gavel", color: "#8b5cf6", url: "https://app.theonestack.com/legal-attorney", default_launch_status: "ga" },
  { id: "rmm", name: "The One RMM", description: "Monitor, patch, and automate every endpoint.", icon: "Cpu", color: "#10b981", url: "https://app.theonestack.com/rmm", default_launch_status: "ga" },
  { id: "defend", name: "The One Defend", description: "231 MITRE ATT&CK rules, attack chain visualization, and automated response.", icon: "Shield", color: "#ef4444", url: "https://app.theonestack.com/defend", default_launch_status: "ga" },
  { id: "backups", name: "The One Backups", description: "Endpoint and SaaS backup with ransomware-aware recovery.", icon: "HardDrive", color: "#3b82f6", url: "https://app.theonestack.com/backups", default_launch_status: "ga" },
  { id: "soc", name: "The One SOC", description: "Autonomous detection, correlation, and response.", icon: "ShieldAlert", color: "#dc2626", url: "https://app.theonestack.com/soc", default_launch_status: "ga" },
  { id: "compliance", name: "The One Compliance", description: "Seven frameworks, auto-collected evidence, and cross-framework control mapping.", icon: "ClipboardCheck", color: "#7c3aed", url: "https://app.theonestack.com/compliance", default_launch_status: "ga" },
  { id: "protect", name: "The One Protect", description: "Dark web monitoring, phishing simulation, DMARC, and breach response.", icon: "UserShield", color: "#db2777", url: "https://app.theonestack.com/protect", default_launch_status: "ga" },
  { id: "voice", name: "The One Voice", description: "Full PBX with caller context, AI call scoring, and wholesale resale.", icon: "Phone", color: "#06b6d4", url: "https://app.theonestack.com/voice", default_launch_status: "ga" },
  { id: "relay", name: "The One Relay", description: "Transactional email delivery, inbound routing, and deliverability management.", icon: "Mail", color: "#0891b2", url: "https://app.theonestack.com/relay", default_launch_status: "ga" },
  { id: "portal", name: "The One Portal", description: "White-label client portal with self-service and health dashboards.", icon: "Monitor", color: "#64748b", url: "https://app.theoneportal.app", default_launch_status: "coming_soon" },
  { id: "people", name: "The One People", description: "HR management with cross-product onboarding and one-click offboarding.", icon: "UserCircle", color: "#ec4899", url: "https://app.theonestack.com/people", default_launch_status: "ga" },
  { id: "fleet", name: "The One Fleet", description: "GPS tracking, predictive maintenance, and automatic mileage billing.", icon: "Truck", color: "#f59e0b", url: "https://app.theonestack.com/fleet", default_launch_status: "ga" },
  { id: "visitor", name: "The One Visitor", description: "Kiosk check-in, badge printing, NDA signing, and instant host notifications.", icon: "DoorOpen", color: "#14b8a6", url: "https://app.theonestack.com/visitor", default_launch_status: "ga" },
  { id: "mission", name: "The One Mission", description: "Church and ministry management — members, giving, events, and communication.", icon: "Flame", color: "#8b5cf6", url: "https://app.theonestack.com/mission", default_launch_status: "ga" },
  { id: "ams", name: "The One AMS", description: "Association management — members, dues, events, and committees.", icon: "Building2", color: "#10b981", url: "https://app.theonestack.com/ams", default_launch_status: "ga" },
  { id: "code", name: "CodeProtect", description: "DevSecOps with GitHub backup, AI documentation, and vulnerability scanning.", icon: "Code2", color: "#06b6d4", url: "https://app.theonestack.com/code", default_launch_status: "ga" },
  { id: "workflows", name: "The One Workflows", description: "Visual workflow builder and AI agents — automate anything across your MSP stack.", icon: "GitBranch", color: "#7c3aed", url: "https://app.theonestack.com/workflows", default_launch_status: "ga" },
  { id: "bridge", name: "The One Bridge", description: "Data migration with AI-assisted field mapping.", icon: "ArrowLeftRight", color: "#0ea5e9", url: "https://app.theonestack.com/bridge", default_launch_status: "ga" },
  { id: "status", name: "The One Status", description: "Branded status pages, uptime monitoring, and automatic incident management.", icon: "Activity", color: "#22c55e", url: "https://app.theonestack.com/status", default_launch_status: "coming_soon" },
  { id: "remote", name: "The One Remote", description: "Remote desktop with in-session diagnostics and auto-logged billing.", icon: "MonitorSmartphone", color: "#3b82f6", url: "https://app.theoneremote.app", default_launch_status: "ga" },
  { id: "gather", name: "The One Gather", description: "Virtual office with proximity video — walk up to teammates and talk.", icon: "UsersRound", color: "#6366f1", url: "https://gather.theonestack.com", default_launch_status: "ga" },
  { id: "sanctuary", name: "The One Sanctuary", description: "Live translation and closed captioning for churches — 31 languages, zero per-minute fees.", icon: "Globe", color: "#059669", url: "https://app.theonestack.com/sanctuary", default_launch_status: "ga" },
  { id: "space", name: "The One Space", description: "Coworking space management — members, bookings, access control, billing, and website builder.", icon: "Building2", color: "#0d9488", url: "https://app.theonestack.com/space", default_launch_status: "ga" },
  { id: "build", name: "The One Build", description: "Construction project management — bids, scheduling, crews, and job costing.", icon: "HardHat", color: "#d97706", url: "https://app.theonestack.com/build", default_launch_status: "ga" },
  { id: "mission", name: "The One Mission", description: "Church and ministry management — members, giving, events, and communication.", icon: "Flame", color: "#8b5cf6", url: "https://app.theonestack.com/mission", default_launch_status: "ga" },
  { id: "ams", name: "The One AMS", description: "Association management — members, dues, events, and committees.", icon: "Building2", color: "#10b981", url: "https://app.theonestack.com/ams", default_launch_status: "ga" },
  { id: "cypher", name: "The One Cypher", description: "AI-powered security awareness training with gamification and adaptive difficulty.", icon: "ShieldCheck", color: "#7C3AED", url: "https://app.theonestack.com/cypher", default_launch_status: "ga" },
  { id: "email-shield", name: "The One Email Shield", description: "Live email threat detection, DMARC management, and inline inspection.", icon: "MailCheck", color: "#0EA5E9", url: "https://app.theonestack.com/email-shield", default_launch_status: "ga" },
  { id: "threat-intel", name: "The One Threat Intel", description: "Dark web monitoring, credential exposure tracking, and breach response.", icon: "Radar", color: "#EF4444", url: "https://app.theonestack.com/threat-intel", default_launch_status: "ga" },
  { id: "shield", name: "The One Shield", description: "Intelligent DNS filtering and student safety monitoring for schools.", icon: "ShieldAlert", color: "#2563EB", url: "https://app.theonestack.com/shield", default_launch_status: "ga" },
  { id: "tier-zero", name: "Tier Zero", description: "Autonomous AI technician — intelligent runbooks and self-healing IT.", icon: "Zap", color: "#7c3aed", url: "https://app.theonestack.com/tier-zero", default_launch_status: "ga" }
];
function Oo(t, n, o) {
  const [i, r] = y([]), [l, d] = y(!1), [c, f] = y(null);
  return H(() => {
    if (!n) {
      r([]);
      return;
    }
    d(!0), f(null);
    const u = new AbortController(), k = o ? Promise.resolve({ activeProductIds: Un.map((b) => b.id) }) : fetch(`${t}/api/bus/products?tenant_id=${encodeURIComponent(n)}`, {
      credentials: "include",
      signal: u.signal
    }).then((b) => b.ok ? b.json() : { activeProductIds: [] }).catch(() => ({ activeProductIds: [] }));
    return Promise.all([
      // Hub-side endpoint — reads product launch status overrides
      fetch(`${t}/api/hub/product-launch/statuses`, {
        credentials: "include",
        signal: u.signal
      }).then((b) => b.ok ? b.json() : { statuses: {} }).catch(() => ({ statuses: {} })),
      k
    ]).then(([b, S]) => {
      const v = new Set(S.activeProductIds);
      r(
        Un.map((g) => ({
          id: g.id,
          name: g.name,
          description: g.description,
          icon: g.icon,
          color: g.color,
          url: g.url,
          active: v.has(g.id),
          launch_status: b.statuses[g.id] ?? g.default_launch_status
        }))
      ), d(!1);
    }).catch((b) => {
      b.name !== "AbortError" && (r([]), f(b.message), d(!1));
    }), () => u.abort();
  }, [t, n, o]), { products: i, loading: l, error: c };
}
const ar = /* @__PURE__ */ new Set(["GET", "HEAD", "OPTIONS"]);
function sr() {
  if (typeof document > "u") return null;
  try {
    const n = document.cookie.match(/(?:^|;)\s*hub_identity=([^;]+)/);
    if (n) {
      const o = JSON.parse(
        atob(n[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
      if (typeof o.csrf == "string") return o.csrf;
    }
  } catch {
  }
  const t = window.__HUB_CSRF_TOKEN__;
  return typeof t == "string" ? t : null;
}
function nt(t, n) {
  const o = ((n == null ? void 0 : n.method) ?? "GET").toUpperCase(), i = new Headers(n == null ? void 0 : n.headers);
  if (!ar.has(o)) {
    const r = sr();
    r && !i.has("X-CSRF-Token") && i.set("X-CSRF-Token", r);
  }
  return fetch(t, {
    credentials: "include",
    ...n,
    headers: i
  });
}
function lr(t, n, o, i) {
  const [r, l] = y([]), [d, c] = y([]), [f, u] = y(!1), k = K(null), b = K(null);
  H(() => {
    if (!o || !i) return;
    const w = new AbortController();
    return fetch(`${t}/api/bus/notifications?limit=20`, {
      credentials: "include",
      signal: w.signal
    }).then((p) => p.ok ? p.json() : Promise.resolve({ notifications: [] })).then((p) => {
      l(p.notifications ?? []);
    }).catch(() => {
    }), () => w.abort();
  }, [t, o, i]), H(() => {
    if (!n || !o) return;
    let w = !1;
    return (async () => {
      try {
        const { HubConnectionBuilder: p, LogLevel: A } = await import("./index-CrDahL0u.js"), G = new p().withUrl(`${n}?tenantId=${encodeURIComponent(o)}`).withAutomaticReconnect().configureLogging(A.Warning).build();
        G.on("notification", (M) => {
          l((L) => [M, ...L.slice(0, 49)]), k.current || (c((L) => [...L, M]), setTimeout(() => {
            c((L) => L.filter((W) => W.id !== M.id));
          }, 5e3));
        }), G.on("notificationsRead", (M) => {
          const L = new Set(M);
          l(
            (W) => W.map((F) => L.has(F.id) ? { ...F, read: !0 } : F)
          );
        }), G.on("busEvent", (M) => {
          const L = {
            id: M.event_id,
            productId: M.source,
            productName: M.source.toUpperCase(),
            title: M.title,
            body: M.detail,
            severity: M.severity === "critical" ? "error" : M.severity,
            read: !1,
            deepLink: M.entity_url || "",
            createdAt: M.timestamp
          };
          l((W) => [L, ...W.slice(0, 49)]), k.current || (c((W) => [...W, L]), setTimeout(() => {
            c((W) => W.filter((F) => F.id !== L.id));
          }, 5e3));
        }), w || (await G.start(), b.current = G);
      } catch {
      }
    })(), () => {
      var p;
      w = !0, (p = b.current) == null || p.stop(), b.current = null;
    };
  }, [n, o]), H(() => {
    if (!t || !o || !i || n) return;
    let w = 5e3, p;
    const A = () => {
      fetch(`${t}/api/bus/notifications?limit=20`, {
        credentials: "include"
      }).then((G) => {
        if (G.status === 429) {
          w = 6e4;
          return;
        }
        if (!G.ok) {
          w = Math.min(w * 2, 6e4);
          return;
        }
        return G.json().then((M) => {
          var L;
          (L = M.notifications) != null && L.length && l((W) => {
            const F = new Set(W.map((j) => j.id)), q = M.notifications.filter((j) => !F.has(j.id));
            return q.length ? [...q, ...W].slice(0, 50) : W;
          }), w = 5e3;
        });
      }).catch(() => {
        w = Math.min(w * 2, 6e4);
      }).finally(() => {
        p = setTimeout(A, w);
      });
    };
    return p = setTimeout(A, w), () => clearTimeout(p);
  }, [t, o, i, n]);
  const S = D((w) => {
    l(
      (p) => p.map((A) => A.id === w ? { ...A, read: !0 } : A)
    ), nt(`${t}/api/bus/notifications/${encodeURIComponent(w)}/read`, {
      method: "POST"
    }).catch(() => {
    });
  }, [t]), v = D(() => {
    l((w) => w.map((p) => ({ ...p, read: !0 }))), nt(`${t}/api/bus/notifications/mark-all-read`, {
      method: "POST"
    }).catch(() => {
    });
  }, [t]), g = D((w) => {
    l((p) => p.filter((A) => A.id !== w)), nt(`${t}/api/bus/notifications/${encodeURIComponent(w)}/dismiss`, {
      method: "POST"
    }).catch(() => {
    });
  }, [t]), _ = D((w) => {
    u(!0), k.current && clearTimeout(k.current), k.current = setTimeout(() => {
      u(!1), k.current = null;
    }, w);
  }, []), C = D(() => {
    u(!1), k.current && (clearTimeout(k.current), k.current = null);
  }, []), R = D((w) => {
    c((p) => p.filter((A) => A.id !== w));
  }, []), P = r.filter((w) => !w.read).length;
  return { notifications: r, unreadCount: P, markAllRead: v, markRead: S, dismiss: g, muted: f, muteUntil: _, unmute: C, toastQueue: d, dismissToast: R };
}
const Fn = {
  critical: 0,
  warning: 1,
  info: 2
}, cr = 3 * 60 * 1e3;
function dr(t, n, o = 5) {
  const [i, r] = y([]);
  return H(() => {
    if (!t || !n) return;
    let l = !1, d = null;
    async function c() {
      try {
        const f = await fetch(`${t}/api/v1/theo/sentinel`, {
          credentials: "include",
          headers: { Accept: "application/json" }
        });
        if (!f.ok) {
          l || r([]);
          return;
        }
        const u = await f.json();
        if (l) return;
        const k = (u.insights ?? []).filter((b) => b.is_active !== !1).filter((b) => b.severity === "critical" || b.severity === "warning").sort((b, S) => {
          const v = (Fn[b.severity] ?? 3) - (Fn[S.severity] ?? 3);
          return v !== 0 ? v : new Date(S.created_at).getTime() - new Date(b.created_at).getTime();
        }).slice(0, o);
        r(k);
      } catch {
        l || r([]);
      }
    }
    return c(), d = setInterval(c, cr), () => {
      l = !0, d && clearInterval(d);
    };
  }, [t, n, o]), { insights: i };
}
function Vn() {
  if (typeof document > "u") return null;
  const t = document.cookie.match(/(?:^|;\s*)hub_session=([^;]+)/);
  return t ? t[1] : null;
}
function pr(t, n) {
  const [o, i] = y([]);
  H(() => {
    if (!n) return;
    const l = new AbortController(), d = Vn();
    return fetch(`${t}/api/hub/user/orgs`, {
      credentials: "include",
      headers: d ? { Authorization: `Bearer ${d}` } : void 0,
      signal: l.signal
    }).then((c) => c.ok ? c.json() : Promise.resolve({ orgs: [] })).then((c) => {
      c.orgs && c.orgs.length > 1 && i(c.orgs);
    }).catch(() => {
    }), () => l.abort();
  }, [t, n]);
  async function r(l) {
    const d = Vn();
    (await nt(`${t}/api/hub/auth/switch-org`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...d ? { Authorization: `Bearer ${d}` } : {}
      },
      body: JSON.stringify({ target_org_id: l })
    })).ok && window.location.reload();
  }
  return { orgs: o, switchOrg: r };
}
const E = (t) => function({ size: o = 16, className: i, color: r = "currentColor" }) {
  const l = Array.isArray(t) ? t : [t];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: o,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: r,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: i,
      children: l.map((d, c) => /* @__PURE__ */ e("path", { d }, c))
    }
  );
}, hr = E("M20 6 9 17l-5-5"), Tt = E("M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"), ur = E([
  "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9",
  "M13.73 21a2 2 0 0 1-3.46 0"
]), fr = E("M12 5v14M5 12h14"), We = E("M18 6 6 18M6 6l12 12"), br = E(["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"]), Ro = E([
  "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
  "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
]), mr = E([
  "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
  "M16 17l5-5-5-5",
  "M21 12H9"
]), gr = E([
  "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  "M4.93 4.93l4.24 4.24",
  "M14.83 14.83l4.24 4.24",
  "M14.83 9.17l4.24-4.24",
  "M14.83 9.17l3.53-3.53",
  "M4.93 19.07l4.24-4.24"
]), xr = E(["M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", "M2 10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10H2z"]), yr = E(["M22 12h-4", "M6 12H2", "M12 6V2", "M12 22v-4", "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"]), on = E(["M2 3h20v14H2z", "M8 21h8", "M12 17v4"]), rn = E(["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", "M9 12l2 2 4-4"]), an = E(["M22 12H2", "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z", "M6 16h.01", "M10 16h.01"]), sn = E(["M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z", "M8 10v4", "M12 10v2", "M16 10v6"]), ln = E(["M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"]), ft = E("M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"), $e = E(["M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z", "M20 3v4", "M22 5h-4"]), Gt = E(["M23 7l-7 5 7 5V7z", "M14 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"]), Gn = E(["M18 22V8l-6-6-6 6v14", "M2 22h20", "M10 22v-4a2 2 0 0 1 4 0v4", "M12 7v5", "M10 9h4"]), cn = E(["M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18", "M6 12H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", "M18 12h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2", "M10 6h4", "M10 10h4", "M10 14h4", "M10 18h4"]), dn = E(["M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h1", "M15 18h6a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14", "M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4z", "M17 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"]), pn = E(["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z", "M22 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"]), hn = E(["M12 2a9 3 0 1 0 0 6 9 3 0 0 0 0-6z", "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3", "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"]), un = E(["M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9", "M13.73 21a2 2 0 0 1-3.46 0", "M2 8c0-2.2.7-4.3 2-6", "M22 8a10 10 0 0 0-2-6"]), fn = E(["M13 4h3a2 2 0 0 1 2 2v14", "M2 20h3", "M13 20h9", "M10 12v.01", "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4.243-1.06A2 2 0 0 1 13 4.561z"]), bn = E(["M16 2l5 5-14 14L2 16z", "M12 8l-2-2", "M8 12l-2-2"]), mn = E(["M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z", "M2 12h20", "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"]), gn = E(["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"]), xn = E("M22 12h-4l-3 9L9 3l-3 9H2"), yn = E(["M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1", "M12 10v4h4", "M12 14c1.5-2 3.5-3 6-3", "M20 18v-4h-4", "M20 14c-1.5 2-3.5 3-6 3"]), Io = E(["M9 11l3 3L22 4", "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 0-2-2V5a2 2 0 0 1 2-2h11"]), vr = E("M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"), kr = E(["M7 17 17 7", "M7 7h10v10"]), Rn = E([
  "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  "M12 8v4",
  "M12 16h.01"
]), Xt = E([
  "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z",
  "M19 10v2a7 7 0 0 1-14 0v-2",
  "M12 19v3",
  "M8 22h8"
]), wr = E([
  "M2 2l20 20",
  "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2",
  "M5 10v2a7 7 0 0 0 12 5",
  "M15 9.34V5a3 3 0 0 0-5.68-1.33",
  "M9 9v3a3 3 0 0 0 5.12 2.12",
  "M12 19v3",
  "M8 22h8"
]), vn = E(["M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z", "M22 6l-10 7L2 6"]), kn = E(["M12 8V4H8", "M3 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z", "M9 13h.01", "M15 13h.01"]), Yn = E(["M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"]), Bn = E(["M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z", "M12 2a10 10 0 0 1 7.743 16.33", "M6.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z", "M17.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z", "M9.5 15.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"]), Kn = E(["M15 12l-8.5 8.5a2.12 2.12 0 0 1-3-3L12 9", "M17.64 15 22 10.64", "M20.91 11.7l-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91z"]), qn = E("M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"), Jn = E(["M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0", "M5 8V5h3", "M5 16v3h3", "M19 8V5h-3", "M19 16v3h-3", "M2 12h3", "M19 12h3", "M12 2v3", "M12 19v3"]), Xn = E(["M4 17l6-6-6-6", "M12 19h8"]), Qn = E(["M12 2 2 7l10 5 10-5-10-5z", "M2 17l10 5 10-5", "M2 12l10 5 10-5"]), Zn = E(["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"]), eo = E(["M18 8h4v12H2v-7", "M10 8V3H2v12h8V8z"]), to = E(["M8 3 4 7l4 4", "M4 7h16", "M16 21l4-4-4-4", "M20 17H4"]), no = E("M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"), oo = E(["M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", "M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2z", "M9 14l2 2 4-4"]), ro = E(["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z", "M20 13s2-1 2-3l-2-5-2 5c0 2 2 3 2 3z"]), io = E(["M12 19l7-7 3 3-7 7-3-3z", "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z", "M2 2l7.586 7.586", "M11 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"]), ao = E(["M18.364 17.364A9 9 0 1 0 5.636 5.636a9 9 0 0 0 12.728 11.728z", "M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0z", "M6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855"]), Wt = E(["M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"]), so = E(["M13 2 3 14h9l-1 8 10-12h-9l1-8z"]), Hn = E([
  "M16 2v6h6",
  "M21 3l-7 7",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), Do = E([
  "M23 7V1h-6",
  "M16 8l7-7",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), Sr = E([
  "M23 1l-6 6",
  "M17 1l6 6",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), Lo = E([
  "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.51 19.51 0 0 1-3.51-3.48",
  "M5 2a2 2 0 0 0-2 2v3a2 2 0 0 0 1.72 2 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 9 11.45L7.73 12.72",
  "M1 1l22 22"
]), Tr = E([
  "M19 1l4 4-4 4",
  "M15 5h8",
  "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
]), _r = E([
  "M6 4h4v16H6z",
  "M14 4h4v16h-4z"
]), Mr = E("M5 3l14 9-14 9V3z"), Cr = E([
  "M4 9h16",
  "M4 15h16",
  "M10 3L8 21",
  "M16 3l-2 18"
]), Nr = E([
  "M3 3h18v18H3z",
  "M9 17V7h4a3 3 0 0 1 0 6H9"
]), Ar = E([
  "M22 2L11 13",
  "M22 2l-7 20-4-9-9-4 20-7z"
]), Po = E([
  "M19 12H5",
  "M12 19l-7-7 7-7"
]), Er = E([
  "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
  "M18 9l-6 6",
  "M12 9l6 6"
]), lo = E(["M18 20V10", "M12 20V4", "M6 20v-6"]), co = E([
  "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
  "M8.21 13.89 7 23l5-3 5 3-1.21-9.11"
]), po = E([
  "M12 20h9",
  "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"
]), ho = E([
  "M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z",
  "M7 11V7a5 5 0 0 1 10 0v4"
]), uo = E([
  "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
  "M12 22V12",
  "M3.29 7 12 12l8.71-5"
]), fo = E([
  "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9z"
]), jo = {
  // Generic Lucide keys (kebab-case)
  briefcase: xr,
  target: yr,
  monitor: on,
  "shield-check": rn,
  "hard-drive": an,
  "folder-kanban": sn,
  "book-open": ln,
  phone: ft,
  sparkles: $e,
  video: Gt,
  church: Gn,
  "building-2": cn,
  truck: dn,
  users: pn,
  database: hn,
  "bell-ring": un,
  "door-open": fn,
  scale: bn,
  globe: mn,
  search: Tt,
  "layout-grid": gn,
  activity: xn,
  "folder-sync": yn,
  // PascalCase aliases — covers all strings used in hub-constants catalogs
  Activity: xn,
  ArrowLeftRight: to,
  Award: co,
  BarChart2: lo,
  BellRing: un,
  BookOpen: ln,
  Bot: kn,
  Building2: cn,
  ClipboardCheck: oo,
  Cloud: fo,
  Code2: Xn,
  Cpu: Jn,
  Database: hn,
  DoorOpen: fn,
  FileSignature: po,
  Flame: no,
  FolderKanban: sn,
  FolderSync: yn,
  Globe: mn,
  HardDrive: an,
  Hammer: Kn,
  Layers: Qn,
  LayoutDashboard: Zn,
  LayoutGrid: gn,
  Lock: ho,
  Mail: vn,
  MapPin: Yn,
  MessageSquare: Wt,
  Mic: Xt,
  Monitor: on,
  MonitorSmartphone: eo,
  Package: uo,
  Palette: Bn,
  PenTool: io,
  Phone: ft,
  Scale: bn,
  Search: Tt,
  Shield: qn,
  ShieldAlert: Rn,
  ShieldCheck: rn,
  Sparkles: $e,
  Truck: dn,
  UserCircle: ao,
  UserShield: ro,
  Users: pn,
  Video: Gt,
  Zap: so,
  mail: vn,
  shield: qn,
  bot: kn,
  // Product-specific icon keys — one unique icon per product
  // Operations
  psa: Qn,
  // layered service desk
  crm: pn,
  // people/relationships
  books: ln,
  // accounting books
  projects: sn,
  clarity: lo,
  // analytics/BI charts
  oncall: un,
  // Endpoint & Infrastructure
  rmm: Jn,
  // hardware monitoring
  cmdb: hn,
  // config database
  defend: rn,
  // endpoint EDR — shield with checkmark
  backups: an,
  // backup drive
  storage: fo,
  // cloud file storage (distinct from backups)
  status: xn,
  // uptime pulse
  connect: eo,
  // Security pillar — four distinct icons, no duplicates
  soc: Rn,
  // SIEM & SOC — alerted shield
  compliance: oo,
  // GRC checklists
  protect: ro,
  // user/dark-web protection
  security: ho,
  // security operations — padlock
  // Communications
  voice: ft,
  relay: vn,
  messaging: Wt,
  // AI & Automation
  aiplatform: $e,
  ai: $e,
  theo: $e,
  // THEO AI
  agents: kn,
  // AI agents
  studio: uo,
  // white-label AI delivery — packaged product
  workflows: so,
  // automation/lightning
  code: Xn,
  // DevSecOps / app lifecycle
  // Data & Integration
  migrate: yn,
  bridge: to,
  // Field & Vertical
  onsite: Yn,
  fleet: dn,
  visitor: fn,
  build: Kn,
  // construction
  govwin: co,
  // government contracts
  ams: cn,
  // association management
  mission: no,
  // church/mission
  chms: Gn,
  // Creative & Productivity
  canvas: io,
  brand: Bn,
  esign: po,
  // e-signature
  livekit: Gt,
  podcast: Xt,
  signal: Gt,
  // AI avatar video (distinct product, same metaphor)
  // Platform
  legal: bn,
  people: ao,
  collective: mn,
  portal: on,
  hub: Zn,
  gather: gn
  // hybrid office spaces/layout
};
function zr({ icon: t, size: n = 20 }) {
  const o = jo[t];
  return o ? /* @__PURE__ */ e(o, { size: n, color: "#fff" }) : /* @__PURE__ */ e("span", { style: { color: "#fff", fontSize: 14, fontWeight: 700 }, children: t.charAt(0).toUpperCase() });
}
function Or({ product: t, apiBase: n, onClose: o }) {
  const [i, r] = y("idle");
  async function l() {
    r("loading");
    try {
      const d = await fetch(`${n}/api/v1/product-launch/${t.id}/waitlist`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      });
      d.status === 409 ? r("already") : d.ok ? r("joined") : r("error");
    } catch {
      r("error");
    }
  }
  return /* @__PURE__ */ e("div", { className: "hb-waitlist-overlay", onClick: (d) => {
    d.target === d.currentTarget && o();
  }, children: /* @__PURE__ */ a("div", { className: "hb-waitlist-modal", role: "dialog", "aria-modal": "true", children: [
    /* @__PURE__ */ e("button", { className: "hb-waitlist-close", onClick: o, "aria-label": "Close", children: "✕" }),
    /* @__PURE__ */ a("div", { className: "hb-waitlist-header", children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: "hb-waitlist-icon",
          style: { background: t.color, filter: "saturate(0.5)" },
          children: /* @__PURE__ */ e(zr, { icon: t.icon, size: 22 })
        }
      ),
      /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("div", { className: "hb-waitlist-title", children: t.name }),
        /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
      ] })
    ] }),
    t.description && /* @__PURE__ */ e("p", { className: "hb-waitlist-desc", children: t.description }),
    /* @__PURE__ */ e("p", { className: "hb-waitlist-body", children: "This product is in private beta. Join the waitlist and we'll reach out when access is available for your organization." }),
    i === "joined" && /* @__PURE__ */ e("div", { className: "hb-waitlist-success", children: "You're on the waitlist ✓" }),
    i === "already" && /* @__PURE__ */ e("div", { className: "hb-waitlist-success", children: "You're already on the waitlist ✓" }),
    i === "error" && /* @__PURE__ */ e("div", { className: "hb-waitlist-error", children: "Something went wrong. Please try again." }),
    i !== "joined" && i !== "already" && /* @__PURE__ */ e(
      "button",
      {
        className: "hb-waitlist-btn",
        onClick: l,
        disabled: i === "loading",
        children: i === "loading" ? "Requesting…" : "Request Beta Access"
      }
    )
  ] }) });
}
const Rr = {
  msp: [],
  general: [],
  nonprofit: ["mission", "sanctuary", "people", "relay", "canvas", "books"],
  association: ["ams", "people", "relay", "books", "canvas"],
  construction: ["build", "fleet", "projects", "people", "relay"]
}, bo = /* @__PURE__ */ new Set(["mission", "ams", "build", "sanctuary"]);
function Ir() {
  const t = [];
  for (let n = 0; n < 3; n++)
    for (let o = 0; o < 3; o++)
      t.push([6 + o * 7, 6 + n * 7]);
  return /* @__PURE__ */ e("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t.map(([n, o], i) => /* @__PURE__ */ e("circle", { cx: n, cy: o, r: "2", fill: "#94a3b8" }, i)) });
}
function vt({ icon: t, size: n = 20 }) {
  const o = jo[t];
  return o ? /* @__PURE__ */ e(o, { size: n, color: "#fff" }) : /* @__PURE__ */ e("span", { style: { color: "#fff", fontSize: 14, fontWeight: 700 }, children: t.charAt(0).toUpperCase() });
}
function kt(t) {
  return t.replace(/^The One /, "");
}
function Ho({
  currentProduct: t,
  products: n,
  open: o,
  onToggle: i,
  onClose: r,
  hubUrl: l,
  apiBase: d = "",
  vertical: c,
  showClientProducts: f = !1
}) {
  const u = K(null), [k, b] = y(null), S = St(() => {
    if (!c) return null;
    const p = Rr[c];
    return p.length > 0 ? new Set(p) : null;
  }, [c]), v = St(() => {
    let p = S ? n.filter((A) => S.has(A.id)) : n;
    return f && (p = p.filter((A) => !bo.has(A.id))), p;
  }, [n, S, f]), g = St(
    () => f ? n.filter((p) => bo.has(p.id)) : [],
    [n, f]
  ), _ = v.filter((p) => p.launch_status === "ga" && p.active), C = v.filter((p) => p.launch_status === "ga" && !p.active), R = v.filter((p) => p.launch_status === "beta_invite" && (p.active || p.has_beta_access)), P = v.filter((p) => p.launch_status === "beta_invite" && !p.active && !p.has_beta_access), w = v.filter((p) => p.launch_status === "coming_soon");
  return H(() => {
    if (!o) return;
    function p(G) {
      u.current && !u.current.contains(G.target) && r();
    }
    function A(G) {
      G.key === "Escape" && r();
    }
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", A), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", A);
    };
  }, [o, r]), /* @__PURE__ */ a("div", { className: "hb-switcher", ref: u, style: { position: "relative" }, "data-tour": "product-switcher", children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-waffle-btn${o ? " open" : ""}`,
        onClick: i,
        "aria-expanded": o,
        "aria-label": "App launcher",
        children: /* @__PURE__ */ e(Ir, {})
      }
    ),
    o && /* @__PURE__ */ a("div", { className: "hb-waffle-panel", role: "menu", children: [
      /* @__PURE__ */ e("div", { className: "hb-waffle-header", children: "Apps" }),
      _.length > 0 && /* @__PURE__ */ a("div", { className: "hb-waffle-grid", children: [
        _.map((p) => /* @__PURE__ */ a(
          "a",
          {
            href: p.url,
            className: "hb-waffle-tile",
            onClick: r,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: `hb-waffle-tile-icon${p.id === t ? " current" : ""}`,
                  style: { background: p.color },
                  children: /* @__PURE__ */ e(vt, { icon: p.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) })
            ]
          },
          p.id
        )),
        R.map((p) => /* @__PURE__ */ a(
          "a",
          {
            href: p.url,
            className: "hb-waffle-tile",
            onClick: r,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { background: p.color },
                  children: /* @__PURE__ */ e(vt, { icon: p.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
            ]
          },
          p.id
        ))
      ] }),
      C.length > 0 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Available" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: C.map((p) => /* @__PURE__ */ a(
          "a",
          {
            href: `${l}/products/${p.id}`,
            className: "hb-waffle-tile inactive",
            onClick: r,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e("div", { className: "hb-waffle-tile-icon", style: { background: p.color }, children: /* @__PURE__ */ e(vt, { icon: p.icon }) }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) })
            ]
          },
          p.id
        )) })
      ] }),
      P.length > 0 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Beta" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: P.map((p) => /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            className: "hb-waffle-tile beta-locked",
            onClick: () => {
              b(p), r();
            },
            role: "menuitem",
            title: `${p.name} — Private Beta`,
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { background: p.color, filter: "saturate(0.5)" },
                  children: /* @__PURE__ */ e(vt, { icon: p.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge beta-badge", children: "Beta" })
            ]
          },
          p.id
        )) })
      ] }),
      w.length > 0 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Coming Soon" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: w.map((p) => /* @__PURE__ */ a(
          "div",
          {
            className: "hb-waffle-tile coming-soon",
            title: `${p.name} — Coming Soon`,
            role: "menuitem",
            children: [
              /* @__PURE__ */ a(
                "div",
                {
                  className: "hb-waffle-tile-icon",
                  style: { position: "relative", background: "#334155" },
                  children: [
                    /* @__PURE__ */ e(vt, { icon: p.icon }),
                    /* @__PURE__ */ e("div", { className: "hb-waffle-lock-overlay", children: "🔒" })
                  ]
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) }),
              /* @__PURE__ */ e("span", { className: "hb-waffle-badge coming-soon-badge", children: "Soon" })
            ]
          },
          p.id
        )) })
      ] }),
      g.length > 0 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { className: "hb-waffle-sep" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-section-label", children: "Client Products" }),
        /* @__PURE__ */ e("div", { className: "hb-waffle-grid", children: g.map((p) => /* @__PURE__ */ a(
          "a",
          {
            href: p.active ? p.url : `${l}/products/${p.id}`,
            className: `hb-waffle-tile${p.active ? "" : " inactive"}`,
            onClick: r,
            role: "menuitem",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: `hb-waffle-tile-icon${p.id === t ? " current" : ""}`,
                  style: { background: p.color },
                  children: /* @__PURE__ */ e(vt, { icon: p.icon })
                }
              ),
              /* @__PURE__ */ e("span", { className: "hb-waffle-tile-name", children: kt(p.name) })
            ]
          },
          p.id
        )) })
      ] }),
      /* @__PURE__ */ e(
        "a",
        {
          href: `${l}/hub/discover`,
          className: "hb-waffle-explore",
          onClick: r,
          children: "+ Discover more products"
        }
      )
    ] }),
    k && /* @__PURE__ */ e(
      Or,
      {
        product: k,
        apiBase: d,
        onClose: () => b(null)
      }
    )
  ] });
}
function Dr(t) {
  const n = /* @__PURE__ */ new Map();
  for (const o of t) {
    const i = o.source_product || "hub", r = {
      id: o.id,
      productId: i,
      productName: i.toUpperCase(),
      title: o.title,
      subtitle: o.subtitle,
      deepLink: o.url ?? ""
    }, l = n.get(i);
    l ? l.push(r) : n.set(i, [r]);
  }
  return Array.from(n.entries()).map(([o, i]) => ({
    productId: o,
    productName: o.toUpperCase(),
    results: i
  }));
}
function Lr(t, n, o, i = 200) {
  const [r, l] = y([]), [d, c] = y(!1), f = K(null);
  return H(() => {
    f.current && clearTimeout(f.current);
    const u = o.trim();
    if (u.length < 2 || !n) {
      l([]), c(!1);
      return;
    }
    c(!0);
    const k = new AbortController();
    return f.current = setTimeout(() => {
      fetch(
        `${t}/api/hub/search/v2?q=${encodeURIComponent(u)}`,
        { credentials: "include", signal: k.signal }
      ).then((b) => b.ok ? b.json() : Promise.resolve({ data: { results: [] } })).then((b) => {
        var v;
        const S = ((v = b.data) == null ? void 0 : v.results) ?? [];
        l(Dr(S)), c(!1);
      }).catch((b) => {
        b.name !== "AbortError" && (l([]), c(!1));
      });
    }, i), () => {
      k.abort(), f.current && clearTimeout(f.current);
    };
  }, [t, n, o, i]), { results: r, loading: d };
}
function Pr({ apiBase: t, tenantId: n }) {
  const [o, i] = y(!1), [r, l] = y(""), [d, c] = y(-1), f = K(null), { results: u, loading: k } = Lr(t, n, r), b = u.flatMap((C) => C.results), S = D(() => {
    i(!0), l(""), c(-1), setTimeout(() => {
      var C;
      return (C = f.current) == null ? void 0 : C.focus();
    }, 0);
  }, []), v = D(() => {
    i(!1), l(""), c(-1);
  }, []);
  H(() => {
    function C(R) {
      (R.metaKey || R.ctrlKey) && R.key === "k" && (R.preventDefault(), o ? v() : S()), R.key === "Escape" && o && v();
    }
    return document.addEventListener("keydown", C), () => document.removeEventListener("keydown", C);
  }, [o, S, v]);
  function g(C) {
    if (C.key === "ArrowDown")
      C.preventDefault(), c((R) => Math.min(R + 1, b.length - 1));
    else if (C.key === "ArrowUp")
      C.preventDefault(), c((R) => Math.max(R - 1, -1));
    else if (C.key === "Enter" && d >= 0) {
      const R = b[d];
      R && (window.location.href = R.deepLink, v());
    }
  }
  const _ = typeof navigator < "u" && /Mac/i.test(navigator.platform);
  return /* @__PURE__ */ a(ue, { children: [
    /* @__PURE__ */ e("div", { className: "hb-search-wrap", "data-tour": "unified-search", children: /* @__PURE__ */ a("button", { className: "hb-search-trigger", onClick: S, "aria-label": "Search (Cmd+K)", children: [
      /* @__PURE__ */ e(Tt, { size: 14 }),
      /* @__PURE__ */ e("span", { className: "hb-search-trigger-text", children: "Search everything..." }),
      /* @__PURE__ */ a("span", { className: "hb-kbd", children: [
        /* @__PURE__ */ e("kbd", { children: _ ? "⌘" : "Ctrl" }),
        /* @__PURE__ */ e("kbd", { children: "K" })
      ] })
    ] }) }),
    o && /* @__PURE__ */ e(
      "div",
      {
        className: "hb-search-overlay",
        onMouseDown: (C) => {
          C.target === C.currentTarget && v();
        },
        role: "dialog",
        "aria-label": "Search",
        "aria-modal": "true",
        children: /* @__PURE__ */ a("div", { className: "hb-search-modal", children: [
          /* @__PURE__ */ a("div", { className: "hb-search-input-row", children: [
            /* @__PURE__ */ e(Tt, { size: 18, color: "#f97316" }),
            /* @__PURE__ */ e(
              "input",
              {
                ref: f,
                className: "hb-search-input",
                placeholder: "Search everything...",
                value: r,
                onChange: (C) => {
                  l(C.target.value), c(-1);
                },
                onKeyDown: g,
                autoComplete: "off",
                spellCheck: !1
              }
            ),
            r && /* @__PURE__ */ e(
              "button",
              {
                style: { background: "none", border: "none", cursor: "pointer", padding: 0, color: "#64748b" },
                onClick: () => l(""),
                "aria-label": "Clear",
                children: /* @__PURE__ */ e(We, { size: 16 })
              }
            )
          ] }),
          /* @__PURE__ */ e(
            jr,
            {
              query: r,
              loading: k,
              results: u,
              focusedIndex: d,
              onNavigate: v
            }
          )
        ] })
      }
    )
  ] });
}
function jr({ query: t, loading: n, results: o, focusedIndex: i, onNavigate: r }) {
  if (!t.trim())
    return /* @__PURE__ */ a("div", { className: "hb-search-empty", children: [
      /* @__PURE__ */ e("div", { children: "Type to search across all products" }),
      /* @__PURE__ */ e("div", { className: "hb-search-empty-hint", children: "Contacts, tickets, invoices, devices, and more" })
    ] });
  if (n)
    return /* @__PURE__ */ a("div", { className: "hb-search-loading", children: [
      /* @__PURE__ */ e("div", { className: "hb-spinner" }),
      "Searching..."
    ] });
  if (!o.length)
    return /* @__PURE__ */ a("div", { className: "hb-search-empty", children: [
      "No results for “",
      t,
      "”"
    ] });
  let l = 0;
  return /* @__PURE__ */ e("div", { className: "hb-search-results", children: o.map((d) => /* @__PURE__ */ a("div", { children: [
    /* @__PURE__ */ a("div", { className: "hb-search-group-label", children: [
      d.productName,
      " — ",
      d.results.length,
      " result",
      d.results.length !== 1 ? "s" : ""
    ] }),
    d.results.map((c) => {
      const f = l++;
      return /* @__PURE__ */ a(
        "a",
        {
          href: c.deepLink,
          className: `hb-search-item${i === f ? " focused" : ""}`,
          onClick: r,
          children: [
            /* @__PURE__ */ e("div", { className: "hb-search-item-icon", children: c.icon ?? c.title.slice(0, 1).toUpperCase() }),
            /* @__PURE__ */ a("div", { className: "hb-search-item-body", children: [
              /* @__PURE__ */ e("div", { className: "hb-search-item-title", children: c.title }),
              c.subtitle && /* @__PURE__ */ e("div", { className: "hb-search-item-sub", children: c.subtitle })
            ] }),
            /* @__PURE__ */ e("span", { className: "hb-source-badge", children: d.productName })
          ]
        },
        c.id
      );
    })
  ] }, d.productId)) });
}
function Hr(t, n) {
  var i;
  const o = (i = n.entity_ids) == null ? void 0 : i[0];
  if (!o) return `${t}/theo`;
  switch (n.entity_type) {
    case "ticket":
      return `${t}/psa/tickets/${encodeURIComponent(o)}`;
    case "incident":
      return `${t}/oncall/incidents/${encodeURIComponent(o)}`;
    case "device":
      return `${t}/rmm/devices/${encodeURIComponent(o)}`;
    case "invoice":
      return `${t}/books/ar/invoices/${encodeURIComponent(o)}`;
    default:
      return `${t}/theo`;
  }
}
function $r(t) {
  switch (t.entity_type) {
    case "ticket":
      return "ticket";
    case "incident":
      return "incident";
    case "device":
      return "device";
    case "invoice":
      return "invoice";
    default:
      return t.entity_type ?? "details";
  }
}
function Wr(t) {
  const n = Math.floor((Date.now() - new Date(t).getTime()) / 1e3);
  return n < 60 ? "just now" : n < 3600 ? `${Math.floor(n / 60)}m ago` : n < 86400 ? `${Math.floor(n / 3600)}h ago` : `${Math.floor(n / 86400)}d ago`;
}
function Ur({
  notifications: t,
  unreadCount: n,
  open: o,
  onToggle: i,
  onClose: r,
  onMarkAllRead: l,
  onMarkRead: d,
  onDismiss: c,
  muted: f,
  onMute: u,
  onUnmute: k,
  hubUrl: b,
  sentinelInsights: S = []
}) {
  const v = K(null);
  return H(() => {
    if (!o) return;
    function g(_) {
      v.current && !v.current.contains(_.target) && r();
    }
    return document.addEventListener("mousedown", g), () => document.removeEventListener("mousedown", g);
  }, [o, r]), /* @__PURE__ */ a("div", { className: "hb-notif", ref: v, "data-tour": "notifications", children: [
    /* @__PURE__ */ a(
      "button",
      {
        className: "hb-notif-btn",
        onClick: i,
        "aria-label": `Notifications${n > 0 ? ` (${n} unread)` : ""}`,
        "aria-expanded": o,
        children: [
          /* @__PURE__ */ e(ur, { size: 18 }),
          n > 0 && /* @__PURE__ */ e("span", { className: "hb-badge", "aria-hidden": "true", children: n > 99 ? "99+" : n })
        ]
      }
    ),
    o && /* @__PURE__ */ a("div", { className: "hb-notif-dropdown", role: "dialog", "aria-label": "Notifications", children: [
      /* @__PURE__ */ a("div", { className: "hb-notif-header", children: [
        /* @__PURE__ */ e("span", { className: "hb-notif-title", children: "Notifications" }),
        n > 0 && /* @__PURE__ */ e("button", { className: "hb-notif-mark-read", onClick: l, children: "Mark all read" })
      ] }),
      S.length > 0 && /* @__PURE__ */ a("div", { className: "hb-notif-sentinel-group", role: "group", "aria-label": "THEO Insights", children: [
        /* @__PURE__ */ a(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 14px 4px",
              fontSize: 11,
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              color: "#a78bfa"
            },
            children: [
              /* @__PURE__ */ e($e, { size: 12, color: "#a78bfa" }),
              "THEO Insights"
            ]
          }
        ),
        S.map((g) => {
          const _ = g.severity === "critical" ? "#ef4444" : g.severity === "warning" ? "#f59e0b" : "#6366f1";
          return /* @__PURE__ */ a(
            "a",
            {
              href: Hr(b, g),
              onClick: r,
              className: "hb-notif-item-link",
              role: "listitem",
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: 10,
                padding: "10px 14px",
                borderBottom: "1px solid rgba(255,255,255,0.04)",
                textDecoration: "none",
                color: "inherit"
              },
              children: [
                /* @__PURE__ */ e(
                  "span",
                  {
                    "aria-hidden": !0,
                    style: {
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 20,
                      height: 20,
                      borderRadius: 6,
                      background: `${_}22`,
                      color: _,
                      flexShrink: 0,
                      marginTop: 2
                    },
                    children: /* @__PURE__ */ e(Rn, { size: 12, color: _ })
                  }
                ),
                /* @__PURE__ */ a("div", { style: { flex: 1, minWidth: 0 }, children: [
                  /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#f1f5f9",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      },
                      children: g.title
                    }
                  ),
                  /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        fontSize: 12,
                        color: "rgba(241,245,249,0.6)",
                        marginTop: 2,
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2
                      },
                      children: g.summary
                    }
                  ),
                  /* @__PURE__ */ a(
                    "div",
                    {
                      style: {
                        fontSize: 11,
                        marginTop: 4,
                        color: "#a78bfa",
                        fontWeight: 600
                      },
                      children: [
                        "Go to ",
                        $r(g),
                        " →"
                      ]
                    }
                  )
                ] })
              ]
            },
            g.id
          );
        })
      ] }),
      /* @__PURE__ */ e("div", { className: "hb-notif-list", role: "list", children: t.length === 0 ? /* @__PURE__ */ e("div", { className: "hb-notif-empty", children: S.length > 0 ? "No other notifications" : "No notifications" }) : t.slice(0, 20).map((g) => /* @__PURE__ */ a(
        "div",
        {
          className: `hb-notif-item${g.read ? "" : " unread"}`,
          role: "listitem",
          children: [
            /* @__PURE__ */ a(
              "a",
              {
                href: g.deepLink,
                className: "hb-notif-item-link",
                onClick: () => {
                  d(g.id), r();
                },
                children: [
                  /* @__PURE__ */ e(
                    "span",
                    {
                      className: "hb-notif-icon",
                      style: { background: On[g.severity] },
                      "aria-hidden": "true"
                    }
                  ),
                  /* @__PURE__ */ a("div", { className: "hb-notif-body", children: [
                    /* @__PURE__ */ a("div", { className: "hb-notif-body-title", children: [
                      g.title,
                      g.groupCount && g.groupCount > 1 && /* @__PURE__ */ e("span", { className: "hb-notif-group-badge", children: g.groupCount })
                    ] }),
                    g.body && /* @__PURE__ */ e("div", { className: "hb-notif-body-text", children: g.body }),
                    /* @__PURE__ */ a("div", { className: "hb-notif-meta", children: [
                      /* @__PURE__ */ e("span", { className: "hb-source-badge", children: g.productName }),
                      /* @__PURE__ */ e("span", { className: "hb-notif-time", children: Wr(g.createdAt) })
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ e(
              "button",
              {
                className: "hb-notif-dismiss",
                onClick: (_) => {
                  _.stopPropagation(), c(g.id);
                },
                "aria-label": "Dismiss notification",
                children: /* @__PURE__ */ e(We, { size: 14 })
              }
            )
          ]
        },
        g.id
      )) }),
      /* @__PURE__ */ e("div", { className: "hb-notif-footer", children: /* @__PURE__ */ a("div", { className: "hb-notif-footer-row", children: [
        f ? /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: k, children: "Unmute notifications" }) : /* @__PURE__ */ a("div", { className: "hb-notif-mute-group", children: [
          /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: () => u(60 * 60 * 1e3), children: "Mute 1h" }),
          /* @__PURE__ */ e("button", { className: "hb-notif-mute-btn", onClick: () => {
            const g = /* @__PURE__ */ new Date(), _ = new Date(g.getFullYear(), g.getMonth(), g.getDate() + 1);
            u(_.getTime() - g.getTime());
          }, children: "Mute today" })
        ] }),
        /* @__PURE__ */ a("a", { href: `${b}/notifications/settings`, onClick: r, className: "hb-notif-settings-link", children: [
          /* @__PURE__ */ e(Ro, { size: 14 }),
          "Settings"
        ] })
      ] }) })
    ] })
  ] });
}
function Fr({ toasts: t, onDismiss: n }) {
  return t.length === 0 ? null : /* @__PURE__ */ e("div", { className: "hb-toast-container", role: "status", "aria-live": "polite", children: t.slice(0, 3).map((o) => {
    const i = Zo.find((r) => r.id === o.productId);
    return /* @__PURE__ */ a(
      "div",
      {
        className: "hb-toast",
        style: { borderLeftColor: On[o.severity] },
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              className: "hb-toast-dot",
              style: { background: (i == null ? void 0 : i.color) || On[o.severity] }
            }
          ),
          /* @__PURE__ */ a("div", { className: "hb-toast-body", children: [
            /* @__PURE__ */ e("div", { className: "hb-toast-title", children: o.title }),
            o.body && /* @__PURE__ */ e("div", { className: "hb-toast-text", children: o.body }),
            o.deepLink && /* @__PURE__ */ e("a", { href: o.deepLink, className: "hb-toast-link", children: "View" })
          ] }),
          /* @__PURE__ */ e(
            "button",
            {
              className: "hb-toast-close",
              onClick: () => n(o.id),
              "aria-label": "Dismiss",
              children: /* @__PURE__ */ e(We, { size: 14 })
            }
          )
        ]
      },
      o.id
    );
  }) });
}
function $o({
  session: t,
  open: n,
  onToggle: o,
  onClose: i,
  onLogout: r,
  hubUrl: l,
  orgs: d = [],
  onSwitchOrg: c
}) {
  const f = K(null);
  H(() => {
    if (!n) return;
    function k(b) {
      f.current && !f.current.contains(b.target) && i();
    }
    return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
  }, [n, i]);
  function u() {
    i(), r ? r() : window.location.href = `${l}/logout`;
  }
  return /* @__PURE__ */ a("div", { className: "hb-user", ref: f, "data-tour": "user-menu", children: [
    /* @__PURE__ */ a("button", { className: "hb-user-btn", onClick: o, "aria-expanded": n, "aria-label": "User menu", children: [
      /* @__PURE__ */ e("div", { className: "hb-avatar", children: t.initials }),
      /* @__PURE__ */ e("span", { className: "hb-user-name", children: t.firstName ?? t.email.split("@")[0] }),
      /* @__PURE__ */ e(
        "svg",
        {
          width: "12",
          height: "12",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          style: { opacity: 0.5 },
          children: /* @__PURE__ */ e("path", { d: "m6 9 6 6 6-6" })
        }
      )
    ] }),
    n && /* @__PURE__ */ a("div", { className: "hb-user-dropdown", role: "menu", children: [
      /* @__PURE__ */ a("div", { className: "hb-user-info", children: [
        /* @__PURE__ */ e("div", { style: { fontWeight: 600, fontSize: 13, color: "#f1f5f9" }, children: t.firstName && t.lastName ? `${t.firstName} ${t.lastName}` : t.email.split("@")[0] }),
        /* @__PURE__ */ e("div", { className: "hb-user-email", children: t.email }),
        t.tenantName && /* @__PURE__ */ e("div", { className: "hb-user-tenant", children: t.tenantName })
      ] }),
      /* @__PURE__ */ a(
        "a",
        {
          href: `${l}/profile`,
          className: "hb-menu-item",
          onClick: i,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(br, { size: 14 }),
            "Profile"
          ]
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: `${l}/settings`,
          className: "hb-menu-item",
          onClick: i,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(Ro, { size: 14 }),
            "Hub Settings"
          ]
        }
      ),
      d.length > 1 && c && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { className: "hb-menu-sep" }),
        /* @__PURE__ */ e("div", { style: { padding: "4px 16px 2px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }, children: "Organizations" }),
        d.map((k) => /* @__PURE__ */ a(
          "button",
          {
            className: "hb-menu-item",
            onClick: () => {
              c(k.org_id), i();
            },
            role: "menuitem",
            style: { display: "flex", alignItems: "center", gap: 8 },
            children: [
              k.org_id === t.tenantId ? /* @__PURE__ */ e(hr, { size: 12, color: "#22c55e" }) : /* @__PURE__ */ e("span", { style: { width: 12, display: "inline-block" } }),
              /* @__PURE__ */ e("span", { style: { flex: 1, textAlign: "left" }, children: k.org_name })
            ]
          },
          k.org_id
        ))
      ] }),
      /* @__PURE__ */ e("div", { className: "hb-menu-sep" }),
      /* @__PURE__ */ a(
        "button",
        {
          className: "hb-menu-item danger",
          onClick: u,
          role: "menuitem",
          children: [
            /* @__PURE__ */ e(mr, { size: 14 }),
            "Log Out"
          ]
        }
      )
    ] })
  ] });
}
function Vr({ config: t, currentProduct: n = "hub", user: o, hubUrl: i = _t }) {
  return /* @__PURE__ */ e(
    "a",
    {
      href: `${i}/support`,
      className: "hb-chat-btn",
      title: "Support",
      "aria-label": "Open support",
      children: /* @__PURE__ */ e(gr, { size: 18 })
    }
  );
}
/*! @license DOMPurify 3.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.3/LICENSE */
const {
  entries: Wo,
  setPrototypeOf: mo,
  isFrozen: Gr,
  getPrototypeOf: Yr,
  getOwnPropertyDescriptor: Br
} = Object;
let {
  freeze: ye,
  seal: Ne,
  create: qt
} = Object, {
  apply: In,
  construct: Dn
} = typeof Reflect < "u" && Reflect;
ye || (ye = function(n) {
  return n;
});
Ne || (Ne = function(n) {
  return n;
});
In || (In = function(n, o) {
  for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), l = 2; l < i; l++)
    r[l - 2] = arguments[l];
  return n.apply(o, r);
});
Dn || (Dn = function(n) {
  for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++)
    i[r - 1] = arguments[r];
  return new n(...i);
});
const Yt = ve(Array.prototype.forEach), Kr = ve(Array.prototype.lastIndexOf), go = ve(Array.prototype.pop), Lt = ve(Array.prototype.push), qr = ve(Array.prototype.splice), Jt = ve(String.prototype.toLowerCase), wn = ve(String.prototype.toString), Sn = ve(String.prototype.match), Pt = ve(String.prototype.replace), Jr = ve(String.prototype.indexOf), Xr = ve(String.prototype.trim), _e = ve(Object.prototype.hasOwnProperty), xe = ve(RegExp.prototype.test), jt = Qr(TypeError);
function ve(t) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++)
      i[r - 1] = arguments[r];
    return In(t, n, i);
  };
}
function Qr(t) {
  return function() {
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    return Dn(t, o);
  };
}
function Q(t, n) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Jt;
  mo && mo(t, null);
  let i = n.length;
  for (; i--; ) {
    let r = n[i];
    if (typeof r == "string") {
      const l = o(r);
      l !== r && (Gr(n) || (n[i] = l), r = l);
    }
    t[r] = !0;
  }
  return t;
}
function Zr(t) {
  for (let n = 0; n < t.length; n++)
    _e(t, n) || (t[n] = null);
  return t;
}
function He(t) {
  const n = qt(null);
  for (const [o, i] of Wo(t))
    _e(t, o) && (Array.isArray(i) ? n[o] = Zr(i) : i && typeof i == "object" && i.constructor === Object ? n[o] = He(i) : n[o] = i);
  return n;
}
function Ht(t, n) {
  for (; t !== null; ) {
    const i = Br(t, n);
    if (i) {
      if (i.get)
        return ve(i.get);
      if (typeof i.value == "function")
        return ve(i.value);
    }
    t = Yr(t);
  }
  function o() {
    return null;
  }
  return o;
}
const xo = ye(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Tn = ye(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), _n = ye(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), ei = ye(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Mn = ye(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ti = ye(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), yo = ye(["#text"]), vo = ye(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Cn = ye(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), ko = ye(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Bt = ye(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ni = Ne(/\{\{[\w\W]*|[\w\W]*\}\}/gm), oi = Ne(/<%[\w\W]*|[\w\W]*%>/gm), ri = Ne(/\$\{[\w\W]*/gm), ii = Ne(/^data-[\-\w.\u00B7-\uFFFF]+$/), ai = Ne(/^aria-[\-\w]+$/), Uo = Ne(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), si = Ne(/^(?:\w+script|data):/i), li = Ne(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Fo = Ne(/^html$/i), ci = Ne(/^[a-z][.\w]*(-[.\w]+)+$/i);
var wo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: ai,
  ATTR_WHITESPACE: li,
  CUSTOM_ELEMENT: ci,
  DATA_ATTR: ii,
  DOCTYPE_NAME: Fo,
  ERB_EXPR: oi,
  IS_ALLOWED_URI: Uo,
  IS_SCRIPT_OR_DATA: si,
  MUSTACHE_EXPR: ni,
  TMPLIT_EXPR: ri
});
const $t = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, di = function() {
  return typeof window > "u" ? null : window;
}, pi = function(n, o) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let i = null;
  const r = "data-tt-policy-suffix";
  o && o.hasAttribute(r) && (i = o.getAttribute(r));
  const l = "dompurify" + (i ? "#" + i : "");
  try {
    return n.createPolicy(l, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + l + " could not be created."), null;
  }
}, So = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Vo() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : di();
  const n = (m) => Vo(m);
  if (n.version = "3.3.3", n.removed = [], !t || !t.document || t.document.nodeType !== $t.document || !t.Element)
    return n.isSupported = !1, n;
  let {
    document: o
  } = t;
  const i = o, r = i.currentScript, {
    DocumentFragment: l,
    HTMLTemplateElement: d,
    Node: c,
    Element: f,
    NodeFilter: u,
    NamedNodeMap: k = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: b,
    DOMParser: S,
    trustedTypes: v
  } = t, g = f.prototype, _ = Ht(g, "cloneNode"), C = Ht(g, "remove"), R = Ht(g, "nextSibling"), P = Ht(g, "childNodes"), w = Ht(g, "parentNode");
  if (typeof d == "function") {
    const m = o.createElement("template");
    m.content && m.content.ownerDocument && (o = m.content.ownerDocument);
  }
  let p, A = "";
  const {
    implementation: G,
    createNodeIterator: M,
    createDocumentFragment: L,
    getElementsByTagName: W
  } = o, {
    importNode: F
  } = i;
  let q = So();
  n.isSupported = typeof Wo == "function" && typeof w == "function" && G && G.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: j,
    ERB_EXPR: X,
    TMPLIT_EXPR: I,
    DATA_ATTR: J,
    ARIA_ATTR: ie,
    IS_SCRIPT_OR_DATA: oe,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: te
  } = wo;
  let {
    IS_ALLOWED_URI: re
  } = wo, B = null;
  const Ae = Q({}, [...xo, ...Tn, ..._n, ...Mn, ...yo]);
  let $ = null;
  const fe = Q({}, [...vo, ...Cn, ...ko, ...Bt]);
  let ae = Object.seal(qt(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), z = null, O = null;
  const V = Object.seal(qt(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ue = !0, ge = !0, Fe = !1, Xe = !0, ce = !1, De = !0, Le = !1, Ve = !1, Qe = !1, Ge = !1, bt = !1, ot = !1, Ye = !0, Mt = !1;
  const tn = "user-content-";
  let Ct = !0, Ee = !1, de = {}, Me = null;
  const rt = Q({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ut = null;
  const be = Q({}, ["audio", "video", "img", "source", "image", "track"]);
  let Be = null;
  const Ke = Q({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), mt = "http://www.w3.org/1998/Math/MathML", it = "http://www.w3.org/2000/svg", ke = "http://www.w3.org/1999/xhtml";
  let Ze = ke, Nt = !1, ze = null;
  const gt = Q({}, [mt, it, ke], wn);
  let qe = Q({}, ["mi", "mo", "mn", "ms", "mtext"]), at = Q({}, ["annotation-xml"]);
  const st = Q({}, ["title", "style", "font", "a", "script"]);
  let Oe = null;
  const At = ["application/xhtml+xml", "text/html"], lt = "text/html";
  let pe = null, et = null;
  const nn = o.createElement("form"), ct = function(s) {
    return s instanceof RegExp || s instanceof Function;
  }, Re = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(et && et === s)) {
      if ((!s || typeof s != "object") && (s = {}), s = He(s), Oe = // eslint-disable-next-line unicorn/prefer-includes
      At.indexOf(s.PARSER_MEDIA_TYPE) === -1 ? lt : s.PARSER_MEDIA_TYPE, pe = Oe === "application/xhtml+xml" ? wn : Jt, B = _e(s, "ALLOWED_TAGS") ? Q({}, s.ALLOWED_TAGS, pe) : Ae, $ = _e(s, "ALLOWED_ATTR") ? Q({}, s.ALLOWED_ATTR, pe) : fe, ze = _e(s, "ALLOWED_NAMESPACES") ? Q({}, s.ALLOWED_NAMESPACES, wn) : gt, Be = _e(s, "ADD_URI_SAFE_ATTR") ? Q(He(Ke), s.ADD_URI_SAFE_ATTR, pe) : Ke, Ut = _e(s, "ADD_DATA_URI_TAGS") ? Q(He(be), s.ADD_DATA_URI_TAGS, pe) : be, Me = _e(s, "FORBID_CONTENTS") ? Q({}, s.FORBID_CONTENTS, pe) : rt, z = _e(s, "FORBID_TAGS") ? Q({}, s.FORBID_TAGS, pe) : He({}), O = _e(s, "FORBID_ATTR") ? Q({}, s.FORBID_ATTR, pe) : He({}), de = _e(s, "USE_PROFILES") ? s.USE_PROFILES : !1, Ue = s.ALLOW_ARIA_ATTR !== !1, ge = s.ALLOW_DATA_ATTR !== !1, Fe = s.ALLOW_UNKNOWN_PROTOCOLS || !1, Xe = s.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ce = s.SAFE_FOR_TEMPLATES || !1, De = s.SAFE_FOR_XML !== !1, Le = s.WHOLE_DOCUMENT || !1, Ge = s.RETURN_DOM || !1, bt = s.RETURN_DOM_FRAGMENT || !1, ot = s.RETURN_TRUSTED_TYPE || !1, Qe = s.FORCE_BODY || !1, Ye = s.SANITIZE_DOM !== !1, Mt = s.SANITIZE_NAMED_PROPS || !1, Ct = s.KEEP_CONTENT !== !1, Ee = s.IN_PLACE || !1, re = s.ALLOWED_URI_REGEXP || Uo, Ze = s.NAMESPACE || ke, qe = s.MATHML_TEXT_INTEGRATION_POINTS || qe, at = s.HTML_INTEGRATION_POINTS || at, ae = s.CUSTOM_ELEMENT_HANDLING || {}, s.CUSTOM_ELEMENT_HANDLING && ct(s.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ae.tagNameCheck = s.CUSTOM_ELEMENT_HANDLING.tagNameCheck), s.CUSTOM_ELEMENT_HANDLING && ct(s.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ae.attributeNameCheck = s.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), s.CUSTOM_ELEMENT_HANDLING && typeof s.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ae.allowCustomizedBuiltInElements = s.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ce && (ge = !1), bt && (Ge = !0), de && (B = Q({}, yo), $ = qt(null), de.html === !0 && (Q(B, xo), Q($, vo)), de.svg === !0 && (Q(B, Tn), Q($, Cn), Q($, Bt)), de.svgFilters === !0 && (Q(B, _n), Q($, Cn), Q($, Bt)), de.mathMl === !0 && (Q(B, Mn), Q($, ko), Q($, Bt))), _e(s, "ADD_TAGS") || (V.tagCheck = null), _e(s, "ADD_ATTR") || (V.attributeCheck = null), s.ADD_TAGS && (typeof s.ADD_TAGS == "function" ? V.tagCheck = s.ADD_TAGS : (B === Ae && (B = He(B)), Q(B, s.ADD_TAGS, pe))), s.ADD_ATTR && (typeof s.ADD_ATTR == "function" ? V.attributeCheck = s.ADD_ATTR : ($ === fe && ($ = He($)), Q($, s.ADD_ATTR, pe))), s.ADD_URI_SAFE_ATTR && Q(Be, s.ADD_URI_SAFE_ATTR, pe), s.FORBID_CONTENTS && (Me === rt && (Me = He(Me)), Q(Me, s.FORBID_CONTENTS, pe)), s.ADD_FORBID_CONTENTS && (Me === rt && (Me = He(Me)), Q(Me, s.ADD_FORBID_CONTENTS, pe)), Ct && (B["#text"] = !0), Le && Q(B, ["html", "head", "body"]), B.table && (Q(B, ["tbody"]), delete z.tbody), s.TRUSTED_TYPES_POLICY) {
        if (typeof s.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw jt('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof s.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw jt('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        p = s.TRUSTED_TYPES_POLICY, A = p.createHTML("");
      } else
        p === void 0 && (p = pi(v, r)), p !== null && typeof A == "string" && (A = p.createHTML(""));
      ye && ye(s), et = s;
    }
  }, Et = Q({}, [...Tn, ..._n, ...ei]), xt = Q({}, [...Mn, ...ti]), yt = function(s) {
    let x = w(s);
    (!x || !x.tagName) && (x = {
      namespaceURI: Ze,
      tagName: "template"
    });
    const N = Jt(s.tagName), Z = Jt(x.tagName);
    return ze[s.namespaceURI] ? s.namespaceURI === it ? x.namespaceURI === ke ? N === "svg" : x.namespaceURI === mt ? N === "svg" && (Z === "annotation-xml" || qe[Z]) : !!Et[N] : s.namespaceURI === mt ? x.namespaceURI === ke ? N === "math" : x.namespaceURI === it ? N === "math" && at[Z] : !!xt[N] : s.namespaceURI === ke ? x.namespaceURI === it && !at[Z] || x.namespaceURI === mt && !qe[Z] ? !1 : !xt[N] && (st[N] || !Et[N]) : !!(Oe === "application/xhtml+xml" && ze[s.namespaceURI]) : !1;
  }, Ce = function(s) {
    Lt(n.removed, {
      element: s
    });
    try {
      w(s).removeChild(s);
    } catch {
      C(s);
    }
  }, Je = function(s, x) {
    try {
      Lt(n.removed, {
        attribute: x.getAttributeNode(s),
        from: x
      });
    } catch {
      Lt(n.removed, {
        attribute: null,
        from: x
      });
    }
    if (x.removeAttribute(s), s === "is")
      if (Ge || bt)
        try {
          Ce(x);
        } catch {
        }
      else
        try {
          x.setAttribute(s, "");
        } catch {
        }
  }, we = function(s) {
    let x = null, N = null;
    if (Qe)
      s = "<remove></remove>" + s;
    else {
      const Y = Sn(s, /^[\r\n\t ]+/);
      N = Y && Y[0];
    }
    Oe === "application/xhtml+xml" && Ze === ke && (s = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + s + "</body></html>");
    const Z = p ? p.createHTML(s) : s;
    if (Ze === ke)
      try {
        x = new S().parseFromString(Z, Oe);
      } catch {
      }
    if (!x || !x.documentElement) {
      x = G.createDocument(Ze, "template", null);
      try {
        x.documentElement.innerHTML = Nt ? A : Z;
      } catch {
      }
    }
    const ne = x.body || x.documentElement;
    return s && N && ne.insertBefore(o.createTextNode(N), ne.childNodes[0] || null), Ze === ke ? W.call(x, Le ? "html" : "body")[0] : Le ? x.documentElement : ne;
  }, Ft = function(s) {
    return M.call(
      s.ownerDocument || s,
      s,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, zt = function(s) {
    return s instanceof b && (typeof s.nodeName != "string" || typeof s.textContent != "string" || typeof s.removeChild != "function" || !(s.attributes instanceof k) || typeof s.removeAttribute != "function" || typeof s.setAttribute != "function" || typeof s.namespaceURI != "string" || typeof s.insertBefore != "function" || typeof s.hasChildNodes != "function");
  }, Ot = function(s) {
    return typeof c == "function" && s instanceof c;
  };
  function Ie(m, s, x) {
    Yt(m, (N) => {
      N.call(n, s, x, et);
    });
  }
  const Vt = function(s) {
    let x = null;
    if (Ie(q.beforeSanitizeElements, s, null), zt(s))
      return Ce(s), !0;
    const N = pe(s.nodeName);
    if (Ie(q.uponSanitizeElement, s, {
      tagName: N,
      allowedTags: B
    }), De && s.hasChildNodes() && !Ot(s.firstElementChild) && xe(/<[/\w!]/g, s.innerHTML) && xe(/<[/\w!]/g, s.textContent) || s.nodeType === $t.progressingInstruction || De && s.nodeType === $t.comment && xe(/<[/\w]/g, s.data))
      return Ce(s), !0;
    if (!(V.tagCheck instanceof Function && V.tagCheck(N)) && (!B[N] || z[N])) {
      if (!z[N] && It(N) && (ae.tagNameCheck instanceof RegExp && xe(ae.tagNameCheck, N) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(N)))
        return !1;
      if (Ct && !Me[N]) {
        const Z = w(s) || s.parentNode, ne = P(s) || s.childNodes;
        if (ne && Z) {
          const Y = ne.length;
          for (let ee = Y - 1; ee >= 0; --ee) {
            const se = _(ne[ee], !0);
            se.__removalCount = (s.__removalCount || 0) + 1, Z.insertBefore(se, R(s));
          }
        }
      }
      return Ce(s), !0;
    }
    return s instanceof f && !yt(s) || (N === "noscript" || N === "noembed" || N === "noframes") && xe(/<\/no(script|embed|frames)/i, s.innerHTML) ? (Ce(s), !0) : (ce && s.nodeType === $t.text && (x = s.textContent, Yt([j, X, I], (Z) => {
      x = Pt(x, Z, " ");
    }), s.textContent !== x && (Lt(n.removed, {
      element: s.cloneNode()
    }), s.textContent = x)), Ie(q.afterSanitizeElements, s, null), !1);
  }, Rt = function(s, x, N) {
    if (O[x] || Ye && (x === "id" || x === "name") && (N in o || N in nn))
      return !1;
    if (!(ge && !O[x] && xe(J, x))) {
      if (!(Ue && xe(ie, x))) {
        if (!(V.attributeCheck instanceof Function && V.attributeCheck(x, s))) {
          if (!$[x] || O[x]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(It(s) && (ae.tagNameCheck instanceof RegExp && xe(ae.tagNameCheck, s) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(s)) && (ae.attributeNameCheck instanceof RegExp && xe(ae.attributeNameCheck, x) || ae.attributeNameCheck instanceof Function && ae.attributeNameCheck(x, s)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              x === "is" && ae.allowCustomizedBuiltInElements && (ae.tagNameCheck instanceof RegExp && xe(ae.tagNameCheck, N) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(N)))
            ) return !1;
          } else if (!Be[x]) {
            if (!xe(re, Pt(N, le, ""))) {
              if (!((x === "src" || x === "xlink:href" || x === "href") && s !== "script" && Jr(N, "data:") === 0 && Ut[s])) {
                if (!(Fe && !xe(oe, Pt(N, le, "")))) {
                  if (N)
                    return !1;
                }
              }
            }
          }
        }
      }
    }
    return !0;
  }, It = function(s) {
    return s !== "annotation-xml" && Sn(s, te);
  }, h = function(s) {
    Ie(q.beforeSanitizeAttributes, s, null);
    const {
      attributes: x
    } = s;
    if (!x || zt(s))
      return;
    const N = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: $,
      forceKeepAttr: void 0
    };
    let Z = x.length;
    for (; Z--; ) {
      const ne = x[Z], {
        name: Y,
        namespaceURI: ee,
        value: se
      } = ne, me = pe(Y), dt = se;
      let he = Y === "value" ? dt : Xr(dt);
      if (N.attrName = me, N.attrValue = he, N.keepAttr = !0, N.forceKeepAttr = void 0, Ie(q.uponSanitizeAttribute, s, N), he = N.attrValue, Mt && (me === "id" || me === "name") && (Je(Y, s), he = tn + he), De && xe(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, he)) {
        Je(Y, s);
        continue;
      }
      if (me === "attributename" && Sn(he, "href")) {
        Je(Y, s);
        continue;
      }
      if (N.forceKeepAttr)
        continue;
      if (!N.keepAttr) {
        Je(Y, s);
        continue;
      }
      if (!Xe && xe(/\/>/i, he)) {
        Je(Y, s);
        continue;
      }
      ce && Yt([j, X, I], (Pe) => {
        he = Pt(he, Pe, " ");
      });
      const Se = pe(s.nodeName);
      if (!Rt(Se, me, he)) {
        Je(Y, s);
        continue;
      }
      if (p && typeof v == "object" && typeof v.getAttributeType == "function" && !ee)
        switch (v.getAttributeType(Se, me)) {
          case "TrustedHTML": {
            he = p.createHTML(he);
            break;
          }
          case "TrustedScriptURL": {
            he = p.createScriptURL(he);
            break;
          }
        }
      if (he !== dt)
        try {
          ee ? s.setAttributeNS(ee, Y, he) : s.setAttribute(Y, he), zt(s) ? Ce(s) : go(n.removed);
        } catch {
          Je(Y, s);
        }
    }
    Ie(q.afterSanitizeAttributes, s, null);
  }, U = function m(s) {
    let x = null;
    const N = Ft(s);
    for (Ie(q.beforeSanitizeShadowDOM, s, null); x = N.nextNode(); )
      Ie(q.uponSanitizeShadowNode, x, null), Vt(x), h(x), x.content instanceof l && m(x.content);
    Ie(q.afterSanitizeShadowDOM, s, null);
  };
  return n.sanitize = function(m) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = null, N = null, Z = null, ne = null;
    if (Nt = !m, Nt && (m = "<!-->"), typeof m != "string" && !Ot(m))
      if (typeof m.toString == "function") {
        if (m = m.toString(), typeof m != "string")
          throw jt("dirty is not a string, aborting");
      } else
        throw jt("toString is not a function");
    if (!n.isSupported)
      return m;
    if (Ve || Re(s), n.removed = [], typeof m == "string" && (Ee = !1), Ee) {
      if (m.nodeName) {
        const se = pe(m.nodeName);
        if (!B[se] || z[se])
          throw jt("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (m instanceof c)
      x = we("<!---->"), N = x.ownerDocument.importNode(m, !0), N.nodeType === $t.element && N.nodeName === "BODY" || N.nodeName === "HTML" ? x = N : x.appendChild(N);
    else {
      if (!Ge && !ce && !Le && // eslint-disable-next-line unicorn/prefer-includes
      m.indexOf("<") === -1)
        return p && ot ? p.createHTML(m) : m;
      if (x = we(m), !x)
        return Ge ? null : ot ? A : "";
    }
    x && Qe && Ce(x.firstChild);
    const Y = Ft(Ee ? m : x);
    for (; Z = Y.nextNode(); )
      Vt(Z), h(Z), Z.content instanceof l && U(Z.content);
    if (Ee)
      return m;
    if (Ge) {
      if (bt)
        for (ne = L.call(x.ownerDocument); x.firstChild; )
          ne.appendChild(x.firstChild);
      else
        ne = x;
      return ($.shadowroot || $.shadowrootmode) && (ne = F.call(i, ne, !0)), ne;
    }
    let ee = Le ? x.outerHTML : x.innerHTML;
    return Le && B["!doctype"] && x.ownerDocument && x.ownerDocument.doctype && x.ownerDocument.doctype.name && xe(Fo, x.ownerDocument.doctype.name) && (ee = "<!DOCTYPE " + x.ownerDocument.doctype.name + `>
` + ee), ce && Yt([j, X, I], (se) => {
      ee = Pt(ee, se, " ");
    }), p && ot ? p.createHTML(ee) : ee;
  }, n.setConfig = function() {
    let m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Re(m), Ve = !0;
  }, n.clearConfig = function() {
    et = null, Ve = !1;
  }, n.isValidAttribute = function(m, s, x) {
    et || Re({});
    const N = pe(m), Z = pe(s);
    return Rt(N, Z, x);
  }, n.addHook = function(m, s) {
    typeof s == "function" && Lt(q[m], s);
  }, n.removeHook = function(m, s) {
    if (s !== void 0) {
      const x = Kr(q[m], s);
      return x === -1 ? void 0 : qr(q[m], x, 1)[0];
    }
    return go(q[m]);
  }, n.removeHooks = function(m) {
    q[m] = [];
  }, n.removeAllHooks = function() {
    q = So();
  }, n;
}
var hi = Vo();
const ui = {
  "theonepsa.com": "psa",
  "theonecrm.app": "crm",
  "theonermm.app": "rmm",
  "theonesecurity.app": "security",
  "theonebackups.app": "backups",
  "theoneprojects.app": "projects",
  "theonebooks.app": "books",
  "voice.theonestack.com": "voice",
  "theonestudio.app": "ai-studio",
  "theonelivekit.app": "livekit",
  // 'theonemission.app' removed 2026-04-15: Mission is now a standalone app at app.theonemission.app (no Hub Bar)
  "theoneams.com": "ams",
  "theonefleet.app": "fleet",
  "theonepeople.app": "people",
  "theonecmdb.app": "cmdb",
  "theoneoncall.app": "oncall",
  "theonevisitor.app": "visitor",
  "theonelegal.app": "legal",
  "mspcollective.io": "collective",
  "theoneportal.app": "portal",
  "theonebridge.app": "bridge",
  "theonecanvas.app": "canvas",
  "theonemigrate.app": "migrate",
  "theonebrand.app": "brand",
  "ops.theonestack.com": "ops-center",
  "theonestack.com": "hub"
};
function fi(t) {
  for (const [n, o] of Object.entries(ui))
    if (t.includes(n)) return o;
  return null;
}
const bi = [
  [/\/tickets?\/([\w-]+)/, "ticket"],
  [/\/companies?\/([\w-]+)/, "company"],
  [/\/contacts?\/([\w-]+)/, "contact"],
  [/\/devices?\/([\w-]+)/, "device"],
  [/\/invoices?\/([\w-]+)/, "invoice"],
  [/\/opportunities?\/([\w-]+)/, "opportunity"],
  [/\/projects?\/([\w-]+)/, "project"],
  [/\/incidents?\/([\w-]+)/, "incident"],
  [/\/contracts?\/([\w-]+)/, "contract"],
  [/\/employees?\/([\w-]+)/, "employee"],
  [/\/configurations?\/([\w-]+)/, "configuration_item"],
  [/\/alerts?\/([\w-]+)/, "alert"],
  [/\/calls?\/([\w-]+)/, "call"],
  [/\/recordings?\/([\w-]+)/, "call"],
  [/\/recaps?\/([\w-]+)/, "call"]
];
function mi(t) {
  for (const [n, o] of bi) {
    const i = t.match(n);
    if (i != null && i[1] && i[1] !== "new" && i[1] !== "list")
      return { entity_type: o, entity_id: i[1] };
  }
  return {};
}
function Nn() {
  const t = fi(window.location.hostname), { entity_type: n, entity_id: o } = mi(window.location.pathname);
  return { product: t, page: window.location.pathname, entity_type: n, entity_id: o };
}
const An = {
  ticket: [
    { label: "Summarize this ticket", prompt: "Summarize this ticket including its history and current status." },
    { label: "Find similar tickets", prompt: "Search for similar tickets that might be related to this one." },
    { label: "Draft a response", prompt: "Draft a professional response to the client for this ticket." },
    { label: "Check SLA status", prompt: "What is the SLA status for this ticket? Is it at risk of breaching?" }
  ],
  company: [
    { label: "Full company picture", prompt: "Give me a complete picture of this company — tickets, revenue, devices, security posture." },
    { label: "Open tickets", prompt: "What are the open tickets for this company?" },
    { label: "Revenue summary", prompt: "Show me the revenue summary for this company." },
    { label: "Device health", prompt: "What is the device health status for this company?" }
  ],
  device: [
    { label: "What's wrong?", prompt: "What's wrong with this device? Show me recent alerts and issues." },
    { label: "Recent alerts", prompt: "Show me the recent alerts for this device." },
    { label: "Similar issues", prompt: "Are there similar issues on other devices?" }
  ],
  invoice: [
    { label: "Payment status", prompt: "What is the payment status of this invoice?" },
    { label: "Customer history", prompt: "Show me the payment history for this customer." }
  ],
  call: [
    { label: "Call summary", prompt: "Summarize this call — what was discussed, sentiment, and any action items." },
    { label: "Extract action items", prompt: "Extract all action items from this call and suggest ticket creation for each." },
    { label: "Full transcript", prompt: "Show me the full transcript of this call." },
    { label: "Follow up", prompt: "Draft a follow-up message to the caller based on this call." }
  ],
  contact: [
    { label: "Text this contact", prompt: "Help me draft and send an SMS to this contact." },
    { label: "Call this contact", prompt: "Connect me to this contact via phone." },
    { label: "Communication history", prompt: "Show me all recent calls and messages with this contact." },
    { label: "Email this contact", prompt: "Help me draft and send an email to this contact." }
  ],
  dashboard: [
    { label: "What needs attention?", prompt: "What needs my attention today? Show me critical items across all products." },
    { label: "Show overdue items", prompt: "What items are overdue — tickets, invoices, tasks?" },
    { label: "SLA alerts", prompt: "Are there any SLA alerts or at-risk tickets right now?" },
    { label: "Revenue this month", prompt: "What's our revenue looking like this month?" }
  ]
};
function gi(t) {
  return t.entity_type && An[t.entity_type] ? An[t.entity_type] : t.page === "/" || t.page.includes("dashboard") ? An.dashboard : [
    { label: "What needs attention?", prompt: "What needs my attention today?" },
    { label: "Search tickets", prompt: "Search for recent open tickets." },
    { label: "Company health", prompt: "Show me a summary of company health scores." }
  ];
}
const Qt = "jarvis_messages", Go = 50;
function xi() {
  try {
    const t = sessionStorage.getItem(Qt);
    return t ? JSON.parse(t).slice(-Go) : [];
  } catch {
    return [];
  }
}
function yi(t) {
  try {
    sessionStorage.setItem(Qt, JSON.stringify(t.slice(-Go)));
  } catch {
    sessionStorage.removeItem(Qt);
  }
}
let vi = 0;
function Kt() {
  return `jm_${Date.now()}_${++vi}`;
}
function ki(t, n, o) {
  const [i, r] = y(xi), [l, d] = y(!1), [c, f] = y(Nn), [u, k] = y([]), b = K(null), S = K("");
  H(() => {
    const R = () => {
      const w = Nn();
      f(w), k(gi(w));
    };
    R(), window.addEventListener("popstate", R);
    const P = new MutationObserver(() => {
      Nn().page !== c.page && R();
    });
    return P.observe(document.querySelector("title") || document.head, { childList: !0, subtree: !0 }), () => {
      window.removeEventListener("popstate", R), P.disconnect();
    };
  }, [c.page]), H(() => {
    yi(i);
  }, [i]);
  const v = D(async (R) => {
    if (!R.trim() || l || !n) return;
    const P = {
      id: Kt(),
      role: "user",
      content: R.trim(),
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    }, w = {
      id: Kt(),
      role: "assistant",
      content: "",
      tool_calls: [],
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
    r((A) => [...A, P, w]), d(!0), S.current = "";
    const p = new AbortController();
    b.current = p;
    try {
      const G = {
        model: "gpt-4.1-mini",
        messages: [...i.slice(-18), P].map((j) => ({
          role: j.role,
          content: j.content
        })),
        stream: !0,
        context: {
          product: c.product,
          entity_type: c.entity_type,
          entity_id: c.entity_id,
          page_url: window.location.href
        }
      }, M = await fetch(`${t}/api/ai/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-tenant-id": n,
          "x-ai-tier": "jarvis_free"
        },
        credentials: "include",
        body: JSON.stringify(G),
        signal: p.signal
      });
      if (!M.ok) {
        const j = await M.json().catch(() => ({ error: M.statusText }));
        throw new Error(j.error || j.message || `Error ${M.status}`);
      }
      if (!M.body) throw new Error("No response body");
      const L = M.body.getReader(), W = new TextDecoder();
      let F = "";
      const q = [];
      for (; ; ) {
        const { done: j, value: X } = await L.read();
        if (j) break;
        F += W.decode(X, { stream: !0 });
        const I = F.split(`
`);
        F = I.pop() || "";
        for (const J of I) {
          if (!J.startsWith("data: ")) continue;
          const ie = J.slice(6).trim();
          if (ie === "[DONE]") break;
          try {
            const oe = JSON.parse(ie);
            if (oe.type === "content_delta" && oe.text) {
              S.current += oe.text;
              const le = S.current;
              r((te) => {
                const re = [...te], B = re[re.length - 1];
                return B && B.id === w.id && (re[re.length - 1] = { ...B, content: le }), re;
              });
            } else if (oe.type === "tool_use_start" && oe.name) {
              q.push({ name: oe.name, status: "running" });
              const le = [...q];
              r((te) => {
                const re = [...te], B = re[re.length - 1];
                return B && B.id === w.id && (re[re.length - 1] = { ...B, tool_calls: le }), re;
              });
            } else if (oe.type === "message_stop") {
              q.forEach((te) => {
                te.status === "running" && (te.status = "done");
              });
              const le = [...q];
              r((te) => {
                const re = [...te], B = re[re.length - 1];
                return B && B.id === w.id && (re[re.length - 1] = { ...B, tool_calls: le }), re;
              });
            } else if (oe.type === "error")
              throw new Error(oe.message || "Stream error");
          } catch (oe) {
            if (oe instanceof Error && oe.message !== "Stream error") continue;
            throw oe;
          }
        }
      }
    } catch (A) {
      if (!(A instanceof DOMException && A.name === "AbortError")) {
        const G = A instanceof Error ? A.message : "Something went wrong. Please try again.";
        r((M) => {
          const L = [...M], W = L[L.length - 1];
          return W && W.id === w.id && (L[L.length - 1] = {
            ...W,
            content: W.content || G,
            error: !0
          }), L;
        });
      }
    } finally {
      d(!1), b.current = null;
    }
  }, [t, n, i, l, c]), g = D(() => {
    b.current && (b.current.abort(), b.current = null);
  }, []), _ = D(() => {
    r([]), sessionStorage.removeItem(Qt);
  }, []), C = D((R, P) => {
    const w = {
      id: Kt(),
      role: "user",
      content: R,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    }, p = {
      id: Kt(),
      role: "assistant",
      content: P,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
    r((A) => [...A, w, p]);
  }, []);
  return {
    messages: i,
    streaming: l,
    context: c,
    quickActions: u,
    sendMessage: v,
    stopStreaming: g,
    clearMessages: _,
    addMessages: C
  };
}
const wi = 0.01, Si = 800, Ti = 100;
function _i(t, n, o) {
  const [i, r] = y("idle"), [l, d] = y(null), [c, f] = y(null), u = K(null), k = K([]), b = K(null), S = K(null), v = K(null), g = K(null), _ = K(null), C = K(null), R = K(null), P = K(!0);
  H(() => (P.current = !0, () => {
    P.current = !1, w();
  }), []);
  const w = D(() => {
    var j;
    C.current && (clearInterval(C.current), C.current = null), ((j = u.current) == null ? void 0 : j.state) === "recording" && u.current.stop(), u.current = null, k.current = [], v.current && (v.current.disconnect(), v.current = null), g.current && (g.current.getTracks().forEach((X) => X.stop()), g.current = null), p();
  }, []), p = D(() => {
    if (R.current) {
      try {
        R.current.stop();
      } catch {
      }
      R.current = null;
    }
  }, []), A = D((j) => {
    b.current || (b.current = new AudioContext());
    const X = b.current, I = X.createAnalyser();
    I.fftSize = 512, S.current = I;
    const J = X.createMediaStreamSource(j);
    J.connect(I), v.current = J;
    const ie = new Float32Array(I.fftSize);
    _.current = null, C.current = setInterval(() => {
      I.getFloatTimeDomainData(ie);
      let oe = 0;
      for (let te = 0; te < ie.length; te++)
        oe += ie[te] * ie[te];
      Math.sqrt(oe / ie.length) < wi ? _.current ? Date.now() - _.current >= Si && L() : _.current = Date.now() : _.current = null;
    }, Ti);
  }, []), G = D(async (j) => {
    if (!(!n || !P.current)) {
      r("processing"), f(null);
      try {
        const X = new FormData();
        X.append("audio", j, "recording.webm");
        const I = await fetch(`${t}/api/v1/theo/voice-chat/stream`, {
          method: "POST",
          headers: {
            "x-tenant-id": n
          },
          credentials: "include",
          body: X
        });
        if (!P.current) return;
        if (I.status === 403) {
          f("Voice mode requires a Pro subscription."), r("idle");
          return;
        }
        if (!I.ok) {
          const ie = await I.json().catch(() => ({ error: `Error ${I.status}` }));
          throw new Error(ie.error || `Error ${I.status}`);
        }
        const J = await I.json();
        if (!P.current) return;
        if (!J.transcript) {
          r("idle");
          return;
        }
        d({
          transcript: J.transcript,
          response_text: J.response_text
        }), J.audio_base64 ? await M(J.audio_base64, J.content_type) : r("idle");
      } catch (X) {
        if (!P.current) return;
        const I = X instanceof Error ? X.message : "Voice request failed";
        console.error("[useVoiceChat] sendAudio error:", X), f(I), r("idle");
      }
    }
  }, [t, n]), M = D(async (j, X) => {
    if (P.current) {
      r("playing");
      try {
        b.current || (b.current = new AudioContext());
        const I = b.current, J = atob(j), ie = new Uint8Array(J.length);
        for (let te = 0; te < J.length; te++)
          ie[te] = J.charCodeAt(te);
        let oe;
        if (X.includes("pcm") || X.includes("raw")) {
          const te = new Int16Array(ie.buffer);
          oe = I.createBuffer(1, te.length, 16e3);
          const re = oe.getChannelData(0);
          for (let B = 0; B < te.length; B++)
            re[B] = te[B] / 32768;
        } else
          oe = await I.decodeAudioData(ie.buffer.slice(0));
        if (!P.current) return;
        const le = I.createBufferSource();
        le.buffer = oe, le.connect(I.destination), R.current = le, le.onended = () => {
          R.current = null, P.current && r("idle");
        }, le.start();
      } catch (I) {
        console.error("[useVoiceChat] playAudio error:", I), P.current && r("idle");
      }
    }
  }, []), L = D(() => {
    C.current && (clearInterval(C.current), C.current = null), v.current && (v.current.disconnect(), v.current = null);
    const j = u.current;
    j && j.state === "recording" && j.stop();
  }, []), W = D(async () => {
    if (!o) {
      f("Voice mode requires a Pro subscription.");
      return;
    }
    f(null);
    try {
      const j = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: !0,
          noiseSuppression: !0,
          sampleRate: 16e3
        }
      });
      if (!P.current) {
        j.getTracks().forEach((I) => I.stop());
        return;
      }
      g.current = j, k.current = [];
      const X = new MediaRecorder(j, {
        mimeType: MediaRecorder.isTypeSupported("audio/webm;codecs=opus") ? "audio/webm;codecs=opus" : "audio/webm"
      });
      X.ondataavailable = (I) => {
        I.data.size > 0 && k.current.push(I.data);
      }, X.onstop = () => {
        const I = k.current;
        if (k.current = [], j.getTracks().forEach((J) => J.stop()), g.current = null, I.length > 0) {
          const J = new Blob(I, { type: X.mimeType });
          G(J);
        } else
          P.current && r("idle");
      }, u.current = X, X.start(250), A(j), r("recording");
    } catch (j) {
      console.error("[useVoiceChat] getUserMedia error:", j), j instanceof DOMException && j.name === "NotAllowedError" ? f("Microphone access denied. Please allow microphone access in your browser settings.") : f("Could not access microphone."), r("idle");
    }
  }, [o, G, A]), F = D(() => {
    switch (i) {
      case "idle":
        W();
        break;
      case "recording":
        L();
        break;
      case "playing":
        p(), r("idle"), setTimeout(() => {
          P.current && W();
        }, 100);
        break;
    }
  }, [i, W, L, p]), q = D(() => {
    w(), r("idle"), f(null);
  }, [w]);
  return {
    state: i,
    lastResult: l,
    error: c,
    toggleVoice: F,
    stopVoice: q,
    isActive: i !== "idle"
  };
}
function Mi(t) {
  return t ? t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/```(\w*)\n?([\s\S]*?)```/g, '<pre class="hb-jv-code-block"><code>$2</code></pre>').replace(/`([^`]+)`/g, '<code class="hb-jv-inline-code">$1</code>').replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\*(.+?)\*/g, "<em>$1</em>").replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="hb-jv-link">$1</a>').replace(/^[•\-\*] (.+)$/gm, "<li>$1</li>").replace(/^\d+\. (.+)$/gm, "<li>$1</li>").replace(/(<li>[\s\S]*?<\/li>)/g, '<ul class="hb-jv-list">$1</ul>').replace(/<\/ul>\s*<ul class="hb-jv-list">/g, "").replace(/\n/g, "<br>") : "";
}
const Ci = {
  search_tickets: "Searching tickets",
  get_ticket: "Fetching ticket details",
  create_ticket: "Creating ticket",
  update_ticket: "Updating ticket",
  get_company_info: "Looking up company",
  search_companies: "Searching companies",
  search_contacts: "Searching contacts",
  get_deals: "Fetching deals",
  get_invoices: "Fetching invoices",
  get_revenue_summary: "Calculating revenue",
  get_device_status: "Checking device status",
  search_devices: "Searching devices",
  run_device_command: "Running command",
  get_security_alerts: "Checking security alerts",
  send_message: "Sending message",
  get_call_history: "Fetching call history",
  get_company_360: "Building company overview",
  get_health_score: "Calculating health score",
  get_briefing: "Generating daily briefing",
  cross_search: "Searching across products"
};
function Ni({ tool: t }) {
  const n = Ci[t.name] || t.name.replace(/_/g, " "), o = t.status === "running", i = t.status === "error";
  return /* @__PURE__ */ a("div", { className: `hb-jv-tool-call${o ? " running" : ""}${i ? " error" : ""}`, children: [
    /* @__PURE__ */ e("div", { className: "hb-jv-tool-icon", children: o ? /* @__PURE__ */ e("span", { className: "hb-jv-tool-spinner" }) : i ? /* @__PURE__ */ e("span", { style: { color: "#f87171" }, children: "!" }) : /* @__PURE__ */ e("span", { style: { color: "#34d399" }, children: "✓" }) }),
    /* @__PURE__ */ a("span", { className: "hb-jv-tool-label", children: [
      n,
      o ? "…" : ""
    ] }),
    t.summary && /* @__PURE__ */ e("span", { className: "hb-jv-tool-summary", children: t.summary })
  ] });
}
function Ai({ message: t, isStreaming: n }) {
  if (t.role === "user")
    return /* @__PURE__ */ e("div", { className: "hb-jv-msg hb-jv-msg-user", children: /* @__PURE__ */ e("div", { className: "hb-jv-bubble hb-jv-bubble-user", children: t.content }) });
  const i = t.content.length > 0, r = t.tool_calls && t.tool_calls.length > 0;
  return /* @__PURE__ */ a("div", { className: "hb-jv-msg hb-jv-msg-assistant", children: [
    /* @__PURE__ */ e("div", { className: "hb-jv-avatar", children: /* @__PURE__ */ e($e, { size: 14, color: "#f97316" }) }),
    /* @__PURE__ */ a("div", { className: "hb-jv-bubble-wrap", children: [
      r && /* @__PURE__ */ e("div", { className: "hb-jv-tool-calls", children: t.tool_calls.map((l, d) => /* @__PURE__ */ e(Ni, { tool: l }, d)) }),
      i && /* @__PURE__ */ e(
        "div",
        {
          className: `hb-jv-bubble hb-jv-bubble-assistant${t.error ? " error" : ""}`,
          dangerouslySetInnerHTML: { __html: hi.sanitize(Mi(t.content)) }
        }
      ),
      !i && n && /* @__PURE__ */ e("div", { className: "hb-jv-bubble hb-jv-bubble-assistant", children: /* @__PURE__ */ a("span", { className: "hb-jv-typing", children: [
        /* @__PURE__ */ e("span", {}),
        /* @__PURE__ */ e("span", {}),
        /* @__PURE__ */ e("span", {})
      ] }) })
    ] })
  ] });
}
function Ei({ actions: t, onSelect: n, disabled: o }) {
  return t.length === 0 ? null : /* @__PURE__ */ e("div", { className: "hb-jv-quick-actions", children: t.map((i, r) => /* @__PURE__ */ e(
    "button",
    {
      className: "hb-jv-quick-chip",
      onClick: () => n(i.prompt),
      disabled: o,
      children: i.label
    },
    r
  )) });
}
function zi({
  apiBase: t,
  tenantId: n,
  userId: o,
  entitlements: i
}) {
  const [r, l] = y(!1), { messages: d, streaming: c, context: f, quickActions: u, sendMessage: k, stopStreaming: b, clearMessages: S, addMessages: v } = ki(t, n), [g, _] = y(""), C = K(null), R = K(null), [P] = y(!1), w = !!i && (i.includes("theo_pro") || i.includes("theo_team") || i.includes("theo_enterprise") || i.includes("theo_voice")), { state: p, lastResult: A, error: G, toggleVoice: M, stopVoice: L, isActive: W } = _i(t, n, w);
  H(() => {
    const I = (J) => {
      (J.metaKey || J.ctrlKey) && J.key === "j" && (J.preventDefault(), l((ie) => !ie)), J.key === "Escape" && r && l(!1);
    };
    return document.addEventListener("keydown", I), () => document.removeEventListener("keydown", I);
  }, [r]), H(() => {
    C.current && C.current.scrollIntoView({ behavior: "smooth" });
  }, [d]), H(() => {
    r && R.current && setTimeout(() => {
      var I;
      return (I = R.current) == null ? void 0 : I.focus();
    }, 100);
  }, [r]), H(() => {
    A && v(A.transcript, A.response_text);
  }, [A, v]), H(() => {
    !r && W && L();
  }, [r, W, L]);
  const F = D(() => {
    !g.trim() || c || (k(g.trim()), _(""));
  }, [g, c, k]), q = D((I) => {
    k(I);
  }, [k]), j = D((I) => {
    I.key === "Enter" && !I.shiftKey && (I.preventDefault(), F());
  }, [F]), X = r ? Zt(
    /* @__PURE__ */ e("div", { className: "hb-jv-overlay", onClick: () => l(!1), children: /* @__PURE__ */ a(
      "div",
      {
        className: "hb-jv-panel",
        onClick: (I) => I.stopPropagation(),
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "THEO AI Assistant",
        children: [
          /* @__PURE__ */ a("div", { className: "hb-jv-header", children: [
            /* @__PURE__ */ a("div", { className: "hb-jv-header-left", children: [
              /* @__PURE__ */ e($e, { size: 16, color: "#f97316" }),
              /* @__PURE__ */ e("span", { className: "hb-jv-header-title", children: "THEO" })
            ] }),
            /* @__PURE__ */ a("div", { className: "hb-jv-header-right", children: [
              d.length > 0 && /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-clear-btn",
                  onClick: S,
                  title: "Clear conversation",
                  "aria-label": "Clear conversation",
                  children: "Clear"
                }
              ),
              /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-close-btn",
                  onClick: () => l(!1),
                  "aria-label": "Close THEO",
                  children: /* @__PURE__ */ e(We, { size: 16 })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a("div", { className: "hb-jv-messages", children: [
            d.length === 0 ? /* @__PURE__ */ a("div", { className: "hb-jv-welcome", children: [
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-icon", children: /* @__PURE__ */ e($e, { size: 28, color: "#f97316" }) }),
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-title", children: "Hey, I'm THEO" }),
              /* @__PURE__ */ e("div", { className: "hb-jv-welcome-sub", children: "Your AI operations assistant for The One Stack. I can help you with tickets, clients, devices, and more." }),
              f.product && /* @__PURE__ */ a("div", { className: "hb-jv-welcome-context", children: [
                "Currently viewing: ",
                /* @__PURE__ */ e("strong", { children: f.product.toUpperCase() }),
                f.entity_type && ` — ${f.entity_type}`,
                f.entity_id && ` ${f.entity_id}`
              ] })
            ] }) : d.map((I, J) => /* @__PURE__ */ e(
              Ai,
              {
                message: I,
                isStreaming: c && J === d.length - 1 && I.role === "assistant"
              },
              I.id
            )),
            /* @__PURE__ */ e("div", { ref: C })
          ] }),
          d.length === 0 && /* @__PURE__ */ e(
            Ei,
            {
              actions: u,
              onSelect: q,
              disabled: c
            }
          ),
          G && /* @__PURE__ */ e("div", { className: "hb-jv-voice-toast", children: G }),
          /* @__PURE__ */ a("div", { className: "hb-jv-input-area", children: [
            W && /* @__PURE__ */ a("div", { className: "hb-jv-voice-indicator", children: [
              /* @__PURE__ */ e("span", { className: "hb-jv-voice-dot" }),
              /* @__PURE__ */ e("span", { children: p === "recording" ? "Listening..." : p === "processing" ? "Thinking..." : p === "playing" ? "Speaking..." : "" }),
              /* @__PURE__ */ e("button", { className: "hb-jv-voice-end", onClick: L, children: "End voice" })
            ] }),
            /* @__PURE__ */ a("div", { className: "hb-jv-input-row", children: [
              /* @__PURE__ */ e(
                "textarea",
                {
                  ref: R,
                  className: "hb-jv-input",
                  placeholder: W ? "Voice mode active — speak or type..." : "Ask THEO anything...",
                  value: g,
                  onChange: (I) => _(I.target.value),
                  onKeyDown: j,
                  rows: 1,
                  disabled: c || p === "processing"
                }
              ),
              /* @__PURE__ */ e(
                "button",
                {
                  className: `hb-jv-mic-btn${p === "recording" ? " recording" : ""}${p === "processing" ? " processing" : ""}${p === "playing" ? " playing" : ""}${w ? "" : " disabled"}`,
                  onClick: w ? M : void 0,
                  title: w ? p === "recording" ? "Stop recording" : p === "playing" ? "Interrupt & speak" : "Start voice mode" : "Voice mode — upgrade to Pro",
                  "aria-label": w ? "Toggle voice mode" : "Voice mode requires Pro subscription",
                  disabled: c || p === "processing",
                  children: /* @__PURE__ */ e(Xt, { size: 16 })
                }
              ),
              c ? /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-stop-btn",
                  onClick: b,
                  title: "Stop generating",
                  "aria-label": "Stop generating",
                  children: /* @__PURE__ */ e("span", { className: "hb-jv-stop-icon" })
                }
              ) : /* @__PURE__ */ e(
                "button",
                {
                  className: "hb-jv-send-btn",
                  onClick: F,
                  disabled: !g.trim(),
                  title: "Send message",
                  "aria-label": "Send message",
                  children: /* @__PURE__ */ a("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [
                    /* @__PURE__ */ e("path", { d: "M22 2L11 13" }),
                    /* @__PURE__ */ e("path", { d: "M22 2L15 22L11 13L2 9L22 2Z" })
                  ] })
                }
              )
            ] }),
            /* @__PURE__ */ a("div", { className: "hb-jv-input-hint", children: [
              /* @__PURE__ */ a("span", { className: "hb-jv-kbd-hint", children: [
                /* @__PURE__ */ e("kbd", { children: "⌘" }),
                /* @__PURE__ */ e("kbd", { children: "J" }),
                " to toggle"
              ] }),
              /* @__PURE__ */ e("span", { className: "hb-jv-powered", children: "Powered by THEO" })
            ] })
          ] })
        ]
      }
    ) }),
    document.body
  ) : null;
  return /* @__PURE__ */ a(ue, { children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-jv-btn${r ? " active" : ""}${P ? " pulse" : ""}`,
        title: "THEO (⌘J)",
        "aria-label": "Open THEO",
        "aria-expanded": r,
        onClick: () => l((I) => !I),
        children: /* @__PURE__ */ e($e, { size: 18 })
      }
    ),
    X
  ] });
}
function Oi({ apiBase: t, tenantId: n, userId: o }) {
  const [i, r] = y([]), [l, d] = y([]), [c, f] = y({ overdue: 0, due_today: 0, total: 0 }), [u, k] = y(!1), [b, S] = y("my-day"), v = K(null), g = K(0), _ = D(async (M = b) => {
    if (!(!n || !o)) {
      k(!0);
      try {
        const L = await fetch(`${t}/api/hub/tasks?view=${M}&limit=50`, {
          credentials: "include"
        });
        if (!L.ok) return;
        const W = await L.json();
        r(W.data || []);
      } catch {
      } finally {
        k(!1);
      }
    }
  }, [t, n, o, b]), C = D(async () => {
    if (!(!n || !o))
      try {
        const M = await fetch(`${t}/api/hub/tasks/areas`, { credentials: "include" });
        if (!M.ok) return;
        const L = await M.json();
        d(L.data || []);
      } catch {
      }
  }, [t, n, o]), R = D(async () => {
    if (!(!n || !o) && !(Date.now() < g.current))
      try {
        const M = await fetch(`${t}/api/hub/tasks/count`, { credentials: "include" });
        if (M.status === 429) {
          g.current = Date.now() + 12e4;
          return;
        }
        if (!M.ok) return;
        const L = await M.json();
        f({ overdue: L.overdue || 0, due_today: L.due_today || 0, total: L.total || 0 });
      } catch {
      }
  }, [t, n, o]);
  H(() => {
    !n || !o || (_("my-day"), C(), R());
  }, [n, o]), H(() => {
    if (!(!n || !o))
      return v.current = setInterval(R, 6e4), () => {
        v.current && clearInterval(v.current);
      };
  }, [n, o, R]);
  const P = D((M) => {
    S(M), _(M);
  }, [_]), w = D(async (M) => {
    try {
      if (!(await nt(`${t}/api/hub/tasks/${M}/complete`, {
        method: "POST"
      })).ok) return;
      r((W) => W.filter((F) => F.id !== M)), R();
    } catch {
    }
  }, [t, R]), p = D(async (M) => {
    try {
      const L = await nt(`${t}/api/hub/tasks`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...M, origin: "manual" })
      });
      if (!L.ok) return null;
      const F = (await L.json()).data;
      return (b === "my-day" || b === "all") && r((q) => [F, ...q]), R(), F;
    } catch {
      return null;
    }
  }, [t, b, R]), A = D(async (M, L) => {
    try {
      const W = await nt(`${t}/api/hub/tasks/areas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: M, color: L })
      });
      if (!W.ok) return null;
      const F = await W.json();
      return d((q) => [...q, F.data]), F.data;
    } catch {
      return null;
    }
  }, [t]), G = D(async (M, L) => {
    try {
      const W = await nt(`${t}/api/hub/tasks/${M}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(L)
      });
      if (!W.ok) return null;
      const F = await W.json();
      return r((q) => q.map((j) => j.id === M ? { ...j, ...F.data } : j)), F.data;
    } catch {
      return null;
    }
  }, [t]);
  return {
    tasks: i,
    areas: l,
    count: c,
    loading: u,
    currentView: b,
    changeView: P,
    completeTask: w,
    createTask: p,
    createArea: A,
    updateTask: G,
    refetch: () => {
      _(), C(), R();
    }
  };
}
const Ri = [
  { id: "my-day", label: "My Day" },
  { id: "my-week", label: "My Week" },
  { id: "all", label: "All Tasks" },
  { id: "assigned-to-me", label: "Assigned to Me" },
  { id: "priority", label: "By Priority" },
  { id: "product", label: "By Product" },
  { id: "done", label: "Completed" }
];
function Ii(t) {
  const n = t.trim().split(/\s+/).filter(Boolean);
  return n.length === 0 ? "?" : n.length === 1 ? n[0].slice(0, 2).toUpperCase() : (n[0][0] + n[n.length - 1][0]).toUpperCase();
}
const Ln = {
  urgent: "#ef4444",
  high: "#f97316",
  normal: "#3b82f6",
  low: "#64748b"
}, Yo = {
  psa: "#8b5cf6",
  rmm: "#22c55e",
  crm: "#06b6d4",
  books: "#f59e0b",
  security: "#ef4444",
  voice: "#3b82f6",
  backups: "#10b981",
  hub: "#f97316",
  theo: "#6366f1"
};
function Di(t) {
  if (!t) return null;
  const n = new Date(t), o = /* @__PURE__ */ new Date(), i = n < o, r = /* @__PURE__ */ new Date();
  r.setHours(0, 0, 0, 0);
  const l = new Date(r);
  l.setDate(l.getDate() + 1);
  const d = new Date(n);
  return d.setHours(0, 0, 0, 0), d.getTime() === r.getTime() ? { label: "Today", overdue: n < o } : d.getTime() === l.getTime() ? { label: "Tomorrow", overdue: !1 } : i ? { label: `${Math.floor((o.getTime() - n.getTime()) / 864e5)}d ago`, overdue: !0 } : {
    label: n.toLocaleDateString(void 0, { month: "short", day: "numeric" }),
    overdue: !1
  };
}
function Li(t) {
  var o;
  const n = {};
  for (const i of t) {
    const r = ((o = i.source) == null ? void 0 : o.product) || "personal";
    n[r] || (n[r] = []), n[r].push(i);
  }
  return n;
}
function Pi(t) {
  const n = { urgent: [], high: [], normal: [], low: [] };
  for (const o of t)
    n[o.priority].push(o);
  return n;
}
function En({ task: t, onComplete: n, hubUrl: o, currentUserId: i }) {
  const r = Di(t.due_at), l = t.source ? Yo[t.source.product] || "#64748b" : void 0, d = t.status === "done" || t.status === "dismissed", c = !!t.assigned_to_user_id && t.assigned_to_user_id !== i && !!t.assigned_to_user_name;
  return /* @__PURE__ */ a("div", { className: "hb-task-row", role: "listitem", children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: `hb-task-check${d ? " done" : ""}`,
        onClick: () => !d && n(t.id),
        "aria-label": d ? "Completed" : "Mark as done",
        title: d ? "Completed" : "Mark as done",
        children: d ? /* @__PURE__ */ e(Io, { size: 15, color: "#22c55e" }) : /* @__PURE__ */ e(vr, { size: 15, color: "#475569" })
      }
    ),
    /* @__PURE__ */ a("div", { className: "hb-task-body", children: [
      t.source ? /* @__PURE__ */ a(
        "a",
        {
          href: t.source.deep_link,
          target: "_blank",
          rel: "noopener noreferrer",
          className: `hb-task-title${d ? " done" : ""}`,
          children: [
            t.title,
            /* @__PURE__ */ e(kr, { size: 11, className: "hb-task-external" })
          ]
        }
      ) : /* @__PURE__ */ e(
        "a",
        {
          href: `${o}/tasks`,
          className: `hb-task-title${d ? " done" : ""}`,
          children: t.title
        }
      ),
      /* @__PURE__ */ a("div", { className: "hb-task-meta", children: [
        t.source && /* @__PURE__ */ e(
          "span",
          {
            className: "hb-task-product-badge",
            style: { background: l ? `${l}22` : void 0, color: l },
            children: t.source.product.toUpperCase()
          }
        ),
        /* @__PURE__ */ e(
          "span",
          {
            className: "hb-task-priority-dot",
            style: { background: Ln[t.priority] },
            title: `${t.priority} priority`
          }
        ),
        r && /* @__PURE__ */ e("span", { className: `hb-task-due${r.overdue ? " overdue" : ""}`, children: r.label }),
        c && /* @__PURE__ */ e(
          "span",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 10,
              color: "#a78bfa"
            },
            title: `Assigned to ${t.assigned_to_user_name}`,
            children: /* @__PURE__ */ e(
              "span",
              {
                style: {
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  background: "#8b5cf633",
                  color: "#a78bfa",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 8,
                  fontWeight: 600
                },
                children: Ii(t.assigned_to_user_name)
              }
            )
          }
        ),
        typeof t.comment_count == "number" && t.comment_count > 0 && /* @__PURE__ */ a(
          "span",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 2,
              fontSize: 10,
              color: "#94a3b8"
            },
            title: `${t.comment_count} comment${t.comment_count === 1 ? "" : "s"}`,
            children: [
              /* @__PURE__ */ e(Wt, { size: 10, color: "#94a3b8" }),
              t.comment_count
            ]
          }
        )
      ] })
    ] })
  ] });
}
function ji({ onAdd: t, areas: n }) {
  const [o, i] = y(""), [r, l] = y(""), d = K(null), c = () => {
    var k;
    const u = o.trim();
    u && (t(u, r || void 0), i(""), l(""), (k = d.current) == null || k.focus());
  };
  return /* @__PURE__ */ a("div", { className: "hb-task-quickadd", children: [
    /* @__PURE__ */ a("div", { className: "hb-task-quickadd-row", children: [
      /* @__PURE__ */ e(fr, { size: 14, color: "#64748b" }),
      /* @__PURE__ */ e(
        "input",
        {
          ref: d,
          className: "hb-task-quickadd-input",
          placeholder: "Add a task…",
          value: o,
          onChange: (u) => i(u.target.value),
          onKeyDown: (u) => {
            u.key === "Enter" && c();
          },
          maxLength: 255,
          "aria-label": "New task title"
        }
      ),
      o.trim() && /* @__PURE__ */ e("button", { className: "hb-task-quickadd-btn", onClick: c, "aria-label": "Add task", children: "Add" })
    ] }),
    n.length > 0 && o.trim() && /* @__PURE__ */ a(
      "select",
      {
        className: "hb-task-quickadd-area",
        value: r,
        onChange: (u) => l(u.target.value),
        "aria-label": "Task area",
        children: [
          /* @__PURE__ */ e("option", { value: "", children: "No area" }),
          n.map((u) => /* @__PURE__ */ e("option", { value: u.id, children: u.name }, u.id))
        ]
      }
    )
  ] });
}
function Hi({ onClose: t, apiBase: n, tenantId: o, userId: i, hubUrl: r }) {
  const { tasks: l, areas: d, count: c, loading: f, currentView: u, changeView: k, completeTask: b, createTask: S } = Oi({
    apiBase: n,
    tenantId: o,
    userId: i
  }), [v, g] = y(""), _ = K(null);
  H(() => {
    const p = (A) => {
      A.key === "Escape" && t();
    };
    return document.addEventListener("keydown", p), () => document.removeEventListener("keydown", p);
  }, [t]), H(() => {
    const p = (A) => {
      _.current && !_.current.contains(A.target) && t();
    };
    return setTimeout(() => document.addEventListener("mousedown", p), 0), () => document.removeEventListener("mousedown", p);
  }, [t]);
  const C = D(async (p, A) => {
    await S({ title: p, area_id: A, priority: "normal" });
  }, [S]), R = v ? l.filter((p) => p.area_id === v) : l;
  let P;
  if (f)
    P = /* @__PURE__ */ e("div", { className: "hb-task-empty", children: "Loading…" });
  else if (R.length === 0) {
    const p = {
      "my-day": "Nothing due today — you're on top of it.",
      "my-week": "Clear week ahead.",
      done: "No completed tasks in the last 30 days.",
      default: "No tasks here."
    };
    P = /* @__PURE__ */ e("div", { className: "hb-task-empty", children: p[u] || p.default });
  } else if (u === "priority") {
    const p = Pi(R);
    P = /* @__PURE__ */ e("div", { role: "list", children: ["urgent", "high", "normal", "low"].map((A) => p[A].length > 0 && /* @__PURE__ */ a("div", { className: "hb-task-group", children: [
      /* @__PURE__ */ a("div", { className: "hb-task-group-label", style: { color: Ln[A] }, children: [
        /* @__PURE__ */ e("span", { className: "hb-task-priority-dot", style: { background: Ln[A] } }),
        A.charAt(0).toUpperCase() + A.slice(1),
        " (",
        p[A].length,
        ")"
      ] }),
      p[A].map((G) => /* @__PURE__ */ e(En, { task: G, onComplete: b, hubUrl: r, currentUserId: i }, G.id))
    ] }, A)) });
  } else if (u === "product") {
    const p = Li(R);
    P = /* @__PURE__ */ e("div", { role: "list", children: Object.entries(p).map(([A, G]) => /* @__PURE__ */ a("div", { className: "hb-task-group", children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: "hb-task-group-label",
          style: { color: Yo[A] || "#94a3b8" },
          children: [
            A === "personal" ? "Personal" : A.toUpperCase(),
            " (",
            G.length,
            ")"
          ]
        }
      ),
      G.map((M) => /* @__PURE__ */ e(En, { task: M, onComplete: b, hubUrl: r, currentUserId: i }, M.id))
    ] }, A)) });
  } else
    P = /* @__PURE__ */ e("div", { role: "list", children: R.map((p) => /* @__PURE__ */ e(En, { task: p, onComplete: b, hubUrl: r, currentUserId: i }, p.id)) });
  const w = c.overdue + c.due_today;
  return Zt(
    /* @__PURE__ */ a(ue, { children: [
      /* @__PURE__ */ e("div", { className: "hb-sp-overlay", onClick: t, "aria-hidden": "true" }),
      /* @__PURE__ */ a(
        "div",
        {
          className: "hb-sp-panel hb-tasks-panel open",
          ref: _,
          role: "dialog",
          "aria-label": "My Tasks",
          children: [
            /* @__PURE__ */ a("div", { className: "hb-sp-header", children: [
              /* @__PURE__ */ a("div", { className: "hb-sp-header-title", children: [
                "My Tasks",
                w > 0 && /* @__PURE__ */ e("span", { className: "hb-task-header-badge", children: w > 99 ? "99+" : w })
              ] }),
              /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
                /* @__PURE__ */ e(
                  "a",
                  {
                    href: `${r}/tasks`,
                    className: "hb-task-full-link",
                    title: "Open full task view",
                    children: "Full view →"
                  }
                ),
                /* @__PURE__ */ e("button", { className: "hb-sp-close", onClick: t, "aria-label": "Close tasks panel", children: /* @__PURE__ */ e(We, { size: 16 }) })
              ] })
            ] }),
            /* @__PURE__ */ e(ji, { onAdd: C, areas: d }),
            /* @__PURE__ */ a("div", { className: "hb-tasks-body", children: [
              /* @__PURE__ */ a("div", { className: "hb-tasks-sidebar", children: [
                /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-section", children: Ri.map((p) => /* @__PURE__ */ a(
                  "button",
                  {
                    className: `hb-tasks-view-btn${u === p.id ? " active" : ""}`,
                    onClick: () => {
                      k(p.id), g("");
                    },
                    children: [
                      p.label,
                      p.id === "my-day" && w > 0 && /* @__PURE__ */ e("span", { className: "hb-task-view-count", children: w })
                    ]
                  },
                  p.id
                )) }),
                d.length > 0 && /* @__PURE__ */ a(ue, { children: [
                  /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-divider" }),
                  /* @__PURE__ */ a("div", { className: "hb-tasks-sidebar-section", children: [
                    /* @__PURE__ */ e("div", { className: "hb-tasks-sidebar-label", children: "Areas" }),
                    d.map((p) => /* @__PURE__ */ a(
                      "button",
                      {
                        className: `hb-tasks-view-btn${v === p.id ? " active" : ""}`,
                        onClick: () => g(v === p.id ? "" : p.id),
                        children: [
                          p.color && /* @__PURE__ */ e(
                            "span",
                            {
                              className: "hb-tasks-area-dot",
                              style: { background: p.color }
                            }
                          ),
                          p.name
                        ]
                      },
                      p.id
                    ))
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ e("div", { className: "hb-tasks-list", children: P })
            ] })
          ]
        }
      )
    ] }),
    document.body
  );
}
function $i({
  apiBase: t,
  tenantId: n,
  userId: o,
  hubUrl: i,
  open: r,
  onToggle: l,
  onClose: d
}) {
  const [c, f] = y(0), u = K(null), k = D(async () => {
    if (!(!n || !o))
      try {
        const b = await fetch(`${t}/api/hub/tasks/count`, { credentials: "include" });
        if (!b.ok) return;
        const S = await b.json();
        f((S.overdue || 0) + (S.due_today || 0));
      } catch {
      }
  }, [t, n, o]);
  return H(() => (k(), u.current = setInterval(k, 6e4), () => {
    u.current && clearInterval(u.current);
  }), [k]), /* @__PURE__ */ a(ue, { children: [
    /* @__PURE__ */ a(
      "button",
      {
        className: `hb-tasks-btn${r ? " active" : ""}`,
        onClick: l,
        "aria-label": `Tasks${c > 0 ? ` (${c})` : ""}`,
        title: "My Tasks",
        children: [
          /* @__PURE__ */ e(Io, { size: 18 }),
          c > 0 && /* @__PURE__ */ e("span", { className: "hb-tasks-badge", children: c > 99 ? "99+" : c })
        ]
      }
    ),
    r && /* @__PURE__ */ e(
      Hi,
      {
        onClose: d,
        apiBase: t,
        tenantId: n,
        userId: o,
        hubUrl: i
      }
    )
  ] });
}
const To = {
  psa: [
    "Summarize my open P1 and P2 tickets",
    "Write a professional response for this ticket: [paste ticket here]",
    "What's the best way to handle a client who keeps reopening closed tickets?"
  ],
  rmm: [
    "Show me devices with CPU over 80% in the last hour",
    "A server is showing high disk I/O — walk me through diagnosing it",
    "Write a PowerShell script to report all devices with less than 10GB free disk"
  ],
  security: [
    "What security alerts need my attention right now?",
    "Walk me through investigating a potential ransomware indicator",
    "What does MITRE ATT&CK technique T1078 mean and how do I detect it?"
  ],
  cmdb: [
    "Help me write a documentation standard for client network diagrams",
    "What fields should I capture for every server in my CMDB?"
  ],
  voice: [
    "Help me write an IVR greeting script for a medical office client",
    "What's the best on-call schedule structure for a 5-person MSP?"
  ],
  default: [
    "What tools should a new MSP consider for their core stack?",
    "Help me write a professional client communication about a service outage",
    "What should I include in a quarterly business review for a healthcare client?",
    "Write a PowerShell script to audit local admin accounts on Windows workstations",
    "How do I explain the value of MFA to a resistant client?"
  ]
};
function Wi(t) {
  const n = [];
  for (const o of t) {
    const i = To[o];
    i && n.push(i[0]);
  }
  for (const o of To.default) {
    if (n.length >= 5) break;
    n.includes(o) || n.push(o);
  }
  return n.slice(0, 5);
}
function Ui({ activeProducts: t, onComplete: n }) {
  const [o, i] = y(0), r = Wi(t);
  return /* @__PURE__ */ a("div", { className: "theo-onboarding", children: [
    /* @__PURE__ */ e("div", { className: "onboarding-step-dots", children: [0, 1, 2].map((l) => /* @__PURE__ */ e("div", { className: `step-dot${o === l ? " active" : ""}` }, l)) }),
    /* @__PURE__ */ a("div", { className: "theo-onboarding-step", children: [
      o === 0 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { style: { fontSize: 32, marginBottom: 12 }, children: "🤖" }),
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 12px" }, children: "Meet THEO" }),
        /* @__PURE__ */ e("p", { style: { color: "#94a3b8", fontSize: 14, lineHeight: 1.7, margin: "0 0 28px" }, children: "THEO is your MSP AI — trained on helpdesk workflows, security incidents, and MSP business operations. Ask about tickets, scripts, client emails, or anything your team runs into." }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => i(1),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit"
            },
            children: "Next →"
          }
        )
      ] }),
      o === 1 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 8px" }, children: "Try asking THEO..." }),
        /* @__PURE__ */ e("p", { style: { color: "#64748b", fontSize: 12, margin: "0 0 4px" }, children: "Click a prompt to jump straight in" }),
        /* @__PURE__ */ e("div", { className: "onboarding-prompts", children: r.map((l) => /* @__PURE__ */ e(
          "button",
          {
            className: "prompt-chip",
            onClick: () => n(l),
            children: l
          },
          l
        )) }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => i(2),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
              marginTop: 8
            },
            children: "Next →"
          }
        )
      ] }),
      o === 2 && /* @__PURE__ */ a(ue, { children: [
        /* @__PURE__ */ e("div", { style: { fontSize: 32, marginBottom: 12 }, children: "📈" }),
        /* @__PURE__ */ e("h2", { style: { color: "#f1f5f9", fontSize: 22, fontWeight: 700, margin: "0 0 12px" }, children: "THEO gets better over time" }),
        /* @__PURE__ */ e("p", { style: { color: "#94a3b8", fontSize: 14, lineHeight: 1.7, margin: "0 0 10px" }, children: "When you rate THEO's responses with 👍 or 👎, you're helping train the next version. Your feedback directly improves THEO — not just for you, but for every MSP using The One Stack." }),
        /* @__PURE__ */ e("p", { style: { color: "#475569", fontSize: 12, lineHeight: 1.6, margin: "0 0 28px" }, children: "Your conversation data is anonymized before being used for training. You can opt out in account settings." }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => n(),
            style: {
              padding: "10px 24px",
              borderRadius: 8,
              background: "#6366f1",
              border: "none",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit"
            },
            children: "Start chatting →"
          }
        )
      ] })
    ] })
  ] });
}
const Fi = {
  msp_owner: "MSP Owner",
  technician: "Technician",
  sales: "Sales",
  marketing: "Marketing",
  finance: "Finance",
  customer: "Customer / End User",
  nonprofit: "Nonprofit / Association Staff",
  healthcare: "Healthcare / Medical Staff",
  business: "General Business / Operations"
}, Vi = {
  msp_owner: "🏢",
  technician: "🔧",
  sales: "📈",
  marketing: "📣",
  finance: "💼",
  customer: "👤",
  nonprofit: "🤝",
  healthcare: "⚕️",
  business: "🏛️"
}, Gi = {
  msp_owner: "Business strategy, growth, client relationships",
  technician: "Step-by-step fixes, commands, troubleshooting",
  sales: "Proposals, objections, client conversations",
  marketing: "Content, positioning, campaigns",
  finance: "Billing, invoicing, reporting",
  customer: "Plain English help with IT questions",
  nonprofit: "Members, events, dues, and programs",
  healthcare: "Scheduling, billing, compliance, admin",
  business: "Operations, HR, finance, and workflows"
}, Yi = {
  msp_owner: "Let's talk business. What's on your mind?",
  technician: "Ready to troubleshoot. What are you working on?",
  sales: "Let's win some deals. What do you need?",
  marketing: "Let's build something. What are you working on?",
  finance: "Numbers time. What do you need?",
  customer: "Hi! What can I help you with today?",
  nonprofit: "Let's make an impact. What are you working on?",
  healthcare: "Ready to help with your workflow. What do you need?",
  business: "Let's get things running smoothly. What's up?"
}, en = "theo_persona_v1", Bi = /* @__PURE__ */ new Set(["msp_owner", "technician", "sales", "marketing", "finance", "customer", "nonprofit", "healthcare", "business"]);
function Bo() {
  try {
    const t = localStorage.getItem(en);
    return t && Bi.has(t) ? t : null;
  } catch {
    return null;
  }
}
function _o() {
  try {
    return localStorage.getItem(en) !== null;
  } catch {
    return !1;
  }
}
function Ki(t) {
  try {
    localStorage.setItem(en, t);
  } catch {
  }
}
function qi() {
  try {
    localStorage.setItem(en, "skipped");
  } catch {
  }
}
function Ji() {
  const [t, n] = y(() => Bo()), o = D((r, l) => {
    Ki(r), n(r), fetch(`${l}/api/v1/theo/memory`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        scope: "user",
        memory_type: "preference",
        label: "user_persona",
        content: r
      })
    }).catch(() => {
    });
  }, []), i = D(() => {
    qi(), n(null);
  }, []);
  return { persona: t, setPersona: o, skipPersona: i };
}
const Xi = [
  "msp_owner",
  "technician",
  "sales",
  "marketing",
  "finance",
  "customer",
  "nonprofit",
  "healthcare",
  "business"
];
function Qi({ onSelect: t, onSkip: n }) {
  const [o, i] = y(null);
  function r(l) {
    i(l), setTimeout(() => t(l), 320);
  }
  return /* @__PURE__ */ e(
    "div",
    {
      style: {
        position: "absolute",
        inset: 0,
        zIndex: 20,
        background: "#1e293b",
        borderRadius: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 24px",
        overflowY: "auto"
      },
      children: /* @__PURE__ */ a("div", { style: { maxWidth: 560, width: "100%" }, children: [
        /* @__PURE__ */ a("div", { style: { textAlign: "center", marginBottom: 28 }, children: [
          /* @__PURE__ */ e("div", { style: { fontSize: 28, marginBottom: 10 }, children: "🤖" }),
          /* @__PURE__ */ e("h2", { style: {
            color: "#f1f5f9",
            fontSize: 20,
            fontWeight: 700,
            margin: "0 0 8px",
            lineHeight: 1.3
          }, children: "Before we begin — who are you?" }),
          /* @__PURE__ */ e("p", { style: { color: "#64748b", fontSize: 13, margin: 0 }, children: "THEO will speak your language." })
        ] }),
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 10,
              marginBottom: 20
            },
            children: Xi.map((l) => {
              const d = o === l;
              return /* @__PURE__ */ a(
                "button",
                {
                  onClick: () => !o && r(l),
                  disabled: !!o,
                  style: {
                    padding: "14px 10px",
                    borderRadius: 10,
                    border: d ? "2px solid #6366f1" : "1px solid #334155",
                    background: d ? "rgba(99,102,241,0.18)" : "rgba(255,255,255,0.03)",
                    cursor: o ? "default" : "pointer",
                    textAlign: "center",
                    transition: "background 0.15s, border-color 0.15s, transform 0.15s",
                    transform: d ? "scale(1.04)" : "scale(1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 6,
                    fontFamily: "inherit"
                  },
                  onMouseEnter: (c) => {
                    o || (c.currentTarget.style.background = "rgba(255,255,255,0.06)", c.currentTarget.style.borderColor = "#475569");
                  },
                  onMouseLeave: (c) => {
                    !o && !d && (c.currentTarget.style.background = "rgba(255,255,255,0.03)", c.currentTarget.style.borderColor = "#334155");
                  },
                  children: [
                    /* @__PURE__ */ e("span", { style: { fontSize: 22 }, children: Vi[l] }),
                    /* @__PURE__ */ e("span", { style: { color: "#f1f5f9", fontSize: 12, fontWeight: 600, lineHeight: 1.3 }, children: Fi[l] }),
                    /* @__PURE__ */ e("span", { style: { color: "#64748b", fontSize: 11, lineHeight: 1.4 }, children: Gi[l] })
                  ]
                },
                l
              );
            })
          }
        ),
        !o && /* @__PURE__ */ e("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ e(
          "button",
          {
            onClick: n,
            style: {
              background: "none",
              border: "none",
              padding: 0,
              color: "#475569",
              fontSize: 12,
              cursor: "pointer",
              fontFamily: "inherit",
              textDecoration: "underline"
            },
            children: "Skip for now"
          }
        ) })
      ] })
    }
  );
}
const Ko = "theo_onboarded_v1";
function Zi() {
  try {
    return localStorage.getItem(Ko) === "true";
  } catch {
    return !1;
  }
}
function ea() {
  try {
    localStorage.setItem(Ko, "true");
  } catch {
  }
}
const qo = "hb_theo_recent", ta = 5, Mo = "hb_theo_seen", Co = {
  psa: "PSA",
  rmm: "RMM",
  crm: "CRM",
  books: "Books",
  voice: "Voice",
  security: "Security",
  backups: "Backups",
  cmdb: "CMDB",
  projects: "Projects",
  oncall: "OnCall",
  fleet: "Fleet",
  people: "People",
  legal: "Legal",
  collective: "Collective",
  hub: "Hub",
  "ops-center": "Ops Center",
  portal: "Hub",
  aiplatform: "AI Studio"
}, No = {
  psa: [
    { label: "Create ticket", icon: "🎫", hint: "New support ticket" },
    { label: "My queue", icon: "📋", hint: "Tickets assigned to me" },
    { label: "Time sheet", icon: "🕐", hint: "Log time entries" }
  ],
  rmm: [
    { label: "Device health", icon: "💻", hint: "View all devices" },
    { label: "Run script", icon: "⚡", hint: "Execute on devices" },
    { label: "View alerts", icon: "🚨", hint: "Active alerts" }
  ],
  crm: [
    { label: "New contact", icon: "👤", hint: "Add a contact" },
    { label: "Pipeline", icon: "📊", hint: "Sales pipeline" },
    { label: "Activities", icon: "📅", hint: "Recent activities" }
  ],
  books: [
    { label: "New invoice", icon: "📄", hint: "Create invoice" },
    { label: "Outstanding", icon: "💰", hint: "Unpaid invoices" },
    { label: "Reports", icon: "📈", hint: "Financial reports" }
  ],
  hub: [
    { label: "Billing", icon: "💳", hint: "Manage subscription" },
    { label: "Invite user", icon: "👋", hint: "Add team member" },
    { label: "Add product", icon: "➕", hint: "Activate a product" }
  ]
};
function Pn() {
  try {
    return JSON.parse(localStorage.getItem(qo) ?? "[]");
  } catch {
    return [];
  }
}
function na(t) {
  const n = Pn().filter((o) => o !== t);
  n.unshift(t);
  try {
    localStorage.setItem(qo, JSON.stringify(n.slice(0, ta)));
  } catch {
  }
}
function oa(t) {
  const n = Date.now() - new Date(t).getTime(), o = Math.floor(n / 6e4);
  if (o < 1) return "just now";
  if (o < 60) return `${o}m ago`;
  const i = Math.floor(o / 60);
  if (i < 24) return `${i}h ago`;
  const r = Math.floor(i / 24);
  return r < 7 ? `${r}d ago` : new Date(t).toLocaleDateString(void 0, { month: "short", day: "numeric" });
}
function Ao({
  customGpts: t,
  selectedId: n,
  upgradeRequired: o,
  open: i,
  onToggle: r,
  onSelect: l
}) {
  const d = t.find((c) => c.id === n) ?? null;
  return /* @__PURE__ */ a("div", { style: { position: "relative", display: "inline-block" }, children: [
    /* @__PURE__ */ a(
      "button",
      {
        onClick: r,
        title: d ? `Custom GPT: ${d.name}` : "Select Custom GPT",
        style: {
          display: "flex",
          alignItems: "center",
          gap: 4,
          background: d ? "rgba(139,92,246,0.2)" : "none",
          border: d ? "1px solid rgba(139,92,246,0.4)" : "1px solid #334155",
          borderRadius: 6,
          padding: "3px 8px",
          color: d ? "#c4b5fd" : "#64748b",
          fontSize: 11,
          cursor: "pointer",
          fontFamily: "inherit"
        },
        onMouseEnter: (c) => {
          d || (c.currentTarget.style.color = "#94a3b8");
        },
        onMouseLeave: (c) => {
          d || (c.currentTarget.style.color = "#64748b");
        },
        children: [
          /* @__PURE__ */ e("span", { style: { fontSize: 12 }, children: d ? d.icon : "✦" }),
          /* @__PURE__ */ e("span", { style: { maxWidth: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: d ? d.name : "THEO" }),
          /* @__PURE__ */ e("span", { style: { fontSize: 9, marginLeft: 1 }, children: "▾" })
        ]
      }
    ),
    i && /* @__PURE__ */ e(
      "div",
      {
        style: {
          position: "absolute",
          bottom: "100%",
          left: 0,
          marginBottom: 4,
          background: "#1e293b",
          border: "1px solid #334155",
          borderRadius: 8,
          boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
          minWidth: 240,
          zIndex: 100,
          overflow: "hidden"
        },
        children: o ? /* @__PURE__ */ a("div", { style: { padding: "14px 16px", textAlign: "center" }, children: [
          /* @__PURE__ */ e("div", { style: { fontSize: 18, marginBottom: 6 }, children: "🔒" }),
          /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 13, fontWeight: 600, marginBottom: 4 }, children: "Custom GPTs" }),
          /* @__PURE__ */ e("div", { style: { color: "#64748b", fontSize: 11, lineHeight: 1.5, marginBottom: 10 }, children: "Create custom THEO personas for your org. Available on THEO Business plan." }),
          /* @__PURE__ */ e(
            "a",
            {
              href: "https://theo.theonestack.com/upgrade",
              target: "_blank",
              rel: "noreferrer",
              style: {
                display: "block",
                padding: "6px 14px",
                background: "rgba(139,92,246,0.25)",
                border: "1px solid rgba(139,92,246,0.4)",
                borderRadius: 6,
                color: "#c4b5fd",
                fontSize: 11,
                fontWeight: 600,
                textDecoration: "none",
                textAlign: "center"
              },
              children: "Upgrade to Business"
            }
          )
        ] }) : /* @__PURE__ */ a(ue, { children: [
          /* @__PURE__ */ a(
            "button",
            {
              onClick: () => l(null),
              style: {
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                padding: "9px 14px",
                background: n === null ? "rgba(139,92,246,0.15)" : "transparent",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                borderBottom: t.length > 0 ? "1px solid #1e293b" : "none"
              },
              children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 15 }, children: "✦" }),
                /* @__PURE__ */ a("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 12, fontWeight: 500 }, children: "THEO" }),
                  /* @__PURE__ */ e("div", { style: { color: "#475569", fontSize: 10 }, children: "Standard persona" })
                ] }),
                n === null && /* @__PURE__ */ e("span", { style: { color: "#8b5cf6", fontSize: 12 }, children: "✓" })
              ]
            }
          ),
          t.length > 0 && /* @__PURE__ */ e("div", { style: { maxHeight: 200, overflowY: "auto" }, children: t.map((c) => /* @__PURE__ */ a(
            "button",
            {
              onClick: () => l(c.id),
              style: {
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                padding: "9px 14px",
                background: n === c.id ? "rgba(139,92,246,0.15)" : "transparent",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                borderBottom: "1px solid #1e293b"
              },
              children: [
                /* @__PURE__ */ e("span", { style: { fontSize: 15, lineHeight: 1, flexShrink: 0 }, children: c.icon }),
                /* @__PURE__ */ a("div", { style: { flex: 1, minWidth: 0 }, children: [
                  /* @__PURE__ */ e("div", { style: { color: "#e2e8f0", fontSize: 12, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: c.name }),
                  c.description && /* @__PURE__ */ e("div", { style: { color: "#475569", fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: c.description })
                ] }),
                n === c.id && /* @__PURE__ */ e("span", { style: { color: "#8b5cf6", fontSize: 12, flexShrink: 0 }, children: "✓" })
              ]
            },
            c.id
          )) }),
          t.length === 0 && /* @__PURE__ */ a("div", { style: { padding: "10px 14px", color: "#475569", fontSize: 11, textAlign: "center" }, children: [
            "No Custom GPTs yet.",
            " ",
            /* @__PURE__ */ e(
              "a",
              {
                href: "https://theo.theonestack.com/settings/custom-gpts",
                target: "_blank",
                rel: "noreferrer",
                style: { color: "#8b5cf6", textDecoration: "none" },
                children: "Create one →"
              }
            )
          ] })
        ] })
      }
    )
  ] });
}
function ra({ open: t, onClose: n, apiBase: o, currentProduct: i, tenantId: r, activeProducts: l = [], entityContext: d = null }) {
  var It;
  const [c, f] = y(""), [u, k] = y([]), [b, S] = y(!1), [v, g] = y([]), [_, C] = y(-1), [R, P] = y(!1), [w, p] = y(null), [A, G] = y(null), [M, L] = y(!1), [W, F] = y(!1), [q, j] = y(!1), { setPersona: X, skipPersona: I } = Ji(), [J, ie] = y(/* @__PURE__ */ new Map()), [oe, le] = y(!1), [te, re] = y(null), [B, Ae] = y(/* @__PURE__ */ new Set()), $ = K(null), [fe, ae] = y([]), [z, O] = y(null), [V, Ue] = y(null), [ge, Fe] = y(!1), [Xe, ce] = y(!1), [De, Le] = y(""), [Ve, Qe] = y(null), [Ge, bt] = y([]), [ot, Ye] = y(!1), [Mt, tn] = y(!1), [Ct, Ee] = y(!1), [de, Me] = y(!1), [rt, Ut] = y(!1), [be, Be] = y(!1), Ke = K(null), [mt, it] = y(!1), [ke, Ze] = y(null), Nt = D(async () => {
    if (!ke)
      try {
        const h = await import("./TalkToTheoModal-BoNA4IpA.js");
        Ze(() => h.TalkToTheoModal);
      } catch (h) {
        console.error("[theo] failed to load TalkToTheoModal:", h);
        return;
      }
    it(!0);
  }, [ke]), ze = K(null), gt = K(null), qe = K(null), at = K(null), st = K(null), Oe = K(null);
  H(() => {
    Oe.current = z;
  }, [z]), H(() => {
    function h() {
      Me(window.innerWidth < 768);
    }
    return h(), window.addEventListener("resize", h), () => window.removeEventListener("resize", h);
  }, []), H(() => {
    const h = window;
    Ut(!!(h.SpeechRecognition || h.webkitSpeechRecognition));
  }, []);
  const At = D(() => {
    fetch(`${o}/api/v1/theo/consent/usage`, { credentials: "include" }).then((h) => h.ok ? h.json() : null).then((h) => {
      h && p(h);
    }).catch(() => {
    });
  }, [o]), lt = D(async (h) => {
    Fe(!0);
    try {
      const U = h ? null : V, m = De.trim(), s = new URLSearchParams();
      U && s.set("token", U), m && s.set("search", m);
      const x = s.toString() ? `?${s}` : "", N = await fetch(`${o}/api/v1/theo/conversations${x}`, { credentials: "include" });
      if (!N.ok) return;
      const Z = await N.json();
      ae((ne) => h ? Z.conversations : [...ne, ...Z.conversations]), Ue(Z.next_token);
    } catch {
    } finally {
      Fe(!1);
    }
  }, [o, V, De]), pe = D(async (h) => {
    ce(!0);
    try {
      const U = await fetch(`${o}/api/v1/theo/conversations/${h}`, { credentials: "include" });
      if (!U.ok) return;
      const m = await U.json();
      k(m.messages.map((s) => ({ role: s.role, content: s.content }))), ie(/* @__PURE__ */ new Map()), O(h), de && Ee(!1);
    } catch {
    } finally {
      ce(!1);
    }
  }, [o, de]), et = D(() => {
    fetch(`${o}/api/v1/theo/custom-gpts`, { credentials: "include" }).then((h) => h.ok ? h.json() : null).then((h) => {
      h && (bt(h.custom_gpts ?? []), tn(h.upgrade_required ?? !1));
    }).catch(() => {
    });
  }, [o]);
  H(() => {
    var h;
    if (t) {
      f(""), k([]), S(!1), C(-1), O(null), Ee(!1), Le(""), g(Pn()), G(null), L(!1), Qe(null), Ye(!1), et(), Zi() ? _o() ? setTimeout(() => {
        var m;
        return (m = ze.current) == null ? void 0 : m.focus();
      }, 50) : j(!0) : F(!0);
      const U = `${Mo}_${i}`;
      localStorage.getItem(U) || P(!0), At(), lt(!0);
    } else
      (h = gt.current) == null || h.abort(), P(!1), F(!1), j(!1);
  }, [t]), H(() => {
    qe.current && (qe.current.scrollTop = qe.current.scrollHeight);
  }, [u, b]), H(() => {
    if (t)
      return st.current && clearTimeout(st.current), st.current = setTimeout(() => {
        lt(!0);
      }, 300), () => {
        st.current && clearTimeout(st.current);
      };
  }, [De]);
  function nn() {
    const h = at.current;
    !h || !V || ge || h.scrollTop + h.clientHeight >= h.scrollHeight - 60 && lt(!1);
  }
  const ct = No[i] ?? No.hub, Re = D(async (h) => {
    var x, N, Z;
    if (!h.trim()) return;
    (x = gt.current) == null || x.abort();
    const U = new AbortController();
    gt.current = U;
    const m = `${Mo}_${i}`;
    if (!localStorage.getItem(m))
      try {
        localStorage.setItem(m, "1");
      } catch {
      }
    P(!1);
    const s = { role: "user", content: h.trim() };
    k((ne) => [...ne, s]), f(""), S(!0), na(h.trim()), g(Pn());
    try {
      const ne = await fetch(`${o}/api/v1/theo/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          message: h.trim(),
          conversation_id: Oe.current ?? void 0,
          context: { product: i, org_id: r },
          persona: Bo() ?? void 0,
          ...Ve ? { customGptId: Ve } : {},
          ...d ? { entity_context: d } : {}
        }),
        signal: U.signal
      });
      if (!ne.ok || !ne.body) {
        k((Se) => [...Se, { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }]);
        return;
      }
      const Y = ne.body.getReader(), ee = new TextDecoder();
      let se = "", me = "", dt = null, he = [];
      for (k((Se) => [...Se, { role: "assistant", content: "" }]); ; ) {
        const { done: Se, value: Pe } = await Y.read();
        if (Se) break;
        se += ee.decode(Pe, { stream: !0 });
        const pt = se.split(`
`);
        se = pt.pop() ?? "";
        for (const $n of pt) {
          if (!$n.startsWith("data: ")) continue;
          const Wn = $n.slice(6);
          if (Wn === "[DONE]") break;
          try {
            const je = JSON.parse(Wn);
            if (je.token)
              me += je.token, k((tt) => {
                const ht = [...tt];
                return ht[ht.length - 1] = { role: "assistant", content: me }, ht;
              });
            else if (je.done) {
              if (je.conversation_id && (dt = je.conversation_id), (N = je.knowledgeUsed) != null && N.length && (he = je.knowledgeUsed), (Z = je.runbook_dispatched) != null && Z.length)
                for (const tt of je.runbook_dispatched)
                  try {
                    window.dispatchEvent(new CustomEvent("theo:runbook-dispatched", {
                      detail: {
                        execution_id: tt.execution_id,
                        runbook_id: tt.runbook_id,
                        runbook_name: tt.runbook_name ?? tt.runbook_id
                      }
                    }));
                  } catch {
                  }
            } else je.error && k((tt) => {
              const ht = [...tt];
              return ht[ht.length - 1] = { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }, ht;
            });
          } catch {
          }
        }
      }
      if (!M && me) {
        const Se = me.match(/💡 Should I remember (.+?)(\?)?$/);
        Se && G(Se[1].trim());
      }
      he.length > 0 && k((Se) => {
        const Pe = [...Se], pt = Pe[Pe.length - 1];
        return (pt == null ? void 0 : pt.role) === "assistant" && (Pe[Pe.length - 1] = { ...pt, knowledgeUsed: he }), Pe;
      }), dt && !Oe.current && (O(dt), lt(!0));
    } catch (ne) {
      (ne == null ? void 0 : ne.name) !== "AbortError" && k((Y) => {
        const ee = [...Y], se = ee[ee.length - 1];
        return (se == null ? void 0 : se.role) === "assistant" && se.content === "" ? ee[ee.length - 1] = { role: "assistant", content: "THEO is unavailable right now. Try again in a moment." } : ee.push({ role: "assistant", content: "THEO is unavailable right now. Try again in a moment." }), ee;
      });
    } finally {
      S(!1), At();
    }
  }, [o, i, r, M, At, lt, d, Ve]), Et = D(async (h, U, m) => {
    const s = Oe.current;
    if (s) {
      ie((x) => {
        const N = new Map(x);
        return N.set(h, { rating: U, bad_reason: m, showReasonPicker: !1, submitted: !0 }), N;
      }), $.current && clearTimeout($.current), le(!0), $.current = setTimeout(() => le(!1), 1500);
      try {
        await fetch(`${o}/api/v1/theo/feedback`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ conversation_id: s, message_index: h, rating: U, bad_reason: m })
        });
      } catch {
      }
    }
  }, [o]);
  function xt() {
    k([]), O(null), f(""), P(!1), G(null), ie(/* @__PURE__ */ new Map()), Qe(null), Ye(!1), de && Ee(!1), setTimeout(() => {
      var h;
      return (h = ze.current) == null ? void 0 : h.focus();
    }, 50);
  }
  const yt = D(() => {
    const h = Ke.current;
    if (h && typeof h.stop == "function")
      try {
        h.stop.call(h);
      } catch {
      }
    Ke.current = null, Be(!1);
  }, []), Ce = D(() => {
    if (!rt || be) return;
    const h = window, U = h.SpeechRecognition ?? h.webkitSpeechRecognition;
    if (!U) return;
    let m;
    try {
      m = new U();
    } catch {
      return;
    }
    m.lang = navigator.language || "en-US", m.continuous = !1, m.interimResults = !0, m.maxAlternatives = 1;
    let s = "";
    m.onresult = (x) => {
      const N = x, Z = N.results;
      if (!Z) return;
      const ne = N.resultIndex ?? 0;
      let Y = "";
      for (let ee = ne; ee < Z.length; ee++) {
        const se = Z[ee];
        if (!se) continue;
        const me = se[0];
        !me || typeof me.transcript != "string" || (se.isFinal ? s += me.transcript : Y += me.transcript);
      }
      f((s + Y).trimStart());
    }, m.onerror = () => {
      Be(!1), Ke.current = null;
    }, m.onend = () => {
      Be(!1), Ke.current = null;
      const x = s.trim();
      x && Re(x);
    };
    try {
      m.start.call(m), Ke.current = m, Be(!0);
    } catch {
      Be(!1);
    }
  }, [rt, be, Re]);
  H(() => (!t && be && yt(), () => {
    Ke.current && yt();
  }), [t, be, yt]);
  function Je(h) {
    if (h.key === "Escape") {
      n();
      return;
    }
    h.key === "Enter" && !h.shiftKey && (h.preventDefault(), u.length === 0 && _ >= 0 && _ < ct.length ? Re(ct[_].label) : Re(c)), u.length === 0 && (h.key === "ArrowDown" && (h.preventDefault(), C((U) => Math.min(U + 1, ct.length - 1))), h.key === "ArrowUp" && (h.preventDefault(), C((U) => Math.max(U - 1, -1))));
  }
  const we = u.length > 0 || b || Xe, Ft = w !== null && w.limit !== null, zt = !de || Ct, Ot = 420;
  if (H(() => {
    if (de || !t) return;
    const h = document.body.style.paddingRight, U = document.body.style.transition;
    return document.body.style.transition = "padding-right 220ms ease-out", document.body.style.paddingRight = `${Ot}px`, () => {
      document.body.style.paddingRight = h, document.body.style.transition = U;
    };
  }, [t, de]), !t) return null;
  const Ie = Co[i] ?? "THEO", Vt = d != null && d.entity_label ? `THEO · ${d.entity_label}` : `THEO · ${Ie}`, Rt = (d == null ? void 0 : d.suggested_prompts) ?? [];
  return /* @__PURE__ */ a(
    "div",
    {
      style: {
        position: "fixed",
        top: 48,
        // sits below HubBar (HUB_BAR_HEIGHT)
        right: 0,
        bottom: 0,
        width: de ? "100vw" : Ot,
        maxWidth: "100vw",
        zIndex: 9998,
        display: "flex",
        flexDirection: "column",
        pointerEvents: "auto"
      },
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            style: {
              flex: 1,
              background: "#1e293b",
              borderLeft: "1px solid #334155",
              boxShadow: "-8px 0 24px rgba(0,0,0,0.35)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "row",
              position: "relative",
              minHeight: 0,
              transform: "translateX(0)",
              transition: "transform 220ms ease-out"
            },
            children: [
              W && /* @__PURE__ */ e(
                Ui,
                {
                  activeProducts: l,
                  onComplete: (h) => {
                    ea(), F(!1), h && f(h), _o() ? setTimeout(() => {
                      var U;
                      return (U = ze.current) == null ? void 0 : U.focus();
                    }, 50) : j(!0);
                  }
                }
              ),
              q && /* @__PURE__ */ e(
                Qi,
                {
                  onSelect: (h) => {
                    X(h, o), j(!1), k([{ role: "assistant", content: Yi[h] }]), setTimeout(() => {
                      var U;
                      return (U = ze.current) == null ? void 0 : U.focus();
                    }, 50);
                  },
                  onSkip: () => {
                    I(), j(!1), setTimeout(() => {
                      var h;
                      return (h = ze.current) == null ? void 0 : h.focus();
                    }, 50);
                  }
                }
              ),
              zt && /* @__PURE__ */ a(
                "div",
                {
                  style: {
                    width: de ? "100%" : 260,
                    background: "#16213e",
                    borderRight: de ? "none" : "1px solid #334155",
                    display: "flex",
                    flexDirection: "column",
                    flexShrink: 0,
                    ...de ? {
                      position: "absolute",
                      inset: 0,
                      zIndex: 10,
                      borderRadius: 12
                    } : {}
                  },
                  children: [
                    /* @__PURE__ */ a("div", { style: { padding: "12px 12px 8px", borderBottom: "1px solid #1e293b", flexShrink: 0 }, children: [
                      /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }, children: [
                        /* @__PURE__ */ e(
                          "button",
                          {
                            onClick: xt,
                            style: {
                              flex: 1,
                              padding: "7px 12px",
                              background: "rgba(139,92,246,0.2)",
                              border: "1px solid rgba(139,92,246,0.4)",
                              borderRadius: 7,
                              color: "#c4b5fd",
                              fontSize: 13,
                              fontWeight: 600,
                              cursor: "pointer",
                              textAlign: "left"
                            },
                            children: "+ New Chat"
                          }
                        ),
                        de && /* @__PURE__ */ e(
                          "button",
                          {
                            onClick: () => Ee(!1),
                            style: { background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 4 },
                            children: /* @__PURE__ */ e(We, { size: 16 })
                          }
                        )
                      ] }),
                      /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 6, background: "#0f172a", borderRadius: 6, padding: "5px 10px" }, children: [
                        /* @__PURE__ */ e(Tt, { size: 12, color: "#475569" }),
                        /* @__PURE__ */ e(
                          "input",
                          {
                            value: De,
                            onChange: (h) => Le(h.target.value),
                            placeholder: "Search chats...",
                            style: {
                              flex: 1,
                              background: "transparent",
                              border: "none",
                              outline: "none",
                              color: "#94a3b8",
                              fontSize: 12
                            }
                          }
                        )
                      ] })
                    ] }),
                    /* @__PURE__ */ a(
                      "div",
                      {
                        ref: at,
                        onScroll: nn,
                        style: { flex: 1, overflowY: "auto", padding: "4px 0" },
                        children: [
                          ge && fe.length === 0 && /* @__PURE__ */ e("div", { style: { padding: "20px 16px", color: "#475569", fontSize: 12, textAlign: "center" }, children: "Loading..." }),
                          !ge && fe.length === 0 && /* @__PURE__ */ e("div", { style: { padding: "20px 16px", color: "#475569", fontSize: 12, textAlign: "center" }, children: De ? "No results" : "No conversations yet" }),
                          fe.map((h) => /* @__PURE__ */ a(
                            "button",
                            {
                              onClick: () => pe(h.id),
                              style: {
                                display: "block",
                                width: "100%",
                                padding: "8px 12px",
                                background: z === h.id ? "rgba(139,92,246,0.15)" : "transparent",
                                border: "none",
                                borderLeft: z === h.id ? "2px solid #8b5cf6" : "2px solid transparent",
                                cursor: "pointer",
                                textAlign: "left",
                                borderBottom: "1px solid rgba(255,255,255,0.03)"
                              },
                              children: [
                                /* @__PURE__ */ e("div", { style: {
                                  color: z === h.id ? "#c4b5fd" : "#cbd5e1",
                                  fontSize: 12,
                                  fontWeight: 500,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                }, children: h.title }),
                                /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 6, marginTop: 2 }, children: [
                                  /* @__PURE__ */ e("span", { style: { color: "#475569", fontSize: 10 }, children: oa(h.updated_at) }),
                                  /* @__PURE__ */ e("span", { style: { color: "#334155", fontSize: 10 }, children: "·" }),
                                  /* @__PURE__ */ a("span", { style: { color: "#475569", fontSize: 10 }, children: [
                                    h.message_count,
                                    " msg"
                                  ] })
                                ] })
                              ]
                            },
                            h.id
                          )),
                          ge && fe.length > 0 && /* @__PURE__ */ e("div", { style: { padding: "8px 16px", color: "#475569", fontSize: 11, textAlign: "center" }, children: "Loading more..." })
                        ]
                      }
                    ),
                    Ft && /* @__PURE__ */ e("div", { style: {
                      padding: "10px 12px",
                      borderTop: "1px solid #1e293b",
                      background: "rgba(249,115,22,0.05)",
                      flexShrink: 0
                    }, children: /* @__PURE__ */ a("div", { style: { color: "#94a3b8", fontSize: 11, lineHeight: 1.5 }, children: [
                      "⏱ Your conversations are saved for 7 days.",
                      " ",
                      /* @__PURE__ */ e("a", { href: "https://theo.theonestack.com/upgrade", target: "_blank", rel: "noopener noreferrer", style: { color: "#f97316", textDecoration: "none", fontWeight: 600 }, children: "Upgrade to keep them forever →" })
                    ] }) })
                  ]
                }
              ),
              /* @__PURE__ */ a("div", { style: { flex: 1, display: "flex", flexDirection: "column", minWidth: 0, maxHeight: "inherit", overflow: "hidden" }, children: [
                /* @__PURE__ */ a(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "10px 14px",
                      borderBottom: "1px solid #334155",
                      flexShrink: 0,
                      background: "rgba(15,23,42,0.6)"
                    },
                    children: [
                      /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: 1 }, children: [
                        /* @__PURE__ */ e("div", { style: {
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                          background: "rgba(139,92,246,0.3)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 11,
                          flexShrink: 0,
                          color: "#c4b5fd"
                        }, children: "T" }),
                        /* @__PURE__ */ a("div", { style: { minWidth: 0, flex: 1 }, children: [
                          /* @__PURE__ */ e("div", { style: {
                            color: "#f1f5f9",
                            fontSize: 13,
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }, children: Vt }),
                          (d == null ? void 0 : d.client_name) && /* @__PURE__ */ e("div", { style: {
                            color: "#64748b",
                            fontSize: 11,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }, children: d.client_name })
                        ] })
                      ] }),
                      /* @__PURE__ */ e(
                        "button",
                        {
                          onClick: n,
                          title: "Close THEO (Esc)",
                          "aria-label": "Close THEO",
                          style: {
                            background: "none",
                            border: "1px solid #334155",
                            cursor: "pointer",
                            color: "#94a3b8",
                            padding: "4px 6px",
                            borderRadius: 6,
                            display: "flex",
                            alignItems: "center"
                          },
                          children: /* @__PURE__ */ e(We, { size: 14 })
                        }
                      )
                    ]
                  }
                ),
                de && /* @__PURE__ */ a("div", { style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 14px",
                  borderBottom: "1px solid #334155",
                  flexShrink: 0
                }, children: [
                  /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => Ee(!0),
                      style: {
                        background: "none",
                        border: "1px solid #334155",
                        borderRadius: 6,
                        color: "#94a3b8",
                        fontSize: 12,
                        padding: "4px 10px",
                        cursor: "pointer"
                      },
                      children: "History"
                    }
                  ),
                  /* @__PURE__ */ e(
                    Ao,
                    {
                      customGpts: Ge,
                      selectedId: Ve,
                      upgradeRequired: Mt,
                      open: ot,
                      onToggle: () => Ye((h) => !h),
                      onSelect: (h) => {
                        Qe(h), Ye(!1), we && xt();
                      }
                    }
                  ),
                  /* @__PURE__ */ e("button", { onClick: n, style: { background: "none", border: "1px solid #334155", cursor: "pointer", color: "#64748b", fontSize: 11, padding: "2px 6px", borderRadius: 4 }, children: "Esc" })
                ] }),
                Xe && !u.length && /* @__PURE__ */ e("div", { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 13 }, children: "Loading conversation..." }),
                we && /* @__PURE__ */ a(
                  "div",
                  {
                    ref: qe,
                    style: { flex: 1, overflowY: "auto", padding: "12px 0", minHeight: 0, maxHeight: 420 },
                    children: [
                      u.map((h, U) => {
                        var ne;
                        const m = J.get(U), s = h.role === "assistant", N = s && h.content.length > 0 && !!Oe.current, Z = te === U;
                        return /* @__PURE__ */ a(
                          "div",
                          {
                            onMouseEnter: () => s && re(U),
                            onMouseLeave: () => re(null),
                            style: {
                              display: "flex",
                              flexDirection: h.role === "user" ? "row-reverse" : "row",
                              gap: 8,
                              padding: "6px 16px",
                              alignItems: "flex-start"
                            },
                            children: [
                              h.role === "assistant" && /* @__PURE__ */ e("div", { style: { width: 22, height: 22, borderRadius: "50%", background: "rgba(139,92,246,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, marginTop: 1 }, children: "T" }),
                              /* @__PURE__ */ a("div", { style: { display: "flex", flexDirection: "column", maxWidth: "75%", gap: 4 }, children: [
                                /* @__PURE__ */ e(
                                  "div",
                                  {
                                    style: {
                                      padding: "7px 11px",
                                      borderRadius: h.role === "user" ? "10px 10px 2px 10px" : "10px 10px 10px 2px",
                                      background: h.role === "user" ? "rgba(249,115,22,0.15)" : "rgba(255,255,255,0.06)",
                                      border: h.role === "user" ? "1px solid rgba(249,115,22,0.25)" : "1px solid rgba(255,255,255,0.06)",
                                      color: "#e2e8f0",
                                      fontSize: 13,
                                      lineHeight: 1.6,
                                      whiteSpace: "pre-wrap"
                                    },
                                    children: h.content || (h.role === "assistant" ? /* @__PURE__ */ e("span", { style: { color: "#475569" }, children: "Thinking…" }) : null)
                                  }
                                ),
                                s && (((ne = h.knowledgeUsed) == null ? void 0 : ne.length) ?? 0) > 0 && /* @__PURE__ */ a("div", { children: [
                                  /* @__PURE__ */ a(
                                    "button",
                                    {
                                      onClick: () => Ae((Y) => {
                                        const ee = new Set(Y);
                                        return ee.has(U) ? ee.delete(U) : ee.add(U), ee;
                                      }),
                                      style: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 4,
                                        padding: "2px 7px",
                                        background: "rgba(124,58,237,0.12)",
                                        border: "1px solid rgba(124,58,237,0.25)",
                                        borderRadius: 5,
                                        color: "#a78bfa",
                                        fontSize: 10,
                                        cursor: "pointer",
                                        fontFamily: "inherit"
                                      },
                                      children: [
                                        /* @__PURE__ */ e("span", { style: { fontSize: 9 }, children: "📖" }),
                                        " From your KB"
                                      ]
                                    }
                                  ),
                                  B.has(U) && /* @__PURE__ */ a("div", { style: {
                                    marginTop: 4,
                                    padding: "6px 9px",
                                    background: "rgba(124,58,237,0.07)",
                                    border: "1px solid rgba(124,58,237,0.2)",
                                    borderRadius: 6
                                  }, children: [
                                    /* @__PURE__ */ e("div", { style: { fontSize: 9, color: "#7c3aed", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }, children: "Knowledge entries used:" }),
                                    h.knowledgeUsed.map((Y) => /* @__PURE__ */ a("div", { style: { fontSize: 10, color: "#94a3b8", marginBottom: 2 }, children: [
                                      "• ",
                                      Y.title
                                    ] }, Y.id))
                                  ] })
                                ] }),
                                N && /* @__PURE__ */ e("div", { style: {
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  opacity: Z || m ? 1 : 0,
                                  transition: "opacity 0.15s",
                                  minHeight: 22
                                }, children: m != null && m.submitted ? /* @__PURE__ */ e("span", { style: { fontSize: 11, color: "#475569" }, children: m.rating === "good" ? "👍 Thanks!" : "👎 Got it" }) : /* @__PURE__ */ a(ue, { children: [
                                  /* @__PURE__ */ e(
                                    "button",
                                    {
                                      onClick: () => {
                                        m != null && m.showReasonPicker || Et(U, "good");
                                      },
                                      title: "Good response",
                                      style: {
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: 14,
                                        padding: "1px 3px",
                                        borderRadius: 4,
                                        opacity: (m == null ? void 0 : m.rating) === "good" ? 1 : 0.5,
                                        transition: "opacity 0.1s"
                                      },
                                      onMouseEnter: (Y) => Y.currentTarget.style.opacity = "1",
                                      onMouseLeave: (Y) => Y.currentTarget.style.opacity = (m == null ? void 0 : m.rating) === "good" ? "1" : "0.5",
                                      children: "👍"
                                    }
                                  ),
                                  /* @__PURE__ */ e(
                                    "button",
                                    {
                                      onClick: () => {
                                        if (m != null && m.submitted) return;
                                        const Y = m == null ? void 0 : m.showReasonPicker;
                                        ie((ee) => {
                                          const se = new Map(ee);
                                          return se.set(U, { rating: "bad", showReasonPicker: !Y, submitted: !1 }), se;
                                        });
                                      },
                                      title: "Not helpful",
                                      style: {
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: 14,
                                        padding: "1px 3px",
                                        borderRadius: 4,
                                        opacity: (m == null ? void 0 : m.rating) === "bad" ? 1 : 0.5,
                                        transition: "opacity 0.1s"
                                      },
                                      onMouseEnter: (Y) => Y.currentTarget.style.opacity = "1",
                                      onMouseLeave: (Y) => Y.currentTarget.style.opacity = (m == null ? void 0 : m.rating) === "bad" ? "1" : "0.5",
                                      children: "👎"
                                    }
                                  ),
                                  (m == null ? void 0 : m.showReasonPicker) && /* @__PURE__ */ a("div", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 4,
                                    flexWrap: "wrap",
                                    animation: "theo-slide-down 0.15s ease-out"
                                  }, children: [
                                    /* @__PURE__ */ e("span", { style: { fontSize: 10, color: "#64748b" }, children: "Why?" }),
                                    [
                                      ["incorrect", "Incorrect"],
                                      ["too_generic", "Too generic"],
                                      ["missed_the_point", "Missed the point"]
                                    ].map(([Y, ee]) => /* @__PURE__ */ e(
                                      "button",
                                      {
                                        onClick: () => void Et(U, "bad", Y),
                                        style: {
                                          background: "rgba(239,68,68,0.12)",
                                          border: "1px solid rgba(239,68,68,0.25)",
                                          borderRadius: 10,
                                          color: "#fca5a5",
                                          fontSize: 10,
                                          padding: "2px 7px",
                                          cursor: "pointer",
                                          fontFamily: "inherit"
                                        },
                                        children: ee
                                      },
                                      Y
                                    ))
                                  ] })
                                ] }) })
                              ] })
                            ]
                          },
                          U
                        );
                      }),
                      b && ((It = u[u.length - 1]) == null ? void 0 : It.role) !== "assistant" && /* @__PURE__ */ a("div", { style: { display: "flex", gap: 8, padding: "6px 16px", alignItems: "flex-start" }, children: [
                        /* @__PURE__ */ e("div", { style: { width: 22, height: 22, borderRadius: "50%", background: "rgba(139,92,246,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, marginTop: 1 }, children: "T" }),
                        /* @__PURE__ */ e("div", { style: { padding: "7px 11px", borderRadius: "10px 10px 10px 2px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.06)", color: "#64748b", fontSize: 13 }, children: "Thinking…" })
                      ] })
                    ]
                  }
                ),
                Rt.length > 0 && /* @__PURE__ */ e(
                  "div",
                  {
                    style: {
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                      padding: "8px 14px",
                      borderTop: we ? "1px solid #334155" : void 0,
                      borderBottom: "1px solid #1e293b",
                      background: "rgba(139,92,246,0.04)",
                      flexShrink: 0
                    },
                    children: Rt.map((h) => /* @__PURE__ */ e(
                      "button",
                      {
                        onClick: () => Re(h),
                        disabled: b,
                        title: h,
                        style: {
                          background: "rgba(139,92,246,0.12)",
                          border: "1px solid rgba(139,92,246,0.3)",
                          borderRadius: 14,
                          color: "#c4b5fd",
                          fontSize: 11,
                          padding: "4px 10px",
                          cursor: b ? "default" : "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                          opacity: b ? 0.5 : 1,
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        },
                        children: h
                      },
                      h
                    ))
                  }
                ),
                /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", padding: "12px 16px", borderTop: we ? "1px solid #334155" : void 0, borderBottom: we ? void 0 : "1px solid #334155", gap: 8, flexShrink: 0 }, children: [
                  be ? /* @__PURE__ */ e(
                    "span",
                    {
                      "aria-hidden": !0,
                      style: {
                        display: "inline-block",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: "#ef4444",
                        boxShadow: "0 0 8px #ef4444",
                        animation: "theo-mic-pulse 1s ease-in-out infinite"
                      }
                    }
                  ) : /* @__PURE__ */ e(Tt, { size: 16, color: "#64748b" }),
                  /* @__PURE__ */ e(
                    "input",
                    {
                      ref: ze,
                      value: c,
                      onChange: (h) => {
                        f(h.target.value), C(-1);
                      },
                      onKeyDown: Je,
                      placeholder: be ? "Listening…" : we ? "Continue the conversation…" : "Ask THEO anything…",
                      style: { flex: 1, background: "transparent", border: "none", outline: "none", color: "#f1f5f9", fontSize: 15 }
                    }
                  ),
                  rt && /* @__PURE__ */ e(
                    "button",
                    {
                      type: "button",
                      onClick: () => {
                        be ? yt() : Ce();
                      },
                      title: be ? "Stop listening" : "Speak to THEO",
                      "aria-label": be ? "Stop voice input" : "Start voice input",
                      "aria-pressed": be,
                      style: {
                        background: be ? "rgba(239,68,68,0.18)" : "rgba(139,92,246,0.12)",
                        border: `1px solid ${be ? "rgba(239,68,68,0.5)" : "rgba(139,92,246,0.4)"}`,
                        cursor: "pointer",
                        color: be ? "#fca5a5" : "#c4b5fd",
                        padding: "4px 6px",
                        borderRadius: 6,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "inherit",
                        fontSize: 13,
                        lineHeight: 1
                      },
                      children: /* @__PURE__ */ a("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
                        /* @__PURE__ */ e("path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" }),
                        /* @__PURE__ */ e("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
                        /* @__PURE__ */ e("line", { x1: "12", y1: "19", x2: "12", y2: "23" }),
                        /* @__PURE__ */ e("line", { x1: "8", y1: "23", x2: "16", y2: "23" })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ a(
                    "button",
                    {
                      type: "button",
                      onClick: Nt,
                      title: "Open a live voice conversation with THEO",
                      "aria-label": "Call THEO",
                      style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        background: "linear-gradient(135deg, rgba(139,92,246,0.22) 0%, rgba(168,85,247,0.22) 100%)",
                        border: "1px solid rgba(168,85,247,0.55)",
                        color: "#ddd6fe",
                        padding: "4px 9px",
                        borderRadius: 999,
                        cursor: "pointer",
                        fontFamily: "inherit",
                        fontSize: 11,
                        fontWeight: 600,
                        lineHeight: 1
                      },
                      children: [
                        /* @__PURE__ */ e("svg", { width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" }) }),
                        "Call THEO"
                      ]
                    }
                  ),
                  c && /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => {
                        var h, U;
                        f(""), (h = gt.current) == null || h.abort(), (U = ze.current) == null || U.focus();
                      },
                      style: { background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 4 },
                      children: /* @__PURE__ */ e(We, { size: 14 })
                    }
                  ),
                  !de && /* @__PURE__ */ a(ue, { children: [
                    /* @__PURE__ */ e(
                      "a",
                      {
                        href: "https://theo.theonestack.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        title: "Open THEO full app",
                        style: { display: "flex", alignItems: "center", gap: 3, color: "#475569", textDecoration: "none", fontSize: 11, padding: "2px 6px", borderRadius: 4, border: "1px solid #334155", whiteSpace: "nowrap" },
                        onMouseEnter: (h) => {
                          h.currentTarget.style.color = "#a78bfa", h.currentTarget.style.borderColor = "#6366f1";
                        },
                        onMouseLeave: (h) => {
                          h.currentTarget.style.color = "#475569", h.currentTarget.style.borderColor = "#334155";
                        },
                        children: "↗ Open full app"
                      }
                    ),
                    /* @__PURE__ */ e("button", { onClick: n, style: { background: "none", border: "1px solid #334155", cursor: "pointer", color: "#64748b", fontSize: 11, padding: "2px 6px", borderRadius: 4 }, children: "Esc" })
                  ] })
                ] }),
                R && !we && /* @__PURE__ */ e("div", { style: { padding: "12px 16px", borderBottom: "1px solid #334155", background: "rgba(139,92,246,0.08)", flexShrink: 0 }, children: /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "flex-start", gap: 10 }, children: [
                  /* @__PURE__ */ e("span", { style: { fontSize: 20, lineHeight: 1 }, children: "✨" }),
                  /* @__PURE__ */ a("div", { children: [
                    /* @__PURE__ */ a("div", { style: { color: "#e2e8f0", fontSize: 13, fontWeight: 600, marginBottom: 4 }, children: [
                      "Welcome to ",
                      Co[i] ?? "The One Stack",
                      "! I'm THEO, your AI assistant."
                    ] }),
                    /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 12, lineHeight: 1.6 }, children: "Ask me anything — “How do I get started?”, “What should I do first?”, or try one of the quick actions below." })
                  ] })
                ] }) }),
                !we && /* @__PURE__ */ a("div", { style: { padding: "8px 0", overflowY: "auto" }, children: [
                  /* @__PURE__ */ e("div", { style: { padding: "4px 16px 6px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }, children: "Quick actions" }),
                  ct.map((h, U) => /* @__PURE__ */ a(
                    "button",
                    {
                      onMouseEnter: () => C(U),
                      onClick: () => Re(h.label),
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        width: "100%",
                        padding: "7px 16px",
                        background: _ === U ? "rgba(248,113,25,0.1)" : "transparent",
                        border: "none",
                        cursor: "pointer",
                        textAlign: "left",
                        color: _ === U ? "#f97316" : "#cbd5e1",
                        fontSize: 13
                      },
                      children: [
                        /* @__PURE__ */ e("span", { style: { fontSize: 15 }, children: h.icon }),
                        /* @__PURE__ */ e("span", { children: h.label }),
                        h.hint && /* @__PURE__ */ e("span", { style: { marginLeft: "auto", color: "#475569", fontSize: 11 }, children: h.hint })
                      ]
                    },
                    h.label
                  )),
                  v.length > 0 && /* @__PURE__ */ a(ue, { children: [
                    /* @__PURE__ */ e("div", { style: { padding: "8px 16px 4px", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", borderTop: "1px solid #1e293b", marginTop: 4 }, children: "Recent" }),
                    v.map((h) => /* @__PURE__ */ a(
                      "button",
                      {
                        onClick: () => {
                          f(h), Re(h);
                        },
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          width: "100%",
                          padding: "7px 16px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          color: "#94a3b8",
                          fontSize: 13,
                          textAlign: "left"
                        },
                        children: [
                          /* @__PURE__ */ e("span", { style: { fontSize: 12 }, children: "🕐" }),
                          h
                        ]
                      },
                      h
                    ))
                  ] })
                ] }),
                (w == null ? void 0 : w.limit) && w.count >= w.limit && /* @__PURE__ */ a("div", { style: { padding: "10px 16px", borderTop: "1px solid #334155", background: "rgba(239,68,68,0.08)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }, children: [
                  /* @__PURE__ */ e("span", { style: { fontSize: 14 }, children: "🔒" }),
                  /* @__PURE__ */ a("div", { style: { flex: 1 }, children: [
                    /* @__PURE__ */ e("div", { style: { color: "#fca5a5", fontSize: 12, fontWeight: 600 }, children: "Daily limit reached" }),
                    /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 11 }, children: "Resets at midnight UTC" })
                  ] }),
                  /* @__PURE__ */ e(
                    "a",
                    {
                      href: "https://hub.theonestack.com/billing",
                      target: "_blank",
                      rel: "noreferrer",
                      style: { fontSize: 11, color: "#f97316", fontWeight: 600, textDecoration: "none", padding: "4px 10px", border: "1px solid #f97316", borderRadius: 6, whiteSpace: "nowrap" },
                      children: "⚡ Upgrade"
                    }
                  )
                ] }),
                (w == null ? void 0 : w.limit) && w.count >= Math.floor(w.limit * 0.8) && w.count < w.limit && /* @__PURE__ */ a("div", { style: { padding: "8px 16px", borderTop: "1px solid #334155", background: "rgba(249,115,22,0.06)", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }, children: [
                  /* @__PURE__ */ a("span", { style: { fontSize: 12, color: "#fb923c" }, children: [
                    "⚡ ",
                    w.limit - w.count,
                    " free ",
                    w.limit - w.count === 1 ? "query" : "queries",
                    " remaining today"
                  ] }),
                  /* @__PURE__ */ e(
                    "a",
                    {
                      href: "https://hub.theonestack.com/billing",
                      target: "_blank",
                      rel: "noreferrer",
                      style: { marginLeft: "auto", fontSize: 11, color: "#f97316", fontWeight: 600, textDecoration: "none" },
                      children: "Upgrade →"
                    }
                  )
                ] }),
                A && !M && /* @__PURE__ */ a("div", { style: { padding: "10px 16px", borderTop: "1px solid #334155", background: "rgba(139,92,246,0.08)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }, children: [
                  /* @__PURE__ */ e("span", { style: { fontSize: 14 }, children: "💡" }),
                  /* @__PURE__ */ a("div", { style: { flex: 1 }, children: [
                    /* @__PURE__ */ e("div", { style: { color: "#a78bfa", fontSize: 12, fontWeight: 600 }, children: "THEO wants to remember:" }),
                    /* @__PURE__ */ a("div", { style: { color: "#cbd5e1", fontSize: 12, marginTop: 2 }, children: [
                      "“",
                      A,
                      "”"
                    ] })
                  ] }),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: async () => {
                        try {
                          await fetch(`${o}/api/v1/theo/memory`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            credentials: "include",
                            body: JSON.stringify({ scope: "org", memory_type: "context", content: A })
                          });
                        } catch {
                        }
                        G(null), L(!0);
                      },
                      style: { padding: "4px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer", background: "rgba(139,92,246,0.3)", border: "1px solid rgba(139,92,246,0.5)", color: "#a78bfa", fontWeight: 600, whiteSpace: "nowrap" },
                      children: "Save this"
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => {
                        G(null), L(!0);
                      },
                      style: { background: "none", border: "none", cursor: "pointer", color: "#475569", fontSize: 12 },
                      children: "No thanks"
                    }
                  )
                ] }),
                oe && /* @__PURE__ */ e("div", { style: {
                  position: "absolute",
                  bottom: 52,
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "#1e293b",
                  border: "1px solid #334155",
                  borderRadius: 8,
                  padding: "6px 14px",
                  fontSize: 12,
                  color: "#94a3b8",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                  animation: "theo-fade-in 0.2s ease-out",
                  pointerEvents: "none",
                  whiteSpace: "nowrap",
                  zIndex: 10
                }, children: "Thanks for the feedback" }),
                /* @__PURE__ */ a("div", { style: { padding: "8px 16px", borderTop: "1px solid #1e293b", display: "flex", alignItems: "center", gap: 8, fontSize: 11, color: "#475569", flexShrink: 0 }, children: [
                  !de && /* @__PURE__ */ e("div", { style: { position: "relative" }, children: /* @__PURE__ */ e(
                    Ao,
                    {
                      customGpts: Ge,
                      selectedId: Ve,
                      upgradeRequired: Mt,
                      open: ot,
                      onToggle: () => Ye((h) => !h),
                      onSelect: (h) => {
                        Qe(h), Ye(!1), we && xt();
                      }
                    }
                  ) }),
                  /* @__PURE__ */ e("span", { children: "↑↓ navigate" }),
                  /* @__PURE__ */ e("span", { children: "·" }),
                  /* @__PURE__ */ e("span", { children: "↵ submit" }),
                  /* @__PURE__ */ e("span", { children: "·" }),
                  /* @__PURE__ */ e("span", { children: "Esc close" }),
                  !we && /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => {
                        F(!0);
                      },
                      title: "Replay THEO intro",
                      style: { marginLeft: "auto", background: "none", border: "1px solid #334155", cursor: "pointer", color: "#475569", fontSize: 10, padding: "2px 7px", borderRadius: 4, fontFamily: "inherit" },
                      onMouseEnter: (h) => h.currentTarget.style.color = "#6366f1",
                      onMouseLeave: (h) => h.currentTarget.style.color = "#475569",
                      children: "? Intro"
                    }
                  ),
                  !window.__theoDesktop && /* @__PURE__ */ e(
                    "a",
                    {
                      href: "https://theo.theonestack.com/download",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      title: "Get the THEO desktop app",
                      style: { marginLeft: we ? "auto" : void 0, display: "flex", alignItems: "center", gap: 3, color: "#475569", textDecoration: "none", fontSize: 11 },
                      onMouseEnter: (h) => h.currentTarget.style.color = "#a78bfa",
                      onMouseLeave: (h) => h.currentTarget.style.color = "#475569",
                      children: "💻 Desktop app"
                    }
                  ),
                  (w == null ? void 0 : w.limit) && /* @__PURE__ */ a("span", { style: { color: w.count >= w.limit ? "#ef4444" : w.count >= Math.floor(w.limit * 0.8) ? "#fb923c" : "#475569" }, children: [
                    w.count,
                    "/",
                    w.limit,
                    " today"
                  ] })
                ] })
              ] })
            ]
          }
        ),
        mt && ke && /* @__PURE__ */ e(
          ke,
          {
            apiBase: o,
            onClose: () => it(!1)
          }
        )
      ]
    }
  );
}
const Eo = {
  psa: {
    name: "PSA",
    color: "#f97316",
    actions: [
      { label: "New Ticket", path: "/psa/service-desk/tickets/new" },
      { label: "Log Time", path: "/psa/time-tracking/new" },
      { label: "New Invoice", path: "/psa/finance/invoices/new" },
      { label: "New Company", path: "/psa/companies/new" },
      { label: "New Contract", path: "/psa/finance/contracts/new" }
    ]
  },
  rmm: {
    name: "RMM",
    color: "#3b82f6",
    actions: [
      { label: "View Alerts", path: "/rmm/alerts" },
      { label: "Run Script", path: "/rmm/scripts/new" },
      { label: "New Device Group", path: "/rmm/device-groups/new" },
      { label: "View Devices", path: "/rmm/devices" }
    ]
  },
  crm: {
    name: "CRM",
    color: "#8b5cf6",
    actions: [
      { label: "New Lead", path: "/crm/leads/new" },
      { label: "New Deal", path: "/crm/pipeline/new" },
      { label: "New Contact", path: "/crm/contacts/new" },
      { label: "New Company", path: "/crm/companies/new" }
    ]
  },
  books: {
    name: "Books",
    color: "#10b981",
    actions: [
      { label: "New Invoice", path: "/books/invoices/new" },
      { label: "New Estimate", path: "/books/estimates/new" },
      { label: "Record Payment", path: "/books/payments/new" },
      { label: "New Expense", path: "/books/expenses/new" }
    ]
  },
  voice: {
    name: "Voice",
    color: "#06b6d4",
    actions: [
      { label: "New Call", path: "/voice/calls/new" },
      { label: "Send SMS", path: "/voice/sms/new" },
      { label: "View Voicemail", path: "/voice/voicemail" }
    ]
  },
  projects: {
    name: "Projects",
    color: "#f59e0b",
    actions: [
      { label: "New Project", path: "/projects/new" },
      { label: "New Milestone", path: "/projects/milestones/new" },
      { label: "New Task", path: "/projects/tasks/new" }
    ]
  },
  security: {
    name: "Security",
    color: "#ef4444",
    actions: [
      { label: "View Alerts", path: "/security/alerts" },
      { label: "New Scan", path: "/security/scans/new" },
      { label: "View Reports", path: "/security/reports" }
    ]
  }
};
function ia({
  products: t,
  hubUrl: n = ""
}) {
  const [o, i] = y(!1), r = K(null);
  H(() => {
    if (!o) return;
    function c(f) {
      r.current && !r.current.contains(f.target) && i(!1);
    }
    return document.addEventListener("mousedown", c), () => document.removeEventListener("mousedown", c);
  }, [o]), H(() => {
    if (!o) return;
    function c(f) {
      f.key === "Escape" && i(!1);
    }
    return document.addEventListener("keydown", c), () => document.removeEventListener("keydown", c);
  }, [o]);
  const l = t.filter(
    (c) => (c.active || c.has_beta_access) && (c.launch_status === "ga" || c.launch_status === "beta_invite") && Eo[c.id]
  ).slice(0, 7).map((c) => ({ product: c, config: Eo[c.id] })), d = l.length > 3 ? 2 : 1;
  return /* @__PURE__ */ a("div", { ref: r, style: { position: "relative", flexShrink: 0 }, children: [
    /* @__PURE__ */ a(
      "button",
      {
        type: "button",
        onClick: () => i((c) => !c),
        "aria-label": "Quick Create",
        "aria-expanded": o,
        "aria-haspopup": "true",
        style: {
          display: "flex",
          alignItems: "center",
          gap: 5,
          height: 30,
          padding: "0 10px",
          borderRadius: 6,
          background: o ? "rgba(249,115,22,0.15)" : "rgba(255,255,255,0.06)",
          border: `1px solid ${o ? "rgba(249,115,22,0.35)" : "rgba(255,255,255,0.1)"}`,
          color: o ? "#f97316" : "#cbd5e1",
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 500,
          transition: "all 0.15s",
          whiteSpace: "nowrap"
        },
        onMouseEnter: (c) => {
          if (!o) {
            const f = c.currentTarget;
            f.style.background = "rgba(255,255,255,0.09)", f.style.color = "#f1f5f9", f.style.borderColor = "rgba(255,255,255,0.15)";
          }
        },
        onMouseLeave: (c) => {
          if (!o) {
            const f = c.currentTarget;
            f.style.background = "rgba(255,255,255,0.06)", f.style.color = "#cbd5e1", f.style.borderColor = "rgba(255,255,255,0.1)";
          }
        },
        children: [
          /* @__PURE__ */ e("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { d: "M7 1v12M1 7h12", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round" }) }),
          /* @__PURE__ */ e("span", { children: "Create" })
        ]
      }
    ),
    o && /* @__PURE__ */ a(
      "div",
      {
        role: "menu",
        style: {
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          width: d === 2 ? 480 : 240,
          maxHeight: "calc(100vh - 80px)",
          overflowY: "auto",
          background: "#18181b",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 10,
          boxShadow: "0 24px 64px rgba(0,0,0,0.55)",
          zIndex: 10001
        },
        children: [
          l.length === 0 ? /* @__PURE__ */ e("div", { style: { padding: "20px", color: "#64748b", fontSize: 13, textAlign: "center" }, children: "No active products found" }) : /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: `repeat(${d}, 1fr)`,
                gap: 0
              },
              children: l.map(({ product: c, config: f }, u) => {
                const k = u % d;
                return /* @__PURE__ */ a(
                  "div",
                  {
                    style: {
                      padding: "14px 16px",
                      borderRight: d === 2 && k === 0 ? "1px solid rgba(255,255,255,0.06)" : "none",
                      borderBottom: u < l.length - d ? "1px solid rgba(255,255,255,0.06)" : "none"
                    },
                    children: [
                      /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }, children: [
                        /* @__PURE__ */ e(
                          "span",
                          {
                            style: {
                              display: "inline-block",
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              background: f.color,
                              flexShrink: 0
                            }
                          }
                        ),
                        /* @__PURE__ */ e(
                          "span",
                          {
                            style: {
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#64748b",
                              textTransform: "uppercase",
                              letterSpacing: "0.08em"
                            },
                            children: f.name
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 1 }, children: f.actions.map((S) => /* @__PURE__ */ e(
                        "a",
                        {
                          href: `${n}${S.path}`,
                          role: "menuitem",
                          onClick: () => i(!1),
                          style: {
                            display: "block",
                            padding: "5px 8px",
                            borderRadius: 5,
                            color: "#cbd5e1",
                            fontSize: 12.5,
                            textDecoration: "none",
                            transition: "background 0.1s, color 0.1s"
                          },
                          onMouseEnter: (v) => {
                            const g = v.currentTarget;
                            g.style.background = "rgba(255,255,255,0.07)", g.style.color = "#f1f5f9";
                          },
                          onMouseLeave: (v) => {
                            const g = v.currentTarget;
                            g.style.background = "transparent", g.style.color = "#cbd5e1";
                          },
                          children: S.label
                        },
                        S.label
                      )) })
                    ]
                  },
                  c.id
                );
              })
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              style: {
                borderTop: "1px solid rgba(255,255,255,0.06)",
                padding: "8px 16px",
                fontSize: 11,
                color: "#475569"
              },
              children: "Only showing products you have access to"
            }
          )
        ]
      }
    )
  ] });
}
const aa = typeof window < "u" && window.__GATHER_URL__ || "https://app.theonestack.com/gather";
function sa(t, n, o) {
  const [i, r] = y([]), l = K(null), d = K(0);
  return H(() => {
    if (!n || !o) return;
    let c = !1;
    async function f() {
      if (!(Date.now() < d.current))
        try {
          const u = await fetch(`${t}/api/v1/gather/presence/all`, {
            credentials: "include"
          });
          if (u.status === 429) {
            d.current = Date.now() + 12e4;
            return;
          }
          if (u.ok && !c) {
            const k = await u.json();
            r(k.active_spaces ?? []);
          }
        } catch {
        }
    }
    return f(), l.current = setInterval(f, 3e4), () => {
      c = !0, l.current && clearInterval(l.current);
    };
  }, [t, n, o]), i;
}
function la({ apiBase: t, tenantId: n, userId: o, currentProduct: i }) {
  var b;
  const r = sa(t, n, o), [l, d] = y(!1), c = r.length > 0, f = i === "gather", u = t.includes("localhost") ? "http://localhost:5180" : aa, k = c && r[0] ? `${u}/space/${r[0].space_id}` : u;
  return /* @__PURE__ */ a("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ a(
      "a",
      {
        href: k,
        target: "_blank",
        rel: "noopener noreferrer",
        onMouseEnter: () => d(!0),
        onMouseLeave: () => d(!1),
        title: c ? `In Gather — ${r.map((S) => S.space_name).join(", ")}` : "The One Gather",
        "aria-label": c ? `In Gather — ${(b = r[0]) == null ? void 0 : b.space_name}` : "Open Gather",
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: 8,
          textDecoration: "none",
          position: "relative",
          background: f ? "rgba(99,102,241,0.2)" : c ? "rgba(34,197,94,0.12)" : "transparent",
          border: f ? "1px solid rgba(99,102,241,0.4)" : c ? "1px solid rgba(34,197,94,0.25)" : "1px solid transparent",
          transition: "all 0.15s"
        },
        children: [
          /* @__PURE__ */ e(ca, { active: c, isCurrentProduct: f }),
          c && /* @__PURE__ */ e(
            "span",
            {
              style: {
                position: "absolute",
                top: 4,
                right: 4,
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#22c55e",
                border: "1.5px solid #09090b"
              },
              children: /* @__PURE__ */ e(
                "span",
                {
                  style: {
                    position: "absolute",
                    inset: -3,
                    borderRadius: "50%",
                    border: "2px solid rgba(34,197,94,0.4)",
                    animation: "gather-pulse 2s ease-out infinite"
                  }
                }
              )
            }
          )
        ]
      }
    ),
    l && /* @__PURE__ */ e(
      "div",
      {
        style: {
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          background: "#1e1e30",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 8,
          padding: "8px 12px",
          fontSize: 12,
          color: "#f1f5f9",
          whiteSpace: "nowrap",
          zIndex: 1e4,
          boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
          minWidth: 140,
          pointerEvents: "none"
        },
        children: c ? /* @__PURE__ */ a(ue, { children: [
          /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: 4, color: "#22c55e" }, children: "● In Gather" }),
          r.map((S) => /* @__PURE__ */ e("div", { style: { color: "#94a3b8", fontSize: 11 }, children: S.space_name }, S.space_id)),
          /* @__PURE__ */ e("div", { style: { marginTop: 6, color: "#475569", fontSize: 11, borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 6 }, children: "Click to return to space" })
        ] }) : /* @__PURE__ */ a(ue, { children: [
          /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: 2 }, children: "The One Gather" }),
          /* @__PURE__ */ e("div", { style: { color: "#64748b", fontSize: 11 }, children: "Virtual spaces for your team" })
        ] })
      }
    ),
    /* @__PURE__ */ e("style", { children: `
        @keyframes gather-pulse {
          0% { transform: scale(0.8); opacity: 1; }
          100% { transform: scale(2.2); opacity: 0; }
        }
      ` })
  ] });
}
function ca({ active: t, isCurrentProduct: n }) {
  const o = n ? "#a5b4fc" : t ? "#4ade80" : "#64748b";
  return /* @__PURE__ */ a("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", children: [
    /* @__PURE__ */ e("circle", { cx: "8", cy: "8", r: "2.5", fill: o }),
    /* @__PURE__ */ e("circle", { cx: "8", cy: "2.5", r: "1.5", fill: o, opacity: "0.85" }),
    /* @__PURE__ */ e("circle", { cx: "13.1", cy: "11", r: "1.5", fill: o, opacity: "0.7" }),
    /* @__PURE__ */ e("circle", { cx: "2.9", cy: "11", r: "1.5", fill: o, opacity: "0.55" }),
    /* @__PURE__ */ e("line", { x1: "8", y1: "4", x2: "8", y2: "5.5", stroke: o, strokeWidth: "1", opacity: "0.5" }),
    /* @__PURE__ */ e("line", { x1: "11.8", y1: "10", x2: "10.1", y2: "9.1", stroke: o, strokeWidth: "1", opacity: "0.4" }),
    /* @__PURE__ */ e("line", { x1: "4.2", y1: "10", x2: "5.9", y2: "9.1", stroke: o, strokeWidth: "1", opacity: "0.4" })
  ] });
}
function zn() {
  return Math.random().toString(36).slice(2);
}
function da({ open: t, onClose: n, apiBase: o, tenantId: i, session: r }) {
  const [l, d] = y([
    {
      id: "welcome",
      role: "assistant",
      content: `Hi${r.firstName ? ` ${r.firstName}` : ""}! I'm THEO, your support assistant. I can help you with tickets, check device status, review invoices, or answer questions about your services. What can I help you with today?`,
      ts: (/* @__PURE__ */ new Date()).toISOString()
    }
  ]), [c, f] = y(""), [u, k] = y(!1), b = K(null);
  H(() => {
    var v;
    (v = b.current) == null || v.scrollIntoView({ behavior: "smooth" });
  }, [l]);
  async function S() {
    const v = c.trim();
    if (!v || u) return;
    const g = { id: zn(), role: "user", content: v, ts: (/* @__PURE__ */ new Date()).toISOString() };
    d((_) => [..._, g]), f(""), k(!0);
    try {
      const R = (await (await fetch(`${o}/api/portal/theo/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          message: v,
          history: l.slice(-6).map((P) => ({ role: P.role, content: P.content })),
          tenant_id: i,
          user_id: r.userId
        })
      })).json().catch(() => ({}))).reply || "I'm having trouble processing that right now. Please try again or contact support directly.";
      d((P) => [...P, {
        id: zn(),
        role: "assistant",
        content: R,
        ts: (/* @__PURE__ */ new Date()).toISOString()
      }]);
    } catch {
      d((_) => [..._, {
        id: zn(),
        role: "assistant",
        content: "Something went wrong. Please try again in a moment.",
        ts: (/* @__PURE__ */ new Date()).toISOString()
      }]);
    } finally {
      k(!1);
    }
  }
  return t ? /* @__PURE__ */ a(
    "div",
    {
      className: "hb-mini-theo",
      role: "dialog",
      "aria-label": "THEO Support Chat",
      style: {
        position: "fixed",
        bottom: "56px",
        right: "16px",
        width: "360px",
        maxHeight: "520px",
        background: "#1e293b",
        border: "1px solid #334155",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        zIndex: 9999,
        boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        overflow: "hidden"
      },
      children: [
        /* @__PURE__ */ a("div", { style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #334155",
          background: "#0f172a"
        }, children: [
          /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
            /* @__PURE__ */ e("div", { style: {
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: "700",
              color: "#fff"
            }, children: "T" }),
            /* @__PURE__ */ a("div", { children: [
              /* @__PURE__ */ e("div", { style: { fontSize: "13px", fontWeight: "600", color: "#f1f5f9" }, children: "THEO" }),
              /* @__PURE__ */ e("div", { style: { fontSize: "11px", color: "#94a3b8" }, children: "Support Assistant" })
            ] })
          ] }),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: n,
              style: {
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#64748b",
                padding: "4px",
                borderRadius: "4px",
                fontSize: "18px",
                lineHeight: 1
              },
              "aria-label": "Close THEO chat",
              children: "×"
            }
          )
        ] }),
        /* @__PURE__ */ a("div", { style: {
          flex: 1,
          overflowY: "auto",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          minHeight: 0
        }, children: [
          l.map((v) => /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: v.role === "user" ? "flex-end" : "flex-start"
              },
              children: /* @__PURE__ */ e("div", { style: {
                maxWidth: "85%",
                padding: "8px 12px",
                borderRadius: v.role === "user" ? "12px 12px 4px 12px" : "12px 12px 12px 4px",
                background: v.role === "user" ? "#6d28d9" : "#334155",
                color: "#f1f5f9",
                fontSize: "13px",
                lineHeight: "1.5",
                wordBreak: "break-word"
              }, children: v.content })
            },
            v.id
          )),
          u && /* @__PURE__ */ e("div", { style: { display: "flex", justifyContent: "flex-start" }, children: /* @__PURE__ */ e("div", { style: {
            padding: "8px 12px",
            borderRadius: "12px 12px 12px 4px",
            background: "#334155",
            color: "#94a3b8",
            fontSize: "13px"
          }, children: /* @__PURE__ */ e("span", { style: { animation: "pulse 1.5s infinite" }, children: "●●●" }) }) }),
          /* @__PURE__ */ e("div", { ref: b })
        ] }),
        /* @__PURE__ */ a("div", { style: {
          padding: "10px 12px",
          borderTop: "1px solid #334155",
          display: "flex",
          gap: "8px",
          background: "#0f172a"
        }, children: [
          /* @__PURE__ */ e(
            "input",
            {
              type: "text",
              value: c,
              onChange: (v) => f(v.target.value),
              onKeyDown: (v) => {
                v.key === "Enter" && !v.shiftKey && (v.preventDefault(), S());
              },
              placeholder: "Ask THEO...",
              disabled: u,
              style: {
                flex: 1,
                background: "#1e293b",
                border: "1px solid #334155",
                borderRadius: "8px",
                padding: "8px 12px",
                color: "#f1f5f9",
                fontSize: "13px",
                outline: "none"
              }
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: () => void S(),
              disabled: u || !c.trim(),
              style: {
                background: "#6d28d9",
                border: "none",
                borderRadius: "8px",
                padding: "8px 12px",
                color: "#fff",
                cursor: u || !c.trim() ? "not-allowed" : "pointer",
                opacity: u || !c.trim() ? 0.5 : 1,
                fontSize: "13px",
                fontWeight: "600"
              },
              children: "Send"
            }
          )
        ] })
      ]
    }
  ) : null;
}
function pa({ open: t, onToggle: n }) {
  return /* @__PURE__ */ a(
    "button",
    {
      className: "hb-btn hb-btn--icon",
      onClick: n,
      "aria-label": "Open THEO support chat",
      "aria-expanded": t,
      style: {
        background: t ? "#6d28d9" : void 0,
        borderRadius: "6px"
      },
      children: [
        /* @__PURE__ */ a("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5" }),
          /* @__PURE__ */ e("path", { d: "M8 12h8M8 8h8M8 16h5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })
        ] }),
        /* @__PURE__ */ e("span", { className: "hb-label", children: "Support" })
      ]
    }
  );
}
async function Te(t, n = {}) {
  const o = await fetch(t, {
    credentials: "include",
    ...n,
    headers: {
      Accept: "application/json",
      ...n.body ? { "Content-Type": "application/json" } : {},
      ...n.headers || {}
    }
  });
  if (!o.ok) {
    let i = `HTTP ${o.status}`;
    try {
      const r = await o.json();
      r.error && (i = r.error);
    } catch {
    }
    throw new Error(i);
  }
  return o.json();
}
function ha(t, n) {
  const o = /* @__PURE__ */ new Map();
  for (const i of t) {
    const r = n.has(i.from) ? i.to : i.from, l = o.get(r);
    l ? new Date(i.created_at).getTime() > new Date(l.lastMessageAt).getTime() && (l.lastMessageAt = i.created_at, l.lastMessagePreview = i.body.slice(0, 80)) : o.set(r, {
      peer: r,
      lastMessageAt: i.created_at,
      lastMessagePreview: i.body.slice(0, 80),
      unreadCount: i.direction === "inbound" && i.status !== "read" ? 1 : 0
    });
  }
  return Array.from(o.values()).sort(
    (i, r) => new Date(r.lastMessageAt).getTime() - new Date(i.lastMessageAt).getTime()
  );
}
function ua({ apiBase: t, orgId: n }) {
  const [o, i] = y("idle"), [r, l] = y(null), [d, c] = y(!1), [f, u] = y(!1), [k, b] = y(!1), [S, v] = y(0), [g, _] = y([]), [C, R] = y([]), [P, w] = y(!1), [p, A] = y(!1), [G, M] = y(null), L = K(null);
  H(() => {
    L.current = r;
  }, [r]);
  const W = K("idle");
  H(() => {
    W.current = o;
  }, [o]), H(() => {
    if (o !== "active" || !r) {
      v(0);
      return;
    }
    const z = r.startTime, O = setInterval(() => {
      v(Math.max(0, Math.floor((Date.now() - z) / 1e3)));
    }, 1e3);
    return () => clearInterval(O);
  }, [o, r]);
  const F = D(async () => {
    w(!0);
    try {
      const z = await Te(
        `${t}/api/v1/voice/calls?limit=10`
      );
      _(
        z.calls.map((O) => ({
          id: O.id,
          direction: O.direction ?? "outbound",
          status: O.status ?? "unknown",
          fromNumber: O.from_number ?? "",
          toNumber: O.to_number ?? "",
          startedAt: O.started_at ?? "",
          durationSecs: O.duration_secs ?? null,
          missed: !!O.missed_at || O.status === "missed"
        }))
      );
    } catch (z) {
      console.warn("[phone] refreshRecents failed:", z instanceof Error ? z.message : String(z));
    } finally {
      w(!1);
    }
  }, [t]), q = D(async () => {
    A(!0);
    try {
      const z = await Te(
        `${t}/api/v1/voice/sms?limit=200`
      ), O = /* @__PURE__ */ new Set();
      for (const V of z.messages)
        V.direction === "outbound" && V.from && O.add(V.from);
      R(ha(z.messages, O));
    } catch (z) {
      console.warn("[phone] refreshThreads failed:", z instanceof Error ? z.message : String(z));
    } finally {
      A(!1);
    }
  }, [t]), j = D(async (z) => {
    try {
      return (await Te(
        `${t}/api/v1/voice/sms?limit=100&phone=${encodeURIComponent(z)}`
      )).messages.map((V) => ({
        id: V.id,
        direction: V.direction,
        from: V.from,
        to: V.to,
        body: V.body,
        status: V.status,
        createdAt: V.created_at
      }));
    } catch (O) {
      return M(O instanceof Error ? O.message : "Failed to load messages"), [];
    }
  }, [t]);
  H(() => {
    if (!n) return;
    let z = !1, O = null;
    try {
      O = new EventSource(
        `${t}/api/v1/voice/livekit/incoming-stream`,
        { withCredentials: !0 }
      );
    } catch {
      return;
    }
    const V = (Ue) => {
      if (!z)
        try {
          const ge = JSON.parse(Ue.data);
          if (L.current && W.current === "active") return;
          l({
            id: ge.call_id,
            roomName: ge.room_name,
            direction: "inbound",
            from: ge.caller_org_id || "Unknown caller",
            to: n ?? "",
            callerName: ge.greeting,
            startTime: Date.now()
          }), i("ringing");
        } catch {
        }
    };
    return O.addEventListener("inapp_call", V), O.addEventListener("incoming_call", V), O.onerror = () => {
    }, () => {
      z = !0, O == null || O.close();
    };
  }, [t, n]), H(() => {
    if (!n) return;
    let z = !1, O = /* @__PURE__ */ new Set(), V = 0;
    const Ue = async () => {
      if (!z && !(Date.now() < V))
        try {
          const Fe = await fetch(
            `${t}/api/v1/voice/calls?limit=5&direction=inbound`,
            { credentials: "include", headers: { Accept: "application/json" } }
          );
          if (Fe.status === 429) {
            V = Date.now() + 6e4;
            return;
          }
          if (!Fe.ok) return;
          const Xe = await Fe.json();
          for (const ce of Xe.calls)
            ce.status === "ringing" && !O.has(ce.id) && (L.current || (l({
              id: ce.id,
              roomName: ce.room_name ?? void 0,
              callControlId: ce.call_control_id ?? void 0,
              direction: "inbound",
              from: ce.from_number ?? "Unknown",
              to: ce.to_number ?? "",
              callerName: ce.caller_display ?? void 0,
              startTime: ce.started_at ? new Date(ce.started_at).getTime() : Date.now()
            }), i("ringing")));
          O = new Set(Xe.calls.map((ce) => ce.id));
        } catch {
        }
    };
    Ue();
    const ge = setInterval(Ue, 15e3);
    return () => {
      z = !0, clearInterval(ge);
    };
  }, [t, n]), H(() => {
    n && (F(), q());
  }, [n, F, q]);
  const X = D(async (z) => {
    if (!z.trim()) {
      M("Enter a number to call");
      return;
    }
    M(null);
    try {
      const O = await Te(
        `${t}/api/v1/voice/calls`,
        { method: "POST", body: JSON.stringify({ to: z.trim() }) }
      ), V = O.call_id ?? O.call_session_id ?? O.call_control_id ?? `out_${Date.now()}`;
      l({
        id: V,
        roomName: O.room_name,
        callControlId: O.call_control_id,
        direction: "outbound",
        from: "",
        to: z.trim(),
        startTime: Date.now()
      }), i("active"), c(!1), u(!1), b(!1);
    } catch (O) {
      M(O instanceof Error ? O.message : "Call failed"), i("idle"), l(null);
    }
  }, [t]), I = D(async () => {
    r && (i("active"), l({ ...r, startTime: Date.now() }));
  }, [r]), J = D(async () => {
    const z = r;
    if (z) {
      i("idle"), l(null);
      try {
        await Te(`${t}/api/v1/voice/calls/${encodeURIComponent(z.id)}`, {
          method: "DELETE"
        });
      } catch {
      }
      F();
    }
  }, [t, r, F]), ie = D(async () => {
    const z = r;
    if (z) {
      i("idle"), l(null), c(!1), u(!1), b(!1);
      try {
        await Te(`${t}/api/v1/voice/calls/${encodeURIComponent(z.id)}`, {
          method: "DELETE"
        });
      } catch {
      }
      F();
    }
  }, [t, r, F]), oe = D(async () => {
    const z = r;
    if (!(z != null && z.roomName)) {
      u(!0), i("held");
      return;
    }
    try {
      await Te(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(z.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !0 }) }
      ), u(!0), i("held");
    } catch (O) {
      M(O instanceof Error ? O.message : "Hold failed");
    }
  }, [t, r]), le = D(async () => {
    const z = r;
    if (!(z != null && z.roomName)) {
      u(!1), i("active");
      return;
    }
    try {
      await Te(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(z.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !1 }) }
      ), u(!1), i("active");
    } catch (O) {
      M(O instanceof Error ? O.message : "Resume failed");
    }
  }, [t, r]), te = D((z) => {
    c(z);
  }, []), re = D(async (z) => {
    const O = r;
    if (!(O != null && O.roomName)) {
      M("Transfer unavailable — no active room");
      return;
    }
    if (!z.trim()) {
      M("Enter a transfer destination");
      return;
    }
    try {
      const V = /^\d{3,6}$/.test(z.trim()) ? "extension" : "phone_number";
      await Te(
        `${t}/api/v1/voice/call-controls/calls/${encodeURIComponent(O.roomName)}/transfer`,
        {
          method: "POST",
          body: JSON.stringify({
            transfer_type: "blind",
            destination: z.trim(),
            destination_type: V
          })
        }
      ), i("transferred"), l(null), F();
    } catch (V) {
      M(V instanceof Error ? V.message : "Transfer failed");
    }
  }, [t, r, F]), B = D(async () => {
    const z = r;
    if (!(z != null && z.roomName)) {
      b(!0), i("held");
      return;
    }
    try {
      await Te(
        `${t}/api/v1/voice/livekit/call/${encodeURIComponent(z.roomName)}/hold`,
        { method: "POST", body: JSON.stringify({ hold: !0 }) }
      ), await Te(
        `${t}/api/v1/voice/call-controls/calls/${encodeURIComponent(z.roomName)}/moh`,
        { method: "POST", body: JSON.stringify({ enabled: !0 }) }
      ).catch(() => {
      }), b(!0), u(!0), i("held");
    } catch (O) {
      M(O instanceof Error ? O.message : "Park failed");
    }
  }, [t, r]), Ae = K(null), $ = D(async () => {
    var z;
    if (Ae.current) return Ae.current;
    try {
      const V = ((z = (await Te(
        `${t}/api/v1/voice/sms?direction=outbound&limit=1`
      )).messages[0]) == null ? void 0 : z.from) ?? null;
      return Ae.current = V, V;
    } catch {
      return null;
    }
  }, [t]), fe = D(async (z, O) => {
    if (!z.trim() || !O.trim()) {
      M("To and message are required");
      return;
    }
    M(null);
    try {
      const V = await $();
      if (!V) {
        M("No outbound number configured. Send an SMS from the Voice app first.");
        return;
      }
      await Te(`${t}/api/v1/voice/sms`, {
        method: "POST",
        body: JSON.stringify({ from: V, to: z.trim(), text: O.trim() })
      }), q();
    } catch (V) {
      M(V instanceof Error ? V.message : "Send failed");
    }
  }, [t, q, $]), ae = D(() => M(null), []);
  return {
    status: o,
    currentCall: r,
    isMuted: d,
    isHeld: f,
    isParked: k,
    duration: S,
    recentCalls: g,
    smsThreads: C,
    loadingRecents: P,
    loadingThreads: p,
    error: G,
    makeCall: X,
    acceptCall: I,
    declineCall: J,
    holdCall: oe,
    resumeCall: le,
    muteCall: te,
    transferCall: re,
    parkCall: B,
    hangUp: ie,
    sendSms: fe,
    listThreadMessages: j,
    refreshRecents: F,
    refreshThreads: q,
    clearError: ae
  };
}
class fa extends Xo {
  constructor(n) {
    super(n), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(n, o) {
    var i, r;
    console.warn("[hub-bar/phone] boundary caught:", n.message, (r = (i = o.componentStack) == null ? void 0 : i.split(`
`)[1]) == null ? void 0 : r.trim());
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
function ba(t) {
  return t.isPlatformOwner === !0 ? !0 : Array.isArray(t.entitlements) && t.entitlements.includes("voice");
}
function Jo(t) {
  const n = Math.floor(t / 60), o = t % 60;
  return `${n}:${o.toString().padStart(2, "0")}`;
}
function jn(t) {
  if (!t) return "";
  const n = new Date(t), i = ((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / 1e3;
  return i < 60 ? "just now" : i < 3600 ? `${Math.floor(i / 60)}m` : i < 86400 ? `${Math.floor(i / 3600)}h` : i < 604800 ? `${Math.floor(i / 86400)}d` : n.toLocaleDateString(void 0, { month: "short", day: "numeric" });
}
const ma = [
  { digit: "1" },
  { digit: "2", letters: "ABC" },
  { digit: "3", letters: "DEF" },
  { digit: "4", letters: "GHI" },
  { digit: "5", letters: "JKL" },
  { digit: "6", letters: "MNO" },
  { digit: "7", letters: "PQRS" },
  { digit: "8", letters: "TUV" },
  { digit: "9", letters: "WXYZ" },
  { digit: "*" },
  { digit: "0", letters: "+" },
  { digit: "#" }
], T = {
  bg: "#0f172a",
  surface: "#1e293b",
  surfaceHi: "#334155",
  border: "#334155",
  text: "#f1f5f9",
  muted: "#94a3b8",
  green: "#22c55e",
  red: "#ef4444",
  blue: "#3b82f6"
};
function ga({
  value: t,
  onChange: n,
  onCall: o,
  onSms: i
}) {
  const r = (d) => n(t + d), l = () => n(t.slice(0, -1));
  return /* @__PURE__ */ a("div", { style: { display: "flex", flexDirection: "column", flex: 1, padding: 12, gap: 12 }, children: [
    /* @__PURE__ */ a("div", { style: { display: "flex", gap: 6 }, children: [
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            flex: 1,
            background: T.surface,
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            padding: "10px 12px",
            color: T.text,
            fontSize: 18,
            fontFamily: "ui-monospace, SFMono-Regular, monospace",
            outline: "none"
          },
          value: t,
          onChange: (d) => n(d.target.value),
          placeholder: "Enter number or name",
          "aria-label": "Phone number or name"
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: l,
          disabled: !t,
          style: {
            background: T.surface,
            border: `1px solid ${T.border}`,
            color: T.text,
            borderRadius: 8,
            padding: "0 12px",
            cursor: t ? "pointer" : "not-allowed",
            opacity: t ? 1 : 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          "aria-label": "Backspace",
          title: "Backspace",
          children: /* @__PURE__ */ e(Er, { size: 16 })
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 8,
      flex: 1
    }, children: ma.map((d) => /* @__PURE__ */ a(
      "button",
      {
        onClick: () => r(d.digit),
        style: {
          background: T.surface,
          border: `1px solid ${T.border}`,
          borderRadius: 10,
          color: T.text,
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 8,
          transition: "background 0.12s",
          minHeight: 48
        },
        onMouseEnter: (c) => {
          c.currentTarget.style.background = T.surfaceHi;
        },
        onMouseLeave: (c) => {
          c.currentTarget.style.background = T.surface;
        },
        "aria-label": `Dial ${d.digit}`,
        children: [
          /* @__PURE__ */ e("span", { style: { fontSize: 20, fontWeight: 600 }, children: d.digit }),
          d.letters && /* @__PURE__ */ e("span", { style: { fontSize: 9, color: T.muted, letterSpacing: 1 }, children: d.letters })
        ]
      },
      d.digit
    )) }),
    /* @__PURE__ */ a("div", { style: { display: "flex", gap: 8 }, children: [
      /* @__PURE__ */ a(
        "button",
        {
          onClick: () => o(t),
          disabled: !t.trim(),
          style: {
            flex: 1,
            background: T.green,
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 0",
            cursor: t.trim() ? "pointer" : "not-allowed",
            opacity: t.trim() ? 1 : 0.4,
            fontSize: 14,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6
          },
          children: [
            /* @__PURE__ */ e(ft, { size: 16 }),
            " Call"
          ]
        }
      ),
      /* @__PURE__ */ a(
        "button",
        {
          onClick: () => i(t),
          disabled: !t.trim(),
          style: {
            flex: 1,
            background: T.blue,
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 0",
            cursor: t.trim() ? "pointer" : "not-allowed",
            opacity: t.trim() ? 1 : 0.4,
            fontSize: 14,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6
          },
          children: [
            /* @__PURE__ */ e(Wt, { size: 16 }),
            " SMS"
          ]
        }
      )
    ] })
  ] });
}
function xa({
  phone: t
}) {
  const {
    currentCall: n,
    status: o,
    duration: i,
    isMuted: r,
    isHeld: l,
    muteCall: d,
    holdCall: c,
    resumeCall: f,
    transferCall: u,
    parkCall: k,
    hangUp: b
  } = t, [S, v] = y(!1), [g, _] = y("");
  if (!n) return null;
  const C = n.direction === "inbound" ? n.callerName || n.from : n.to, R = n.direction === "inbound" ? /* @__PURE__ */ e(Hn, { size: 14 }) : /* @__PURE__ */ e(Do, { size: 14 });
  return /* @__PURE__ */ a("div", { style: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 20,
    gap: 16,
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ a("div", { style: { textAlign: "center" }, children: [
      /* @__PURE__ */ a("div", { style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: T.muted,
        textTransform: "uppercase",
        letterSpacing: 1
      }, children: [
        R,
        n.direction === "inbound" ? "Inbound" : "Outbound",
        o === "held" && " · On Hold"
      ] }),
      /* @__PURE__ */ e("div", { style: {
        fontSize: 22,
        fontWeight: 600,
        color: T.text,
        marginTop: 6,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: C || "Unknown" }),
      /* @__PURE__ */ e("div", { style: {
        fontSize: 28,
        color: T.muted,
        marginTop: 4,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: Jo(i) })
    ] }),
    S ? /* @__PURE__ */ a("div", { style: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      width: "100%",
      background: T.surface,
      border: `1px solid ${T.border}`,
      borderRadius: 10,
      padding: 12
    }, children: [
      /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 6 }, children: [
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => v(!1),
            style: {
              background: "transparent",
              border: "none",
              color: T.muted,
              cursor: "pointer",
              padding: 4,
              display: "flex",
              alignItems: "center"
            },
            "aria-label": "Back",
            children: /* @__PURE__ */ e(Po, { size: 14 })
          }
        ),
        /* @__PURE__ */ e("span", { style: { fontSize: 12, color: T.muted }, children: "Blind transfer to…" })
      ] }),
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            background: T.bg,
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            padding: "8px 10px",
            color: T.text,
            outline: "none",
            fontSize: 14,
            fontFamily: "ui-monospace, SFMono-Regular, monospace"
          },
          value: g,
          onChange: (P) => _(P.target.value),
          placeholder: "Ext or phone number",
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            u(g), v(!1), _("");
          },
          disabled: !g.trim(),
          style: {
            background: T.blue,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "8px 0",
            cursor: g.trim() ? "pointer" : "not-allowed",
            opacity: g.trim() ? 1 : 0.4,
            fontWeight: 600,
            fontSize: 13
          },
          children: "Transfer"
        }
      )
    ] }) : /* @__PURE__ */ a("div", { style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 8,
      width: "100%"
    }, children: [
      /* @__PURE__ */ e(
        wt,
        {
          label: r ? "Unmute" : "Mute",
          icon: r ? /* @__PURE__ */ e(wr, { size: 16 }) : /* @__PURE__ */ e(Xt, { size: 16 }),
          onClick: () => d(!r),
          active: r
        }
      ),
      /* @__PURE__ */ e(
        wt,
        {
          label: l ? "Resume" : "Hold",
          icon: l ? /* @__PURE__ */ e(Mr, { size: 16 }) : /* @__PURE__ */ e(_r, { size: 16 }),
          onClick: () => {
            l ? f() : c();
          },
          active: l
        }
      ),
      /* @__PURE__ */ e(
        wt,
        {
          label: "Transfer",
          icon: /* @__PURE__ */ e(Tr, { size: 16 }),
          onClick: () => v(!0)
        }
      ),
      /* @__PURE__ */ e(
        wt,
        {
          label: "Park",
          icon: /* @__PURE__ */ e(Nr, { size: 16 }),
          onClick: () => {
            k();
          }
        }
      ),
      /* @__PURE__ */ e(
        wt,
        {
          label: "Keypad",
          icon: /* @__PURE__ */ e(Cr, { size: 16 }),
          onClick: () => {
          }
        }
      ),
      /* @__PURE__ */ e(
        wt,
        {
          label: "End",
          icon: /* @__PURE__ */ e(Lo, { size: 16 }),
          onClick: () => {
            b();
          },
          tone: "danger"
        }
      )
    ] })
  ] });
}
function wt({
  label: t,
  icon: n,
  onClick: o,
  active: i,
  tone: r
}) {
  const l = r === "danger" ? T.red : i ? T.surfaceHi : T.surface, d = r === "danger" ? "#fff" : T.text;
  return /* @__PURE__ */ a(
    "button",
    {
      onClick: o,
      style: {
        background: l,
        color: d,
        border: `1px solid ${T.border}`,
        borderRadius: 10,
        padding: "10px 0",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
        fontSize: 11
      },
      children: [
        n,
        /* @__PURE__ */ e("span", { children: t })
      ]
    }
  );
}
function ya({
  phone: t,
  onCall: n
}) {
  const { recentCalls: o, loadingRecents: i, refreshRecents: r } = t;
  return /* @__PURE__ */ a("div", { style: { flex: 1, overflowY: "auto", padding: 8 }, children: [
    /* @__PURE__ */ a("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 8px 8px"
    }, children: [
      /* @__PURE__ */ e("span", { style: { fontSize: 11, color: T.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Recent" }),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            r();
          },
          style: {
            background: "transparent",
            border: "none",
            color: T.muted,
            cursor: "pointer",
            fontSize: 11,
            padding: 2
          },
          children: "Refresh"
        }
      )
    ] }),
    i && o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, padding: 20, fontSize: 12 }, children: "Loading…" }) : o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, padding: 20, fontSize: 12 }, children: "No recent calls" }) : /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column" }, children: o.map((l) => {
      const d = l.direction.startsWith("inbound"), c = d ? l.fromNumber : l.toNumber, f = l.missed ? Sr : d ? Hn : Do, u = l.missed ? T.red : d ? T.green : T.blue;
      return /* @__PURE__ */ a(
        "button",
        {
          onClick: () => c && n(c),
          style: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "transparent",
            border: "none",
            borderBottom: `1px solid ${T.border}`,
            padding: "10px 8px",
            cursor: "pointer",
            color: T.text,
            textAlign: "left"
          },
          onMouseEnter: (k) => {
            k.currentTarget.style.background = T.surface;
          },
          onMouseLeave: (k) => {
            k.currentTarget.style.background = "transparent";
          },
          children: [
            /* @__PURE__ */ e("span", { style: { color: u, display: "flex" }, children: /* @__PURE__ */ e(f, { size: 14 }) }),
            /* @__PURE__ */ a("div", { style: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ e("div", { style: {
                fontSize: 13,
                color: T.text,
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }, children: c || "Unknown" }),
              /* @__PURE__ */ a("div", { style: { fontSize: 11, color: T.muted }, children: [
                jn(l.startedAt),
                l.durationSecs != null && l.durationSecs > 0 && ` · ${Jo(l.durationSecs)}`
              ] })
            ] })
          ]
        },
        l.id
      );
    }) })
  ] });
}
function va({
  phone: t,
  initialPeer: n
}) {
  const { smsThreads: o, loadingThreads: i, refreshThreads: r, listThreadMessages: l, sendSms: d } = t, [c, f] = y(n ?? null), [u, k] = y([]), [b, S] = y(""), [v, g] = y(!1);
  return H(() => {
    c && (g(!0), l(c).then((_) => {
      k(_.reverse()), g(!1);
    }));
  }, [c, l]), c ? /* @__PURE__ */ a("div", { style: { display: "flex", flexDirection: "column", flex: 1 }, children: [
    /* @__PURE__ */ a("div", { style: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 12px",
      borderBottom: `1px solid ${T.border}`
    }, children: [
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => f(null),
          style: {
            background: "transparent",
            border: "none",
            color: T.muted,
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center"
          },
          "aria-label": "Back",
          children: /* @__PURE__ */ e(Po, { size: 14 })
        }
      ),
      /* @__PURE__ */ e("span", { style: {
        fontSize: 13,
        color: T.text,
        fontWeight: 500,
        fontFamily: "ui-monospace, SFMono-Regular, monospace"
      }, children: c })
    ] }),
    /* @__PURE__ */ e("div", { style: {
      flex: 1,
      overflowY: "auto",
      padding: 12,
      display: "flex",
      flexDirection: "column",
      gap: 6
    }, children: v ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, fontSize: 12 }, children: "Loading…" }) : u.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, fontSize: 12 }, children: "No messages" }) : u.map((_) => {
      const C = _.direction === "outbound";
      return /* @__PURE__ */ a("div", { style: {
        alignSelf: C ? "flex-end" : "flex-start",
        maxWidth: "80%",
        background: C ? T.blue : T.surface,
        color: C ? "#fff" : T.text,
        padding: "6px 10px",
        borderRadius: 12,
        fontSize: 13,
        border: C ? "none" : `1px solid ${T.border}`
      }, children: [
        _.body,
        /* @__PURE__ */ e("div", { style: {
          fontSize: 10,
          opacity: 0.7,
          marginTop: 3
        }, children: jn(_.createdAt) })
      ] }, _.id);
    }) }),
    /* @__PURE__ */ a("div", { style: {
      display: "flex",
      gap: 6,
      padding: 8,
      borderTop: `1px solid ${T.border}`
    }, children: [
      /* @__PURE__ */ e(
        "input",
        {
          style: {
            flex: 1,
            background: T.surface,
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            padding: "8px 10px",
            color: T.text,
            outline: "none",
            fontSize: 13
          },
          value: b,
          onChange: (_) => S(_.target.value),
          onKeyDown: (_) => {
            _.key === "Enter" && b.trim() && (d(c, b.trim()).then(() => l(c).then((C) => {
              k(C.reverse());
            })), S(""));
          },
          placeholder: "Type a message…",
          maxLength: 1600
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            b.trim() && (d(c, b.trim()).then(() => l(c).then((_) => {
              k(_.reverse());
            })), S(""));
          },
          disabled: !b.trim(),
          style: {
            background: T.blue,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "0 12px",
            cursor: b.trim() ? "pointer" : "not-allowed",
            opacity: b.trim() ? 1 : 0.4,
            display: "flex",
            alignItems: "center"
          },
          "aria-label": "Send",
          children: /* @__PURE__ */ e(Ar, { size: 14 })
        }
      )
    ] })
  ] }) : /* @__PURE__ */ a("div", { style: { flex: 1, overflowY: "auto", padding: 8 }, children: [
    /* @__PURE__ */ a("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 8px 8px"
    }, children: [
      /* @__PURE__ */ e("span", { style: { fontSize: 11, color: T.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Threads" }),
      /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            r();
          },
          style: {
            background: "transparent",
            border: "none",
            color: T.muted,
            cursor: "pointer",
            fontSize: 11,
            padding: 2
          },
          children: "Refresh"
        }
      )
    ] }),
    i && o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, padding: 20, fontSize: 12 }, children: "Loading…" }) : o.length === 0 ? /* @__PURE__ */ e("div", { style: { textAlign: "center", color: T.muted, padding: 20, fontSize: 12 }, children: "No SMS threads" }) : o.map((_) => /* @__PURE__ */ a(
      "button",
      {
        onClick: () => f(_.peer),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 10,
          background: "transparent",
          border: "none",
          borderBottom: `1px solid ${T.border}`,
          padding: "10px 8px",
          cursor: "pointer",
          color: T.text,
          textAlign: "left",
          width: "100%"
        },
        onMouseEnter: (C) => {
          C.currentTarget.style.background = T.surface;
        },
        onMouseLeave: (C) => {
          C.currentTarget.style.background = "transparent";
        },
        children: [
          /* @__PURE__ */ e("span", { style: { color: T.blue, display: "flex" }, children: /* @__PURE__ */ e(Wt, { size: 14 }) }),
          /* @__PURE__ */ a("div", { style: { flex: 1, minWidth: 0 }, children: [
            /* @__PURE__ */ e("div", { style: {
              fontSize: 13,
              color: T.text,
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }, children: _.peer }),
            /* @__PURE__ */ e("div", { style: {
              fontSize: 11,
              color: T.muted,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }, children: _.lastMessagePreview })
          ] }),
          /* @__PURE__ */ e("span", { style: { fontSize: 10, color: T.muted }, children: jn(_.lastMessageAt) })
        ]
      },
      _.peer
    ))
  ] });
}
function ka({
  phone: t
}) {
  const { currentCall: n, status: o, acceptCall: i, declineCall: r } = t;
  return o !== "ringing" || !n ? null : Zt(
    /* @__PURE__ */ a(
      "div",
      {
        style: {
          position: "fixed",
          top: 70,
          left: "50%",
          transform: "translateX(-50%)",
          background: T.bg,
          border: `1px solid ${T.border}`,
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
          padding: 14,
          minWidth: 320,
          color: T.text,
          zIndex: 1e5,
          display: "flex",
          flexDirection: "column",
          gap: 10,
          animation: "hb-phone-ring 1s ease-in-out infinite"
        },
        role: "dialog",
        "aria-label": "Incoming call",
        children: [
          /* @__PURE__ */ e("style", { children: `
        @keyframes hb-phone-ring {
          0%, 100% { box-shadow: 0 10px 30px rgba(0,0,0,0.5), 0 0 0 0 rgba(34,197,94,0.4); }
          50% { box-shadow: 0 10px 30px rgba(0,0,0,0.5), 0 0 0 8px rgba(34,197,94,0); }
        }
      ` }),
          /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
            /* @__PURE__ */ e("div", { style: {
              width: 36,
              height: 36,
              borderRadius: "50%",
              background: T.green,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }, children: /* @__PURE__ */ e(Hn, { size: 18, color: "#fff" }) }),
            /* @__PURE__ */ a("div", { style: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ e("div", { style: { fontSize: 11, color: T.muted, textTransform: "uppercase", letterSpacing: 1 }, children: "Incoming call" }),
              /* @__PURE__ */ e("div", { style: {
                fontSize: 15,
                fontWeight: 600,
                color: T.text,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }, children: n.callerName || n.from || "Unknown" })
            ] })
          ] }),
          /* @__PURE__ */ a("div", { style: { display: "flex", gap: 8 }, children: [
            /* @__PURE__ */ a(
              "button",
              {
                onClick: () => {
                  r();
                },
                style: {
                  flex: 1,
                  background: T.red,
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 0",
                  cursor: "pointer",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6
                },
                children: [
                  /* @__PURE__ */ e(Lo, { size: 14 }),
                  " Decline"
                ]
              }
            ),
            /* @__PURE__ */ a(
              "button",
              {
                onClick: () => {
                  i();
                },
                style: {
                  flex: 1,
                  background: T.green,
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 0",
                  cursor: "pointer",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6
                },
                children: [
                  /* @__PURE__ */ e(ft, { size: 14 }),
                  " Accept"
                ]
              }
            )
          ] })
        ]
      }
    ),
    document.body
  );
}
function wa({
  phone: t,
  onClose: n
}) {
  const [o, i] = y("dialpad"), [r, l] = y(""), [d, c] = y(void 0), f = K(null);
  H(() => {
    const S = (g) => {
      f.current && !f.current.contains(g.target) && n();
    }, v = setTimeout(() => document.addEventListener("mousedown", S), 0);
    return () => {
      clearTimeout(v), document.removeEventListener("mousedown", S);
    };
  }, [n]), H(() => {
    const S = (v) => {
      v.key === "Escape" && n();
    };
    return document.addEventListener("keydown", S), () => document.removeEventListener("keydown", S);
  }, [n]);
  const u = (S) => {
    t.makeCall(S);
  }, k = (S) => {
    c(S), i("sms");
  }, b = t.status === "active" || t.status === "held" || t.status === "transferred";
  return Zt(
    /* @__PURE__ */ a(
      "div",
      {
        ref: f,
        style: {
          position: "fixed",
          top: 60,
          right: 12,
          width: 320,
          height: 480,
          background: T.bg,
          border: `1px solid ${T.border}`,
          borderRadius: 12,
          boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
          color: T.text,
          zIndex: 99999,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        role: "dialog",
        "aria-label": "Softphone",
        children: [
          /* @__PURE__ */ a("div", { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: `1px solid ${T.border}`
          }, children: [
            /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ e(ft, { size: 14 }),
              /* @__PURE__ */ e("span", { style: { fontSize: 13, fontWeight: 600 }, children: "Phone" })
            ] }),
            /* @__PURE__ */ e(
              "button",
              {
                onClick: n,
                style: {
                  background: "transparent",
                  border: "none",
                  color: T.muted,
                  cursor: "pointer",
                  padding: 4,
                  display: "flex"
                },
                "aria-label": "Close",
                children: /* @__PURE__ */ e(We, { size: 14 })
              }
            )
          ] }),
          t.error && /* @__PURE__ */ a("div", { style: {
            background: "rgba(239,68,68,0.1)",
            borderBottom: `1px solid ${T.red}`,
            padding: "6px 12px",
            fontSize: 12,
            color: "#fca5a5",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 6
          }, children: [
            /* @__PURE__ */ e("span", { style: { flex: 1 }, children: t.error }),
            /* @__PURE__ */ e(
              "button",
              {
                onClick: t.clearError,
                style: {
                  background: "transparent",
                  border: "none",
                  color: "#fca5a5",
                  cursor: "pointer",
                  padding: 2,
                  display: "flex"
                },
                "aria-label": "Dismiss error",
                children: /* @__PURE__ */ e(We, { size: 12 })
              }
            )
          ] }),
          !b && /* @__PURE__ */ e("div", { style: {
            display: "flex",
            borderBottom: `1px solid ${T.border}`
          }, children: ["dialpad", "recent", "sms"].map((S) => /* @__PURE__ */ e(
            "button",
            {
              onClick: () => i(S),
              style: {
                flex: 1,
                background: "transparent",
                border: "none",
                color: o === S ? T.text : T.muted,
                borderBottom: `2px solid ${o === S ? T.blue : "transparent"}`,
                padding: "8px 0",
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                textTransform: "capitalize"
              },
              children: S
            },
            S
          )) }),
          b ? /* @__PURE__ */ e(xa, { phone: t }) : o === "dialpad" ? /* @__PURE__ */ e(ga, { value: r, onChange: l, onCall: u, onSms: k }) : o === "recent" ? /* @__PURE__ */ e(ya, { phone: t, onCall: (S) => {
            l(S), i("dialpad"), t.makeCall(S);
          } }) : /* @__PURE__ */ e(va, { phone: t, initialPeer: d })
        ]
      }
    ),
    document.body
  );
}
function Sa(t) {
  return /* @__PURE__ */ e(fa, { children: /* @__PURE__ */ e(Ta, { ...t }) });
}
function Ta({ session: t, apiBase: n }) {
  const o = St(() => ba(t), [t]), [i, r] = y(!1), l = ua({
    apiBase: n,
    orgId: o && t.tenantId || null
  });
  if (H(() => {
    l.status === "active" && r(!0);
  }, [l.status]), !o) return null;
  const d = l.status === "active" || l.status === "held", c = l.status === "ringing";
  return /* @__PURE__ */ a(ue, { children: [
    /* @__PURE__ */ e("div", { style: { position: "relative", flexShrink: 0 }, children: /* @__PURE__ */ a(
      "button",
      {
        onClick: () => r((f) => !f),
        "aria-label": "Softphone",
        "aria-expanded": i,
        title: "Softphone",
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 36,
          height: 36,
          background: "transparent",
          border: "none",
          borderRadius: 8,
          cursor: "pointer",
          color: c ? T.red : d ? T.green : "#94a3b8",
          transition: "background 0.15s, color 0.15s",
          position: "relative"
        },
        onMouseEnter: (f) => {
          f.currentTarget.style.background = "rgba(255,255,255,0.04)";
        },
        onMouseLeave: (f) => {
          f.currentTarget.style.background = "transparent";
        },
        children: [
          /* @__PURE__ */ e(ft, { size: 18 }),
          c && /* @__PURE__ */ a(ue, { children: [
            /* @__PURE__ */ e("style", { children: `
                @keyframes hb-phone-badge-pulse {
                  0%, 100% { transform: scale(1); opacity: 1; }
                  50% { transform: scale(1.2); opacity: 0.75; }
                }
              ` }),
            /* @__PURE__ */ e(
              "span",
              {
                "aria-hidden": "true",
                style: {
                  position: "absolute",
                  top: 6,
                  right: 6,
                  width: 8,
                  height: 8,
                  background: T.red,
                  borderRadius: "50%",
                  animation: "hb-phone-badge-pulse 1s ease-in-out infinite"
                }
              }
            )
          ] }),
          !c && d && /* @__PURE__ */ e(
            "span",
            {
              "aria-hidden": "true",
              style: {
                position: "absolute",
                top: 6,
                right: 6,
                width: 8,
                height: 8,
                background: T.green,
                borderRadius: "50%"
              }
            }
          )
        ]
      }
    ) }),
    i && /* @__PURE__ */ e(wa, { phone: l, onClose: () => r(!1) }),
    /* @__PURE__ */ e(ka, { phone: l })
  ] });
}
function _a() {
  return /* @__PURE__ */ e(
    "svg",
    {
      className: "hb-logo-bird",
      width: "24",
      height: "24",
      viewBox: "0 0 1200 1200",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      children: /* @__PURE__ */ e("g", { transform: "scale(13.5) translate(-5.5555488798353405, -5.55552503797743)", children: /* @__PURE__ */ e("g", { fill: "#f97316", children: /* @__PURE__ */ e("g", { transform: "translate(0,-952.36218)", children: /* @__PURE__ */ e("path", { d: "m 60.7828,964.36215 27.1809,0.8834 -27.1809,25.9958 z m -1.9745,1.4513 0,26.7845 -25.2681,0 c 8.6166,-8.7334 16.8796,-17.8103 25.2681,-26.7845 z m 27.7053,3.628 3.4864,1.1989 -12.5877,7.4768 z m -68.1835,2.9656 5.5226,0 12.8654,14.0705 -5.9854,6.1204 -12.4026,0 c 9e-4,-6.7347 0,-13.4597 0,-20.1909 z m -1.9746,1.2304 0,5.8364 -6.3555,0 z m 3.363,20.9796 38.627,0 -10.7675,29.43465 z m 39.0898,4.54286 0,41.20229 -12.5878,-6.8775 c 4.1972,-11.443 8.3886,-22.879 12.5878,-34.32479 z" }) }) }) })
    }
  );
}
function za({
  currentProduct: t,
  currentAppName: n,
  apiBase: o,
  signalrEndpoint: i,
  session: r,
  onLogout: l,
  hubUrl: d = _t,
  chatSlot: c,
  supportConfig: f,
  orgBranding: u,
  vertical: k,
  theoEntityContext: b
}) {
  const S = ir(r, o), v = K(!1);
  if (H(() => {
    if (v.current || (v.current = !0, document.getElementById("hb-styles"))) return;
    const _ = document.createElement("style");
    _.id = "hb-styles", _.textContent = tr, document.head.appendChild(_);
  }, []), H(() => {
    const _ = document.body.style.paddingTop;
    return document.body.style.paddingTop = `${er}px`, () => {
      document.body.style.paddingTop = _;
    };
  }, []), !S)
    return /* @__PURE__ */ e("div", { className: "hb-root", role: "banner", children: /* @__PURE__ */ e("div", { className: "hb-bar hb-bar--guest", "aria-hidden": "true" }) });
  const g = k ?? S.vertical;
  return Qo(S) ? /* @__PURE__ */ e(
    Ma,
    {
      currentProduct: t,
      apiBase: o,
      session: S,
      onLogout: l,
      hubUrl: d,
      orgBranding: u,
      vertical: g
    }
  ) : /* @__PURE__ */ e(
    Ca,
    {
      currentProduct: t,
      currentAppName: n,
      apiBase: o,
      signalrEndpoint: i,
      session: S,
      onLogout: l,
      hubUrl: d,
      chatSlot: c,
      supportConfig: f,
      orgBranding: u,
      vertical: g,
      theoEntityContext: b
    }
  );
}
function Ma({
  currentProduct: t,
  apiBase: n,
  session: o,
  onLogout: i,
  hubUrl: r = _t,
  orgBranding: l,
  vertical: d
}) {
  var _;
  const { products: c } = Oo(n, o.tenantId ?? null, o.isPlatformOwner), [f, u] = y(!1), [k, b] = y(!1), [S, v] = y(!1), g = c.filter(
    (C) => {
      var R;
      return ((R = o.entitlements) == null ? void 0 : R.includes(C.id)) || C.active;
    }
  );
  return /* @__PURE__ */ a("div", { className: "hb-root", role: "banner", children: [
    /* @__PURE__ */ e(
      da,
      {
        open: k,
        onClose: () => b(!1),
        apiBase: n,
        tenantId: o.tenantId ?? null,
        session: { userId: o.userId, email: o.email, firstName: o.firstName }
      }
    ),
    /* @__PURE__ */ a(
      "div",
      {
        className: "hb-bar hb-bar--portal",
        style: (_ = l == null ? void 0 : l.colors) != null && _.header_bg ? {
          background: l.colors.header_bg,
          color: l.colors.header_text || "#f1f5f9"
        } : void 0,
        children: [
          g.length > 0 && /* @__PURE__ */ e(
            Ho,
            {
              currentProduct: t,
              products: g,
              open: f,
              onToggle: () => {
                v(!1), u((C) => !C);
              },
              onClose: () => u(!1),
              hubUrl: r,
              apiBase: n,
              vertical: d
            }
          ),
          /* @__PURE__ */ e(
            "a",
            {
              href: `${r}/portal`,
              className: "hb-logo",
              "aria-label": (l == null ? void 0 : l.company_name) ?? "Customer Portal",
              children: l != null && l.logo_icon_url || l != null && l.logo_url ? /* @__PURE__ */ e(
                "img",
                {
                  src: l.logo_icon_url || l.logo_url,
                  alt: l.company_name || "Logo",
                  style: { height: "22px", maxWidth: "120px", objectFit: "contain" }
                }
              ) : /* @__PURE__ */ e("span", { style: { fontSize: "13px", fontWeight: "600", color: "#f1f5f9" }, children: (l == null ? void 0 : l.company_name) ?? o.tenantName })
            }
          ),
          /* @__PURE__ */ e("div", { className: "hb-spacer" }),
          /* @__PURE__ */ e(pa, { open: k, onToggle: () => b((C) => !C) }),
          /* @__PURE__ */ e(
            $o,
            {
              session: o,
              open: S,
              onToggle: () => {
                u(!1), v((C) => !C);
              },
              onClose: () => v(!1),
              onLogout: i,
              hubUrl: r
            }
          )
        ]
      }
    )
  ] });
}
function Ca({
  currentProduct: t,
  currentAppName: n,
  apiBase: o,
  signalrEndpoint: i,
  session: r,
  onLogout: l,
  hubUrl: d = _t,
  chatSlot: c,
  supportConfig: f,
  orgBranding: u,
  vertical: k,
  theoEntityContext: b
}) {
  var Ae;
  const v = !!(r.orgType === "msp" || !r.orgType && (r.vertical === "msp" || r.vertical === void 0) || r.isPlatformOwner), { products: g } = Oo(o, r.tenantId ?? null, r.isPlatformOwner), { notifications: _, unreadCount: C, markAllRead: R, markRead: P, dismiss: w, muted: p, muteUntil: A, unmute: G, toastQueue: M, dismissToast: L } = lr(
    o,
    i,
    r.tenantId ?? null,
    r.userId ?? null
  ), { insights: W } = dr(o, r.tenantId ?? null), { orgs: F, switchOrg: q } = pr(o, r.userId ?? null), [j, X] = y(!1), [I, J] = y(!1), [ie, oe] = y(!1), [le, te] = y(!1), [re, B] = y(!1);
  return H(() => {
    function $(fe) {
      (fe.metaKey || fe.ctrlKey) && fe.key === "/" && (fe.preventDefault(), B((ae) => !ae)), fe.key === "Escape" && B(!1);
    }
    return window.addEventListener("keydown", $), () => window.removeEventListener("keydown", $);
  }, []), H(() => {
    function $() {
      B(!0);
    }
    return window.addEventListener("theo:open", $), () => window.removeEventListener("theo:open", $);
  }, []), /* @__PURE__ */ a("div", { className: "hb-root", role: "banner", children: [
    /* @__PURE__ */ e(
      ra,
      {
        open: re,
        onClose: () => B(!1),
        apiBase: o,
        currentProduct: t,
        tenantId: r.tenantId ?? null,
        activeProducts: g.filter(($) => ($.launch_status === "ga" || $.launch_status === "beta_invite") && ($.active || $.has_beta_access)).map(($) => $.id),
        entityContext: b ?? null
      }
    ),
    /* @__PURE__ */ e(Fr, { toasts: M, onDismiss: L }),
    /* @__PURE__ */ a(
      "div",
      {
        className: "hb-bar",
        style: (Ae = u == null ? void 0 : u.colors) != null && Ae.header_bg ? {
          background: u.colors.header_bg,
          color: u.colors.header_text || "#f1f5f9"
        } : void 0,
        children: [
          /* @__PURE__ */ e(
            Ho,
            {
              currentProduct: t,
              products: g,
              open: j,
              onToggle: () => {
                J(!1), te(!1), X(($) => !$);
              },
              onClose: () => X(!1),
              hubUrl: d,
              apiBase: o,
              vertical: k,
              showClientProducts: v
            }
          ),
          /* @__PURE__ */ a("a", { href: d, className: "hb-logo", "aria-label": u != null && u.company_name ? `${u.company_name} — Home` : "The One Stack — Home", children: [
            u != null && u.logo_icon_url || u != null && u.logo_url ? /* @__PURE__ */ e(
              "img",
              {
                src: u.logo_icon_url || u.logo_url,
                alt: u.company_name || "Logo",
                style: { height: 22, width: "auto", objectFit: "contain" }
              }
            ) : /* @__PURE__ */ e(_a, {}),
            /* @__PURE__ */ e("span", { className: "hb-logo-name", children: (u == null ? void 0 : u.company_name) || "The One" })
          ] }),
          /* @__PURE__ */ e("div", { className: "hb-divider", "aria-hidden": "true" }),
          (() => {
            if (n)
              return /* @__PURE__ */ e("span", { style: { fontSize: 14, fontWeight: 500, color: "#94a3b8", whiteSpace: "nowrap" }, children: n });
            const $ = g.find((fe) => fe.id === t);
            return $ ? /* @__PURE__ */ e("span", { style: { fontSize: 14, fontWeight: 500, color: "#f1f5f9", whiteSpace: "nowrap" }, children: $.name }) : null;
          })(),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          /* @__PURE__ */ e(Pr, { apiBase: o, tenantId: (r == null ? void 0 : r.tenantId) ?? null }),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          /* @__PURE__ */ e(ia, { products: g, hubUrl: d }),
          f ? /* @__PURE__ */ e(
            Vr,
            {
              config: f,
              currentProduct: t,
              hubUrl: d,
              user: {
                email: (r == null ? void 0 : r.email) ?? "",
                name: r ? `${r.firstName ?? ""} ${r.lastName ?? ""}`.trim() || r.email : ""
              }
            }
          ) : c ?? null,
          /* @__PURE__ */ e(
            la,
            {
              apiBase: o,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              currentProduct: t
            }
          ),
          /* @__PURE__ */ e(
            zi,
            {
              apiBase: o,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              currentProduct: t,
              entitlements: r.entitlements
            }
          ),
          /* @__PURE__ */ e(
            $i,
            {
              apiBase: o,
              tenantId: r.tenantId ?? null,
              userId: r.userId ?? null,
              hubUrl: d,
              open: ie,
              onToggle: () => {
                X(!1), J(!1), te(!1), oe(($) => !$);
              },
              onClose: () => oe(!1)
            }
          ),
          /* @__PURE__ */ e(Sa, { session: r, apiBase: o }),
          /* @__PURE__ */ e(
            Ur,
            {
              notifications: _,
              unreadCount: C,
              open: I,
              onToggle: () => {
                X(!1), te(!1), J(($) => !$);
              },
              onClose: () => J(!1),
              onMarkAllRead: R,
              onMarkRead: P,
              onDismiss: w,
              muted: p,
              onMute: A,
              onUnmute: G,
              hubUrl: d,
              sentinelInsights: W
            }
          ),
          r.tenantName && /* @__PURE__ */ e(
            "button",
            {
              className: "hb-org-chip",
              onClick: () => {
                X(!1), J(!1), te(($) => !$);
              },
              title: `Current org: ${r.tenantName}`,
              children: r.tenantName
            }
          ),
          /* @__PURE__ */ e(
            $o,
            {
              session: r,
              open: le,
              onToggle: () => {
                X(!1), J(!1), te(($) => !$);
              },
              onClose: () => te(!1),
              onLogout: l,
              hubUrl: d,
              orgs: F,
              onSwitchOrg: q
            }
          )
        ]
      }
    )
  ] });
}
export {
  Zo as A,
  la as G,
  er as H,
  zi as J,
  pa as M,
  Ur as N,
  Sa as P,
  On as S,
  Pr as U,
  nt as a,
  _t as b,
  za as c,
  da as d,
  Fr as e,
  Ho as f,
  Vr as g,
  $o as h,
  Qo as i,
  ki as j,
  lr as k,
  ua as l,
  Oo as m,
  Lr as n,
  nr as r,
  ir as u
};
